/* ============================================================
   Minnely-designern
   Fullskärmseditor: ladda upp teckning (bakgrunden tas bort via
   PhotoRoom + lokal pappersborttagning), lägg bilder och texter som
   lager på produktens riktiga mockup i vald färg, dra/skala/rotera,
   fram/rygg, färg, storlek och antal – flera bilder, spegla, dubblera,
   lagerordning, kontur på text – och exportera EN tryckfil som täcker
   hela tryckytan (layout x 0.5 / y 0.5 / s 1) till Printify-flödet.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('mn-designer');
  if (!root) return;
  /* produktdata läses innan elementet flyttas ut ur sektionen */
  var PRODUCT = null, options = [];
  try { PRODUCT = JSON.parse(root.querySelector('[data-mnd-product]').textContent); } catch (e) { PRODUCT = null; }
  try { options = JSON.parse(root.querySelector('[data-mnd-options-json]').textContent) || []; } catch (e) { options = []; }
  /* flytta ut ur sektionen så att inga stacking contexts (mn-sheet, animationer) stör */
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var PROXY_URL = root.dataset.proxyUrl || '';
  var AI_LJUS = root.dataset.aiLjus === 'true';   /* temainställning: AI-ljus vid borttagning, 5 Photoroom-bilder i stället för 1 */
  var SAVE_URL = PROXY_URL ? PROXY_URL.replace('fixa-teckning', 'spara-teckning') : '';
  var CLIENT_UPLOAD_URL = PROXY_URL ? PROXY_URL.replace('fixa-teckning', 'ladda-upp') : '';
  var KIND = root.dataset.kind || 'tshirt';
  var placement = 'front';
  var EXTRA_VARIANT = root.dataset.extraVariant || null;      /* tilläggsprodukten "Extra tryck – rygg" */
  var EXTRA_PRIS = Number(root.dataset.extraPris || 0);
  var MALLTEXT_VARIANT = root.dataset.malltextVariant || null;  /* tillägget "Egen text på mall" (variant på Extra tryck) */
  var MALLTEXT_PRIS = Number(root.dataset.malltextPris || 0);
  var KATEGORI = root.dataset.kategori || '';
  var ENGRAVE = root.dataset.gravyr === '1';          /* graveras (laser): förhandsvisning och tryckfil i gråskala */
  var BRODYR = root.dataset.brodyr === '1';           /* broderas: bara text */
  /* färdiga produkter (admin-vyns tryck): trycket ligger låst på plagget, kunden lägger till runt om */
  var FARDIG = []; try { FARDIG = JSON.parse(root.dataset.fardig || '[]') || []; } catch (e) { FARDIG = []; }
  /* Kundtexter som butiken byter i temaredigeraren (settings_schema.json → mn_layer_*).
     Liquid lägger dem som data-attribut på roten; tomt attribut = standardtexten här. */
  var TXT_GEAR = root.dataset.txtSettings || 'Ändra';
  var TXT_BG_OFF = root.dataset.txtBgOff || 'Ta bort bakgrunden';
  var TXT_BG_ON = root.dataset.txtBgOn || 'Bakgrunden borttagen';
  /* lägesväljaren nederst på scenen och bildtexten ovanför den (mn_designer_mode_* och mn_designer_tap_note) */
  var TXT_MODE_REAL = root.dataset.txtModeReal || 'På produkten';
  var TXT_MODE_FLAT = root.dataset.txtModeFlat || 'Hela trycket';
  var TXT_TAP_NOTE = root.dataset.txtTapNote || 'Tryck på produkten för att flytta bilden';
  /* köpknappen innan det finns en bild, storleken innan kunden valt den, sparandet vid stängning och
     varningen för små bilder (mn_designer_cta_empty, _size_prompt, _saving_label, _lowres_note) */
  var TXT_CTA_EMPTY = root.dataset.txtCtaEmpty || 'Ladda upp en bild';
  var TXT_SIZE_PROMPT = root.dataset.txtSizePrompt || 'Välj storlek';
  var TXT_SAVING = root.dataset.txtSaving || 'Sparar din design';
  var TXT_LOWRES = root.dataset.txtLowres || 'Bilden är liten och kan bli suddig i tryck. Välj gärna en större bild om du har en.';
  /* förhandsvisningen (mn_designer_fv_*); [produkt] i rubriken byts mot produktens namn */
  var TXT_FV_RUBRIK = root.dataset.txtFvRubrik || 'Så blir din [produkt]';
  var TXT_FV_TILLBAKA = root.dataset.txtFvTillbaka || 'Tillbaka till designen';
  var TXT_FV_LADDAR = root.dataset.txtFvLaddar || 'Förbereder förhandsvisningen';
  var TXT_FV_FEL = root.dataset.txtFvFel || 'Förhandsvisningen gick inte att visa just nu. Din design är sparad och går att lägga i varukorgen ändå.';
  /* en bild vars längsta sida är kortare än så varnas för: på en tröjas framsida blir den under 100 dpi */
  var LOWRES_SIDE = 1200;
  var MAX_SIDE = 3600, MAX_PIXELS = 12e6, RELIGHT_MAX = 3500, TARGET_SIDE = 3600, MAX_UPSCALE = 4;
  var MAX_UPLOAD_BYTES = 4.2 * 1024 * 1024; /* Vercel-funktionens kroppsgräns */
  var PRINT_MAX_SIDE = 4200;                /* tryckfilens längsta sida */
  var R_W = 1000;                           /* referensbredd för lagerkoordinater (px i tryckytan) */
  var BAND = 0.55, THETA = 1.0;             /* muggens synliga band och vinkel */

  var TY = null;
  try { TY = root.dataset.tryckyta ? JSON.parse(root.dataset.tryckyta) : null; } catch (e) { TY = null; }
  if (TY && !TY.front && !TY.ytor) TY = null;
  /* UV-läge: kalibrerade kartor (kalibrera-uv.py) säger exakt vilken punkt i tryckfilen som syns i
     varje mockup-pixel – platt, cylinder, paraply, kudde, ryggsäckens sidor. Gravyr/broderi ritas som förut. */
  var UV = !!(TY && TY.ytor && TY.vyer && TY.filer && !ENGRAVE);
  /* Former: när ett alternativ byter själva produkten (gosedjurets Kanin, Elefant, Får, Björn) sitter
     tröjan på olika ställe på varje bild. Metafältet har då bilder och kartor per värde (kalibrera-former.py),
     och de byts in när kunden väljer. Utan värde för formen gäller produktens egna. */
  var FORMER = UV && TY.former && TY.former.varden ? TY.former : null;
  var TY_BAS = TY ? { bilder: TY.bilder, vyer: TY.vyer } : null, aktivForm = null;
  function tillampaForm() {
    if (!FORMER) return false;
    var val = currentFormValue(FORMER.alternativ), f = (val && FORMER.varden[val]) || null;
    var nyckel = f ? val : '';
    if (nyckel === aktivForm) return false;
    aktivForm = nyckel;
    TY.bilder = f && f.bilder ? { '': f.bilder } : TY_BAS.bilder;
    TY.vyer = f && f.vyer ? f.vyer : TY_BAS.vyer;
    /* bara de vyer formen har bild och karta för (sidovyn finns bara för en form) */
    Object.keys(TY.ytor).forEach(function (sid) {
      var y = TY.ytor[sid];
      if (!y._vyer) { y._vyer = y.vyer || [y.vy]; y._vy = y.vy; }
      y.vyer = y._vyer.filter(function (v) { return TY.vyer[v]; });
      if (!y.vyer.length) y.vyer = [y._vy];
      y.vy = y.vyer.indexOf(y._vy) >= 0 ? y._vy : y.vyer[0];
      if (realView[sid] && y.vyer.indexOf(realView[sid]) < 0) delete realView[sid];
    });
    viewMapsReady = {}; gridCache = {};
    return true;
  }
  /* designytor: id → { grupp (tryckfil), del [x0,y0,x1,y1] av filen, namn, vy (kamera), vyer } */
  var SURF = UV ? Object.keys(TY.ytor) : (TY && TY.back ? ['front', 'back'] : ['front']);
  if (UV) {
    /* Fram först, sedan Rygg/Bak, sedan övriga i tryckeriets ordning */
    var rank = function (id) { var g = TY.ytor[id].grupp; return g === 'front' || g === 'front_dtf' ? 0 : g === 'back' ? 1 : 2; };
    SURF = SURF.map(function (id, i) { return [id, i]; }).sort(function (a, b) { return rank(a[0]) - rank(b[0]) || a[1] - b[1]; }).map(function (x) { return x[0]; });
  }
  var VIEW_NAMES = { front: '', back: 'baksida', left: 'vänster sida', right: 'höger sida', top: 'ovansida', side: 'sidan', bottom: 'undersida', 'front-and-side': 'fram och sida', 'front-vertical': 'stående', 'front-horizontal': 'liggande', 'left-and-right-slipper': 'båda tofflorna', 'person-5-left-sleeve': 'vänster ärm', 'person-5-right-sleeve': 'höger ärm', both: 'båda' };
  function surf(id) { return UV ? TY.ytor[id || placement] : null; }
  function surfName(id) { var y = surf(id); return y ? y.namn : (id === 'back' ? (KIND === 'tshirt' ? 'Rygg' : 'Bak') : 'Fram'); }
  function surfacesOf(grupp) { return SURF.filter(function (id) { return TY.ytor[id].grupp === grupp; }); }

  var q = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  var canvas = q('[data-mnd-canvas]');
  var ctx = canvas.getContext('2d');
  var stage = q('[data-mnd-stage]');
  var fileInput = q('[data-mnd-file]');

  /* ---------- Produktdata: alternativ, varianter, färger ---------- */

  var COLOR_HEX = {
    'Mintblå': '#a7c7b9', 'Ljusgrön': '#a6d68f', 'Gul': '#f2d230', 'Mörkblå': '#1f3a6b', 'Petrol': '#1f5560', 'Grön': '#2f6b45', 'Svart kamouflage': 'linear-gradient(135deg,#2a2a2a 0 30%,#4a4a42 30% 55%,#1f1f1f 55% 80%,#3d3d36 80%)', 'Ljusgrå melerad': '#c8c8c6', 'Senapsgul': '#c9a227', 'Svart ram': '#1f1f1f', 'Träram': '#c8a27a', 'Vit ram': '#ffffff',
    'Vit': '#ffffff', 'Arktisk vit': '#f7f7f5', 'Naturvit': '#efe8d8', 'Svart': '#1f1f1f', 'Kolsvart': '#111111',
    'Marinblå': '#1f2a44', 'Mörk marinblå': '#172238', 'Oxford-marinblå': '#1c2a4a', 'Röd': '#c8322f', 'Eldröd': '#d3262c',
    'Kardinalröd': '#a8232b', 'Vinröd': '#7a1f2e', 'Tranbärsröd': '#8b2a3a', 'Kungsblå': '#2b5fc7', 'Ljusblå': '#9cc4e4',
    'Himmelsblå': '#8ec5f0', 'Carolinablå': '#7bb7de', 'Lila': '#6b3fa0', 'Rosa': '#f2a7c3', 'Ljusrosa': '#f6c9d6',
    'Babyrosa': '#f7cdd8', 'Cerise': '#d63384', 'Kolgrå': '#4a4a4a', 'Mörk gråmelerad': '#4c4c50', 'Gråmelerad': '#a9a9ad',
    'Sportgrå': '#b8b8ba', 'Askgrå': '#cfcfcf', 'Grå': '#8f8f92', 'Mörkgrå': '#5a5a5e', 'Mörk choklad': '#4b2e22',
    'Brun': '#6b4a35', 'Mörkbrun': '#4a3325', 'Ljusbrun': '#a67c5a', 'Irländsk grön': '#2f8f4e', 'Skogsgrön': '#1f5a3a',
    'Flaskgrön': '#1d4d3a', 'Militärgrön': '#5b6b3c', 'Mörkgrön': '#204a2f', 'Kiwigrön': '#8bc34a', 'Oliv': '#6b6b3a',
    'Grangrön': '#2f5a4a', 'Orange': '#ea7a2a', 'Guld': '#d4a72c', 'Solgul': '#f2c14e', 'Sand': '#d9c5a3', 'Beige': '#d8c7ad',
    'Khaki': '#b7a57a', 'Stengrå': '#a8a29a', 'Sandbrun': '#c9a67c', 'Silver': '#c0c0c4', 'Guldpläterad': '#d4a72c',
    'Rostfritt stål': '#b9bcc0', 'Rostfritt stål (obelagt)': '#b9bcc0', 'Guld (18K PVD)': '#d4a72c', 'Roséguld (18K PVD)': '#d8a09a',
    'Svart (PVD)': '#2a2a2a', 'Regnbåge (PVD)': 'linear-gradient(135deg,#f6c14e,#e9698f,#6aa7e6)', 'Regnbåge': 'linear-gradient(135deg,#f6c14e,#e9698f,#6aa7e6)',
    /* samma som snippets/mn-farg-hex.liquid */
    'Candyfloss Pink': '#f6b5cf', 'Vit dragkedja': '#ffffff', 'Svart dragkedja': 'linear-gradient(180deg,#1f1f1f 0 34%,#ffffff 34%)',
    'Svart/guld': 'linear-gradient(135deg,#1f1f1f 50%,#c9a24a 50%)', 'Svart/silver': 'linear-gradient(135deg,#1f1f1f 50%,#c4c4c4 50%)',
    'Rustik/guld': 'linear-gradient(135deg,#6f4a2e 50%,#c9a24a 50%)'
  };
  /* färger som inte finns ovan (nya produkter): produktjobbet sparar Printifys färgkoder i butikens metafält */
  try { var reservFarger = JSON.parse(root.dataset.farger || 'null') || {}; Object.keys(reservFarger).forEach(function (k) { if (!COLOR_HEX[k] && /^#[0-9a-f]{3,8}$/i.test(reservFarger[k])) COLOR_HEX[k] = reservFarger[k]; }); } catch (e) { /* inget metafält än */ }

  var colorOpt = options.find(function (o) { return o.name === 'Färg'; }) || null;
  var colorIndex = colorOpt ? colorOpt.position - 1 : -1;
  /* Storleken är förvald (första varianten, ofta XS) och en mormor som köper till ett sexåring märker det
     inte. Designerns köpknapp kräver därför att kunden själv valt storlek, i designern eller på sidan.
     En länk med ?variant= (annons, delad länk) eller en rad som ändras från varukorgen räknas som vald. */
  var sizeOpt = options.find(function (o) { return o.name === 'Storlek' && o.values.length > 1; }) || null;
  var sizePicked = !sizeOpt || /[?&]variant=/.test(window.location.search);
  function needsSize() { return !sizePicked && surfacesWithContent().length > 0; }
  /* storlekar i storleksordning: produkten kan ha dem i den ordning varianterna skapades (XS, M, L, XL, S) */
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
  function sortedValues(o) {
    var vals = o.values.slice();
    if (!vals.every(function (v) { return SIZE_ORDER.indexOf(v) >= 0; })) return vals;
    return vals.sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); });
  }

  function optionSelect(name) { return document.querySelector('select[name="options[' + name + ']"]'); }
  function formOptionInput(name, value) {
    return document.querySelector('input[type="radio"][data-option-name="' + name + '"][value="' + CSS.escape(value) + '"]');
  }
  function currentFormValue(name) {
    var inp = document.querySelector('input[type="radio"][data-option-name="' + name + '"]:checked');
    if (inp) return inp.value;
    var sel = optionSelect(name);
    return sel ? sel.value : null;
  }
  function selectedValues() { return options.map(function (o) { return currentFormValue(o.name); }); }
  function currentVariant() {
    if (!PRODUCT) return null;
    var vals = selectedValues();
    return PRODUCT.variants.find(function (v) { return v.options.every(function (x, i) { return vals[i] == null || x === vals[i]; }); }) || null;
  }
  function money(cents) { return Math.round(cents / 100).toLocaleString('sv-SE') + ' kr'; }

  /* ---------- Tryckyta & mockup ---------- */

  placement = 'front';
  var mockCache = {};

  function viewImage(view) {
    var color = colorIndex >= 0 ? currentFormValue('Färg') : '';
    var b = TY.bilder || {}, keys = Object.keys(b);
    var set = b[color] || b[''] || (keys.length ? b[keys[0]] : null) || {};
    var first = keys.length ? b[keys[0]] : {};
    return set[view] || first[view] || set.front || first.front || root.dataset.mainImage;
  }
  /* Redigeringsläge per yta: 'real' = produktvyn ("På produkten", kundens bild på den kalibrerade mockupen)
     eller 'flat' = hela tryckytan platt ("Hela tryckytan", som Printifys/Gelatos editorer). Designern öppnar
     på produkten när ytans huvudvy har en karta: den platta tryckfilen är en vit fyrkant på en tröja och en
     grå remsa på en mugg, och den som inte är van ser inte att det är produkten. Vyer som är speglade, vridna,
     kraftigt kupade eller bara visar en del av ytan (mugg, flaska, väska) går inte att redigera i. Där tar ett
     tryck på scenen kunden till hela tryckytan (se pointerdown). Standardläget räknas ur produktens metadata,
     aldrig ur kartorna som laddas asynkront, så läget kan inte hoppa medan de laddar. Ett läge kunden valt
     med knapparna står kvar: modeOf skriver bara när ytan saknar läge. */
  var modes = {}, realView = {};
  function kartaFor(sid, view) { var y = TY.ytor[sid]; return ((TY.vyer[view || y.vy] || {}).kartor || {})[y.grupp] || null; }
  function defaultMode(sid) { return kartaFor(sid) ? 'real' : 'flat'; }
  function modeOf(sid) { if (!modes[sid]) modes[sid] = defaultMode(sid); return modes[sid]; }
  function viewOf(sid) {
    if (realView[sid]) return realView[sid];
    var y = TY.ytor[sid];
    /* ärmarna: Printifys sidovy (ärmen hänger rakt, hela ytan syns) om den är kalibrerad, annars framifrån */
    if (/sleeve/.test(String(sid))) {
      var sida = /left/.test(String(sid)) ? 'person-5-left-sleeve' : 'person-5-right-sleeve';
      if ((y.vyer || []).indexOf(sida) >= 0 && kartaFor(sid, sida)) return sida;
      if ((y.vyer || []).indexOf('front') >= 0 && kartaFor(sid, 'front')) return 'front';
    }
    return y.vy;
  }
  function area() {
    if (UV) {
      var y = TY.ytor[placement], fil = TY.filer[y.grupp] || [1000, 1000];
      var arUV = ((y.del[2] - y.del[0]) * fil[0]) / ((y.del[3] - y.del[1]) * fil[1]);
      if (modeOf(placement) === 'flat') return { uv: true, flat: true, box: { l: 0, t: 0, w: 1, h: 1 }, ar: arUV, src: null, view: viewOf(placement), wrap: null };
      var view = viewOf(placement), karta = kartaFor(placement, view);
      var box = karta ? { l: karta.l, t: karta.t, w: karta.w, h: karta.h } : { l: 0.2, t: 0.2, w: 0.6, h: 0.6 };
      /* vyer där samma tryckfil syns på flera ställen (båda tofflorna, vimplarna) eller är kraftigt
         förvrängd går inte att redigera i: de visar hur det blir, placeringen görs på hela tryckytan */
      var editable = !karta || (karta.skev || 0) < 0.15;
      return { uv: true, box: box, ar: arUV, src: viewImage(view), view: view, wrap: null, editable: editable };
    }
    if (TY) {
      var pos = (placement === 'back' && TY.back) ? 'back' : 'front';
      var box = TY[pos];
      var yta = (TY.yta && (TY.yta[pos] || TY.yta.front)) || null;
      var mock = TY.mock || [1200, 1200];
      var ar = yta ? yta[0] / yta[1] : (box.w * mock[0]) / (box.h * mock[1]);
      var color = colorIndex >= 0 ? currentFormValue('Färg') : '';
      var keys = Object.keys(TY.bilder || {});
      var set = (TY.bilder && (TY.bilder[color] || TY.bilder[''] || (keys.length ? TY.bilder[keys[0]] : null))) || {};
      /* cylinder: kalibrerade värden (kalibrera-wrap.py) – x_mock = cx + R·sin(S·(u − u0)), relativt mockupens bredd –
         eller de gamla mugg-konstanterna om produkten är taggad som mugg men saknar kalibrering */
      var wrap = null;
      if (pos === 'front' && TY.wrap && TY.wrap.R) wrap = TY.wrap;
      else if (KIND === 'mugg') wrap = { cx: box.l + box.w / 2, R: box.w / 2 / Math.sin(THETA), S: 2 * THETA / BAND, u0: 0.5 };
      return { box: box, ar: ar, src: set[pos] || set.front || root.dataset.mainImage, wrap: wrap };
    }
    return { box: { l: 0.2, t: 0.2, w: 0.6, h: 0.6 }, ar: 1, src: root.dataset.mainImage, wrap: null, generic: true };
  }
  /* synlig del av tryckfilen (u 0–1): det som hamnar innanför rutan i mockupen (och inom ±90° på cylindern) */
  /* den del av ytan (0–1) som en kameravy visar */
  function viewZone(sid, view) {
    var y = TY.ytor[sid], k = kartaFor(sid, view);
    if (!k || !k.u || !k.v) return null;
    var du = y.del[2] - y.del[0], dv = y.del[3] - y.del[1];
    var c = function (t) { return Math.max(0, Math.min(1, t)); };
    return { lo: c((k.u[0] - y.del[0]) / du), hi: c((k.u[1] - y.del[0]) / du), vlo: c((k.v[0] - y.del[1]) / dv), vhi: c((k.v[1] - y.del[1]) / dv) };
  }
  function zoneArea(z) { return z ? (z.hi - z.lo) * (z.vhi - z.vlo) : 1; }
  function visibleRange(a) {
    if (a.uv) {
      if (a.flat) {
        /* platt läge: centrera i huvudvyns zon om ytan viks runt produkten (väska: framsidan), annars hela */
        var z0 = viewZone(placement, TY.ytor[placement].vy);
        if (z0 && zoneArea(z0) < 0.85) return { lo: z0.lo, hi: z0.hi, vlo: z0.vlo, vhi: z0.vhi, free: true };
        return { lo: 0, hi: 1, vlo: 0, vhi: 1, free: true };
      }
      /* den del av ytan som huvudvyn visar (kudde: hela; sminkväska: framsidan av den omslutande filen) */
      var y = surf(), k = kartaFor(placement, a.view);
      if (!k || !k.u || !k.v) return { lo: 0, hi: 1, vlo: 0, vhi: 1, free: true };
      var du = y.del[2] - y.del[0], dv = y.del[3] - y.del[1];
      var c = function (t) { return Math.max(0, Math.min(1, t)); };
      return { lo: c((k.u[0] - y.del[0]) / du), hi: c((k.u[1] - y.del[0]) / du), vlo: c((k.v[0] - y.del[1]) / dv), vhi: c((k.v[1] - y.del[1]) / dv), free: true };
    }
    if (!a.wrap) return { lo: 0, hi: 1 };
    var w = a.wrap;
    var inv = function (x) { return w.u0 + Math.asin(Math.max(-1, Math.min(1, (x - w.cx) / w.R))) / w.S; };
    var lo = inv(a.box.l), hi = inv(a.box.l + a.box.w);
    if (hi < lo) { var t = lo; lo = hi; hi = t; }
    return { lo: Math.max(0, Math.min(1, lo)), hi: Math.max(0, Math.min(1, hi)) };
  }

  function loadMock(src) {
    if (mockCache[src]) return mockCache[src];
    mockCache[src] = new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { resolve(im); };
      im.onerror = function () { delete mockCache[src]; resolve(null); };
      im.src = src;
    });
    return mockCache[src];
  }

  /* ---------- UV-kartor: tryckfil → mockup-pixel ---------- */

  var mapCache = {};   /* url → Promise<karta> ; karta = { w, h, u, v (Uint16, 1–4095), ok (Uint8), bbox } */
  function loadMap(url) {
    if (mapCache[url]) return mapCache[url];
    mapCache[url] = new Promise(function (resolve) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
          var g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(im, 0, 0);
          var d = g.getImageData(0, 0, c.width, c.height).data, n = c.width * c.height, W = c.width;
          var u = new Uint16Array(n), v = new Uint16Array(n), ok = new Uint8Array(n);
          var x0 = W, y0 = c.height, x1 = -1, y1 = -1;
          for (var i = 0, j = 0; i < n; i++, j += 4) {
            var r = d[j], gg = d[j + 1], b = d[j + 2];
            if (!r && !gg && !b) continue;
            u[i] = (r << 4) | (b >> 4); v[i] = (gg << 4) | (b & 15); ok[i] = 1;
            var x = i % W, yy = (i / W) | 0;
            if (x < x0) x0 = x; if (x > x1) x1 = x; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
          }
          resolve({ w: W, h: c.height, u: u, v: v, ok: ok, bbox: { x0: x0, y0: y0, x1: x1, y1: y1 } });
        } catch (e) { console.warn('[Minnely-designern] karta', e); resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = url;
    });
    return mapCache[url];
  }
  var viewMapsReady = {};  /* vy → { grupp: karta } när alla kartor för vyn är laddade */
  function viewMaps(view, onReady) {
    if (!UV) return null;
    if (viewMapsReady[view]) return viewMapsReady[view];
    var kartor = (TY.vyer[view] || {}).kartor || {};
    var keys = Object.keys(kartor);
    if (!viewMapsReady['_' + view]) {
      var bas = viewMapsReady;   /* tillampaForm byter objektet; ett sent svar hamnar då i det gamla */
      bas['_' + view] = Promise.all(keys.map(function (g) { return loadMap(kartor[g].url); })).then(function (maps) {
        var out = {};
        keys.forEach(function (g, i) { if (maps[i]) out[g] = maps[i]; });
        bas[view] = out;
        if (onReady) onReady();
        return out;
      });
    } else if (onReady) viewMapsReady['_' + view].then(onReady);
    return null;
  }
  /* u,v (0–1) i tryckfilen för en punkt i mockupen (andel av bredd/höjd); null utanför trycket.
     Bilinjärt när grannarna hör till samma yta, annars närmaste giltiga pixel. */
  function mapAt(m, fx, fy, radius) {
    var px = fx * m.w - 0.5, py = fy * m.h - 0.5;
    var x = Math.floor(px), y = Math.floor(py), tx = px - x, ty = py - y;
    var W = m.w;
    if (x >= 0 && y >= 0 && x < W - 1 && y < m.h - 1) {
      var i00 = y * W + x, i10 = i00 + 1, i01 = i00 + W, i11 = i01 + 1;
      if (m.ok[i00] && m.ok[i10] && m.ok[i01] && m.ok[i11]) {
        var a = m.u[i00], b = m.u[i10], c = m.u[i01], d = m.u[i11];
        var e = m.v[i00], f = m.v[i10], g = m.v[i01], h = m.v[i11];
        if (Math.max(a, b, c, d) - Math.min(a, b, c, d) < 200 && Math.max(e, f, g, h) - Math.min(e, f, g, h) < 200) {
          var uu = (a * (1 - tx) + b * tx) * (1 - ty) + (c * (1 - tx) + d * tx) * ty;
          var vv = (e * (1 - tx) + f * tx) * (1 - ty) + (g * (1 - tx) + h * tx) * ty;
          return { u: (uu - 1) / 4094, v: (vv - 1) / 4094 };
        }
      }
    }
    var cx = Math.round(px), cy = Math.round(py), R = radius || 1;
    for (var r = 0; r <= R; r++) {
      for (var dy = -r; dy <= r; dy++) for (var dx = -r; dx <= r; dx++) {
        if (Math.abs(dx) !== r && Math.abs(dy) !== r) continue;
        var xx = cx + dx, yy = cy + dy;
        if (xx < 0 || yy < 0 || xx >= W || yy >= m.h) continue;
        var i = yy * W + xx;
        if (m.ok[i]) return { u: (m.u[i] - 1) / 4094, v: (m.v[i] - 1) / 4094 };
      }
    }
    return null;
  }
  /* framåtkarta per (vy, yta): rutnät i ytans koordinater → läge i mockupen (andelar), för
     markeringsram, handtag och pekare. Dolda delar av ytan extrapoleras från kanten. */
  var gridCache = {};
  function forwardGrid(view, sid) {
    var key = view + '|' + sid;
    if (gridCache[key]) return gridCache[key];
    var maps = viewMapsReady[view]; var y = TY.ytor[sid];
    var m = maps && maps[y.grupp]; if (!m) return null;
    var du = y.del[2] - y.del[0], dv = y.del[3] - y.del[1];
    /* robust kubisk polynomanpassning (su,sv) → (x,y) på ett urval av kartans pixlar: jämn även
       utanför det synliga (dolda delar extrapoleras mjukt), okänslig för brus vid kanterna */
    var pts = [], step = Math.max(1, Math.round(Math.sqrt(m.ok.length / 6000)));
    for (var yy = 0; yy < m.h; yy += step) for (var xx = 0; xx < m.w; xx += step) {
      var i = yy * m.w + xx; if (!m.ok[i]) continue;
      var su = ((m.u[i] - 1) / 4094 - y.del[0]) / du, sv = ((m.v[i] - 1) / 4094 - y.del[1]) / dv;
      if (su < -0.02 || su > 1.02 || sv < -0.02 || sv > 1.02) continue;
      pts.push([su, sv, (xx + 0.5) / m.w, (yy + 0.5) / m.h]);
    }
    if (pts.length < 30) return null;
    var basis = function (u, v) { return [1, u, v, u * u, u * v, v * v, u * u * u, u * u * v, u * v * v, v * v * v]; };
    var fit = function (P) {
      var n = 10, A = [], b1 = [], b2 = [];
      for (var r = 0; r < n; r++) { A.push(new Float64Array(n)); b1.push(0); b2.push(0); }
      P.forEach(function (p) { var f = basis(p[0], p[1]); for (var r = 0; r < n; r++) { b1[r] += f[r] * p[2]; b2[r] += f[r] * p[3]; for (var c = 0; c < n; c++) A[r][c] += f[r] * f[c]; } });
      for (var d = 0; d < n; d++) A[d][d] += 1e-9;
      var solve = function (M, b) {
        var N = b.length, a = M.map(function (row, r) { return Array.prototype.slice.call(row).concat([b[r]]); });
        for (var c = 0; c < N; c++) {
          var piv = c; for (var r = c + 1; r < N; r++) if (Math.abs(a[r][c]) > Math.abs(a[piv][c])) piv = r;
          var t = a[c]; a[c] = a[piv]; a[piv] = t;
          if (Math.abs(a[c][c]) < 1e-12) continue;
          for (var r2 = 0; r2 < N; r2++) { if (r2 === c) continue; var k = a[r2][c] / a[c][c]; for (var c2 = c; c2 <= N; c2++) a[r2][c2] -= k * a[c][c2]; }
        }
        var out = []; for (var r3 = 0; r3 < N; r3++) out.push(Math.abs(a[r3][r3]) < 1e-12 ? 0 : a[r3][N] / a[r3][r3]);
        return out;
      };
      return { cx: solve(A, b1), cy: solve(A, b2) };
    };
    var evalAt = function (co, u, v) { var f = basis(u, v), o = 0; for (var r = 0; r < 10; r++) o += co.cx[r] * f[r]; var o2 = 0; for (var r2 = 0; r2 < 10; r2++) o2 += co.cy[r2] * f[r2]; return { x: o, y: o2 }; };
    var co = fit(pts);
    /* andra passet utan de 15 % sämst passande punkterna (brus i kartans kant) */
    var res = pts.map(function (p) { var e = evalAt(co, p[0], p[1]); return Math.hypot(e.x - p[2], e.y - p[3]); }).sort(function (a, b) { return a - b; });
    var cut = res[Math.floor(res.length * 0.85)] || Infinity;
    var good = pts.filter(function (p) { var e = evalAt(co, p[0], p[1]); return Math.hypot(e.x - p[2], e.y - p[3]) <= cut; });
    if (good.length >= 30) co = fit(good);
    /* passningens fel: hur väl polynomet återger kartan (andel av tryckets storlek i mockupen).
       Stort fel = samma fil på flera ställen (tofflor, vimplar) eller mycket böjd yta → inga handtag i vyn */
    var sizeF = Math.max((m.bbox.x1 - m.bbox.x0 + 1) / m.w, (m.bbox.y1 - m.bbox.y0 + 1) / m.h, 1e-3);
    var se = 0; good.forEach(function (p) { var e = evalAt(co, p[0], p[1]); se += (e.x - p[2]) * (e.x - p[2]) + (e.y - p[3]) * (e.y - p[3]); });
    var err = Math.sqrt(se / Math.max(1, good.length)) / sizeF;
    var G = 36, N = (G + 1) * (G + 1), gx = new Float32Array(N), gy = new Float32Array(N);
    for (var gj = 0; gj <= G; gj++) for (var gi = 0; gi <= G; gi++) { var e2 = evalAt(co, gi / G, gj / G), k2 = gj * (G + 1) + gi; gx[k2] = e2.x; gy[k2] = e2.y; }
    gridCache[key] = { G: G, x: gx, y: gy, err: err };
    return gridCache[key];
  }
  function gridAt(grid, su, sv) {
    var G = grid.G, fx = Math.max(0, Math.min(G, su * G)), fy = Math.max(0, Math.min(G, sv * G));
    var i = Math.min(G - 1, Math.floor(fx)), j = Math.min(G - 1, Math.floor(fy)), tx = fx - i, ty = fy - j;
    var k = j * (G + 1) + i;
    var x = (grid.x[k] * (1 - tx) + grid.x[k + 1] * tx) * (1 - ty) + (grid.x[k + G + 1] * (1 - tx) + grid.x[k + G + 2] * tx) * ty;
    var y = (grid.y[k] * (1 - tx) + grid.y[k + 1] * tx) * (1 - ty) + (grid.y[k + G + 1] * (1 - tx) + grid.y[k + G + 2] * tx) * ty;
    return { x: x, y: y };
  }
  /* skuggning för UV-läget: mockupens ljus normaliserat mot medianen inom trycket */
  var shadeUVCache = {};
  function shadeUV(im, view, ow, oh) {
    var key = im.src + '|' + view + '|' + ow + 'x' + oh;
    if (shadeUVCache[key]) return shadeUVCache[key];
    var maps = viewMapsReady[view] || {};
    var c = document.createElement('canvas'); c.width = ow; c.height = oh;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(im, 0, 0, ow, oh);
    var p = g.getImageData(0, 0, ow, oh).data, lum = new Float32Array(ow * oh), sample = [], kroma = [];
    for (var i = 0, j = 0; i < lum.length; i++, j += 4) lum[i] = 0.299 * p[j] + 0.587 * p[j + 1] + 0.114 * p[j + 2];
    Object.keys(maps).forEach(function (gk) {
      var m = maps[gk];
      for (var y = 0; y < oh; y += 3) for (var x = 0; x < ow; x += 3) {
        var mi = Math.min(m.h - 1, ((y + 0.5) / oh * m.h) | 0) * m.w + Math.min(m.w - 1, ((x + 0.5) / ow * m.w) | 0);
        if (m.ok[mi]) { var pj = (y * ow + x) * 4; sample.push(lum[y * ow + x]); kroma.push(Math.max(p[pj], p[pj + 1], p[pj + 2]) - Math.min(p[pj], p[pj + 1], p[pj + 2])); }
      }
    });
    sample.sort(function (a, b) { return a - b; });
    var med = Math.max(12, sample[Math.floor(sample.length / 2)] || 200);
    for (var k = 0; k < lum.length; k++) lum[k] = Math.min(1.08, lum[k] / med);
    /* Vita ytor (vit tröja, kudde, filt, keramik) trycks utan vitt bläck: det vita i bilden blir tygets
       egen färg. Där blandas designen i ytan (multiplicera), annars syntes pappret runt en teckning som
       en ljusare fyrkant på tröjan fast den inte trycks. Färgade och grå plagg får vitt bläck, och där
       ritas vitt som vitt. Gränsen är uppmätt: vita produkter 233–244 i ljushet utan färgton, askgrå 217,
       ljusrosa har färgton 30. */
    kroma.sort(function (a, b) { return a - b; });
    var kmed = kroma[Math.floor(kroma.length / 2)] || 0;
    lum.vitt = Math.max(0, Math.min(1, (med - 222) / 12)) * Math.max(0, Math.min(1, (18 - kmed) / 10));
    lum.rgb = p;
    var keys = Object.keys(shadeUVCache); if (keys.length > 6) delete shadeUVCache[keys[0]];
    shadeUVCache[key] = lum;
    return lum;
  }
  var uvOut = document.createElement('canvas');
  /* ytans lager som mip-kedja: nivå 0 i den upplösning vyn behöver där trycket syns störst, varje
     nästa nivå halverad. En utpixel läses ur de två nivåer som motsvarar hur många texlar den täcker,
     så att tunna linjer varken hackar eller försvinner där trycket ses på håll eller trycks ihop
     (en tröja i helbild, cylinderns kanter). */
  function mipKedja(sid, kW, arS, preview) {
    var sc = document.createElement('canvas');
    sc.width = kW; sc.height = Math.max(2, Math.round(kW / arS));
    withSide(sid, function () { renderArea(sc, kW / R_W, { preview: preview }); });
    var niv = [], src = sc;
    for (;;) {
      niv.push({ w: src.width, h: src.height, d: src.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, src.width, src.height).data });
      if (src.width <= 8 || src.height <= 8 || niv.length >= 8) break;
      var nc = document.createElement('canvas');
      nc.width = Math.max(1, src.width >> 1); nc.height = Math.max(1, src.height >> 1);
      var ng = nc.getContext('2d', { willReadFrequently: true });
      ng.imageSmoothingEnabled = true; ng.imageSmoothingQuality = 'high';
      ng.drawImage(src, 0, 0, nc.width, nc.height);
      src = nc;
    }
    return niv;
  }
  /* bilinjär avläsning av en nivå: färg förmultiplicerad med alfa (mipUt[0–2]) och alfa 0–255 (mipUt[3]) */
  var mipUt = new Float64Array(4);
  function mipLas(n, su, sv) {
    var sw = n.w, sh = n.h, sd = n.d;
    var fx = su * sw - 0.5, fy = sv * sh - 0.5;
    if (fx < 0) fx = 0; else if (fx > sw - 1) fx = sw - 1;
    if (fy < 0) fy = 0; else if (fy > sh - 1) fy = sh - 1;
    var x0 = fx | 0, y0 = fy | 0, ax = fx - x0, ay = fy - y0;
    var x1 = x0 + 1 < sw ? x0 + 1 : x0, y1 = y0 + 1 < sh ? y0 + 1 : y0;
    var j00 = (y0 * sw + x0) * 4, j10 = (y0 * sw + x1) * 4, j01 = (y1 * sw + x0) * 4, j11 = (y1 * sw + x1) * 4;
    var w00 = (1 - ax) * (1 - ay) * sd[j00 + 3], w10 = ax * (1 - ay) * sd[j10 + 3];
    var w01 = (1 - ax) * ay * sd[j01 + 3], w11 = ax * ay * sd[j11 + 3];
    mipUt[0] = (sd[j00] * w00 + sd[j10] * w10 + sd[j01] * w01 + sd[j11] * w11) / 255;
    mipUt[1] = (sd[j00 + 1] * w00 + sd[j10 + 1] * w10 + sd[j01 + 1] * w01 + sd[j11 + 1] * w11) / 255;
    mipUt[2] = (sd[j00 + 2] * w00 + sd[j10 + 2] * w10 + sd[j01 + 2] * w01 + sd[j11 + 2] * w11) / 255;
    mipUt[3] = w00 + w10 + w01 + w11;
  }
  /* hur stor del av ytan en utpixel täcker (ytans bredd = 1, höjden skalad med sidförhållandet),
     ur grannpixlarnas läge i tryckfilen; 0 när ingen granne hör till trycket */
  function fotavtryck(U, V, k, x, y, bw, bh, du, dv, ar) {
    var kx = x + 1 < bw && U[k + 1] >= 0 ? k + 1 : (x > 0 && U[k - 1] >= 0 ? k - 1 : -1);
    var ky = y + 1 < bh && U[k + bw] >= 0 ? k + bw : (y > 0 && U[k - bw] >= 0 ? k - bw : -1);
    var fx = kx < 0 ? 0 : Math.hypot((U[kx] - U[k]) / du, (V[kx] - V[k]) / dv / ar);
    var fy = ky < 0 ? 0 : Math.hypot((U[ky] - U[k]) / du, (V[ky] - V[k]) / dv / ar);
    return fx > fy ? fx : fy;
  }
  /* alla ytor med innehåll som syns i vyn ritas pixel för pixel efter kartorna, med skuggning */
  function composeUV(g, im, view, rect, cap, preview) {
    var maps = viewMaps(view, scheduleDraw);
    if (!maps) return false;
    var ow = Math.round(rect.w * (cap.scale || 1)), oh = Math.round(rect.h * (cap.scale || 1));
    var lim = cap.max || 1100;
    if (Math.max(ow, oh) > lim) { var f = lim / Math.max(ow, oh); ow = Math.round(ow * f); oh = Math.round(oh * f); }
    if (ow < 2 || oh < 2) return true;
    var out = new Uint8ClampedArray(ow * oh * 4);
    var shade = shadeUV(im, view, ow, oh), vitt = shade.vitt || 0;
    var drawn = false;
    Object.keys(maps).forEach(function (grupp) {
      var m = maps[grupp];
      var ytor = surfacesOf(grupp).filter(sideHasContent);
      if (!ytor.length) return;
      var bx0 = Math.max(0, Math.floor(m.bbox.x0 / m.w * ow) - 1), bx1 = Math.min(ow - 1, Math.ceil((m.bbox.x1 + 1) / m.w * ow) + 1);
      var by0 = Math.max(0, Math.floor(m.bbox.y0 / m.h * oh) - 1), by1 = Math.min(oh - 1, Math.ceil((m.bbox.y1 + 1) / m.h * oh) + 1);
      var bw = bx1 - bx0 + 1, bh = by1 - by0 + 1;
      if (bw < 1 || bh < 1) return;
      /* läget i tryckfilen (u,v 0–1) för varje utpixel, -1 utanför trycket */
      var U = new Float32Array(bw * bh), V = new Float32Array(bw * bh);
      U.fill(-1);
      var mu = m.u, mv = m.v, mok = m.ok, mw = m.w, mh = m.h;
      for (var oy = by0; oy <= by1; oy++) {
        var py = (oy + 0.5) / oh * mh - 0.5, yi = Math.floor(py), ty = py - yi;
        for (var ox = bx0; ox <= bx1; ox++) {
          var px = (ox + 0.5) / ow * mw - 0.5, xi = Math.floor(px), tx = px - xi;
          var uu, vv;
          if (xi >= 0 && yi >= 0 && xi < mw - 1 && yi < mh - 1) {
            var i00 = yi * mw + xi, i10 = i00 + 1, i01 = i00 + mw, i11 = i01 + 1;
            if (mok[i00] && mok[i10] && mok[i01] && mok[i11]) {
              var a = mu[i00], b = mu[i10], c = mu[i01], d = mu[i11];
              var e = mv[i00], f2 = mv[i10], g2 = mv[i01], h2 = mv[i11];
              if (Math.max(a, b, c, d) - Math.min(a, b, c, d) < 200 && Math.max(e, f2, g2, h2) - Math.min(e, f2, g2, h2) < 200) {
                uu = (a * (1 - tx) + b * tx) * (1 - ty) + (c * (1 - tx) + d * tx) * ty;
                vv = (e * (1 - tx) + f2 * tx) * (1 - ty) + (g2 * (1 - tx) + h2 * tx) * ty;
              } else { var ni = (ty < 0.5 ? (tx < 0.5 ? i00 : i10) : (tx < 0.5 ? i01 : i11)); uu = mu[ni]; vv = mv[ni]; }
            } else {
              var nx = Math.round(px), ny = Math.round(py);
              if (nx < 0 || ny < 0 || nx >= mw || ny >= mh) continue;
              var nj = ny * mw + nx; if (!mok[nj]) continue;
              uu = mu[nj]; vv = mv[nj];
            }
          } else {
            var nx2 = Math.max(0, Math.min(mw - 1, Math.round(px))), ny2 = Math.max(0, Math.min(mh - 1, Math.round(py)));
            var nj2 = ny2 * mw + nx2; if (!mok[nj2]) continue;
            uu = mu[nj2]; vv = mv[nj2];
          }
          var kk = (oy - by0) * bw + (ox - bx0);
          U[kk] = (uu - 1) / 4094; V[kk] = (vv - 1) / 4094;
        }
      }
      ytor.forEach(function (sid) {
        var y = TY.ytor[sid];
        var du = y.del[2] - y.del[0], dv = y.del[3] - y.del[1];
        var arS = withSide(sid, function () { return area().ar; });
        /* upplösningen väljs där trycket syns störst i vyn: där ska en utpixel täcka ~1,3 texel */
        var prov = [];
        for (var sy = 0; sy < bh; sy += 3) for (var sx = 0; sx < bw; sx += 3) {
          var k0 = sy * bw + sx;
          if (U[k0] < 0) continue;
          var su0 = (U[k0] - y.del[0]) / du, sv0 = (V[k0] - y.del[1]) / dv;
          if (su0 < 0 || su0 >= 1 || sv0 < 0 || sv0 >= 1) continue;
          var s0 = fotavtryck(U, V, k0, sx, sy, bw, bh, du, dv, arS);
          if (s0 > 0) prov.push(s0);
        }
        if (!prov.length) return;
        prov.sort(function (p, q) { return p - q; });
        var kW = Math.max(64, Math.min(2400, Math.round(1.3 / prov[Math.floor(prov.length * 0.03)])));
        var niv = mipKedja(sid, kW, arS, preview), sista = niv.length - 1;
        for (var ry = 0; ry < bh; ry++) {
          for (var rx = 0; rx < bw; rx++) {
            var k = ry * bw + rx;
            if (U[k] < 0) continue;
            var su = (U[k] - y.del[0]) / du, sv = (V[k] - y.del[1]) / dv;
            if (su < 0 || su >= 1 || sv < 0 || sv >= 1) continue;
            /* texlar per utpixel på nivå 0 → nivå (log2), mjukt mellan två nivåer. Över 64 är det en
               söm i kartan (två delar av tryckfilen möts), inte ett ihoptryckt tryck */
            var fp = fotavtryck(U, V, k, rx, ry, bw, bh, du, dv, arS) * kW;
            var lam = fp > 1 && fp < 64 ? Math.log2(fp) : 0;
            var L = lam | 0, t = lam - L;
            if (L >= sista) { L = sista; t = 0; }
            mipLas(niv[L], su, sv);
            var pr = mipUt[0], pg = mipUt[1], pb = mipUt[2], pa = mipUt[3];
            if (t > 0) {
              mipLas(niv[L + 1], su, sv);
              pr += (mipUt[0] - pr) * t; pg += (mipUt[1] - pg) * t; pb += (mipUt[2] - pb) * t; pa += (mipUt[3] - pa) * t;
            }
            if (pa <= 0.8) continue;
            var o = ((ry + by0) * ow + rx + bx0) * 4, s = shade[(ry + by0) * ow + rx + bx0];
            var al = pa / 255, r = pr / al, gg = pg / al, bb = pb / al;
            if (vitt) {
              var q = o, mr = shade.rgb;
              r *= s * (1 - vitt) + mr[q] / 255 * vitt; gg *= s * (1 - vitt) + mr[q + 1] / 255 * vitt; bb *= s * (1 - vitt) + mr[q + 2] / 255 * vitt;
            } else { r *= s; gg *= s; bb *= s; }
            var oa = out[o + 3] / 255;
            var na = al + oa * (1 - al);
            out[o] = (r * al + out[o] * oa * (1 - al)) / na;
            out[o + 1] = (gg * al + out[o + 1] * oa * (1 - al)) / na;
            out[o + 2] = (bb * al + out[o + 2] * oa * (1 - al)) / na;
            out[o + 3] = na * 255;
            drawn = true;
          }
        }
      });
    });
    if (!drawn) return true;
    uvOut.width = ow; uvOut.height = oh;
    uvOut.getContext('2d').putImageData(new ImageData(out, ow, oh), 0, 0);
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    g.drawImage(uvOut, rect.x, rect.y, rect.w, rect.h);
    return true;
  }

  /* ---------- Lager & historik ---------- */

  /* lagren finns per sida (fram/rygg); `layers` pekar alltid på den aktiva sidans lista */
  var sides = {};
  SURF.forEach(function (id) { sides[id] = []; });
  placement = SURF[0];
  var layers = sides[placement];
  var selected = null;
  var history = [], future = [];
  var uid = 0;
  var assets = {}; /* id → { versions } för bildlager (överlever ångra) */

  function stripLayers(arr) {
    return arr.map(function (l) { var c = {}; Object.keys(l).forEach(function (k) { if (k !== 'versions') c[k] = l[k]; }); return c; });
  }
  function reattach(arr) {
    return (arr || []).map(function (l) { if (l.type === 'image' && assets[l.id]) l.versions = assets[l.id].versions; return l; });
  }
  function snapshot() {
    sides[placement] = layers;
    var out = { placement: placement, sides: {} };
    SURF.forEach(function (id) { out.sides[id] = stripLayers(sides[id]); });
    return JSON.stringify(out);
  }
  function restore(json) {
    var snap = JSON.parse(json);
    SURF.forEach(function (id) { sides[id] = reattach((snap.sides || {})[id] || (id === 'front' ? snap.front : id === 'back' ? snap.back : null)); });
    if (snap.placement && snap.placement !== placement && sides[snap.placement]) setPlacement(snap.placement, true);
    layers = sides[placement];
    if (selected && !layers.some(function (l) { return l.id === selected; })) selected = null;
  }
  function sideHasContent(pos) {
    var arr = pos === placement ? layers : sides[pos];
    return !!arr && arr.some(function (l) { return l.type === 'image' || String(l.text || '').trim(); });
  }
  function surfacesWithContent() { return SURF.filter(sideHasContent); }
  /* extra tryckytor utöver den första kostar extra (tilläggsprodukten "Extra tryck") */
  function extraCount() { return Math.max(0, surfacesWithContent().length - 1); }
  function setPlacement(pos, silent) {
    if (pos === placement || !sides[pos]) return;
    sides[placement] = layers;
    placement = pos;
    layers = sides[pos];
    selected = null;
    qa('[data-mnd-side]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.mndSide === pos); });
    if (!silent) { refitLayers(); renderPanels(); draw(); }
  }
  /* kör fn med en annan sida aktiv (för export av tryckfil per sida) */
  function withSide(pos, fn) {
    var prev = placement; var prevLayers = layers;
    sides[placement] = layers; placement = pos; layers = sides[pos];
    try { return fn(); } finally { placement = prev; layers = prevLayers; }
  }
  function pushHistory(snap) {
    history.push(snap);
    if (history.length > 60) history.shift();
    future = [];
    updateUndo();
  }
  function commit() { pushHistory(snapshot()); }
  function undo() {
    if (!history.length) return;
    future.push(snapshot()); restore(history.pop());
    updateUndo(); renderPanels(); draw();
  }
  function redo() {
    if (!future.length) return;
    history.push(snapshot()); restore(future.pop());
    updateUndo(); renderPanels(); draw();
  }
  function updateUndo() {
    q('[data-mnd-undo]').disabled = !history.length;
    q('[data-mnd-redo]').disabled = !future.length;
  }

  function layerById(id) { return layers.find(function (l) { return l.id === id; }) || null; }
  function selectedLayer() { return selected ? layerById(selected) : null; }
  function activeVersion(l) { return (l.bg || !l.versions.clean) ? l.versions.paper : l.versions.clean; }

  /* Lagerkoordinater: x/y = mittpunkt i px av en tryckyta som är R_W bred
     (höjden R_W / ar). w = bredd i samma px. */
  function areaH() { return R_W / area().ar; }

  function addImageLayer(versions, name) {
    var id = 'b' + (++uid);
    assets[id] = { versions: versions };
    var ar = (versions.clean || versions.paper).ar;
    var a = area(), vr = visibleRange(a);
    var maxW = R_W * (vr.hi - vr.lo) * (a.wrap ? 0.86 : 0.82);
    var w = Math.min(maxW, areaH() * 0.82 * ar);
    /* flera bilder: lägg nya lite förskjutet så de inte hamnar exakt ovanpå varandra */
    var n = layers.filter(function (l) { return l.type === 'image'; }).length;
    var off = Math.min(n, 4) * R_W * 0.04;
    var cy = vr.vlo != null ? areaH() * (vr.vlo + vr.vhi) / 2 : areaH() / 2;
    if (vr.vlo != null) w = Math.min(w, Math.max(R_W * 0.2, areaH() * (vr.vhi - vr.vlo) * 0.82 * ar));
    layers.push({ id: id, type: 'image', name: name || 'Teckning', bg: !versions.clean, flip: false, x: R_W * (vr.lo + vr.hi) / 2 + off, y: cy + off, w: w, ar: ar, rot: 0, versions: versions });
    clampLayer(layers[layers.length - 1]);
    selected = id;
  }

  /* täck hela tryckytan med bilden (bilden beskärs i kanterna om proportionerna skiljer sig) */
  function fillArea(id) {
    var l = layerById(id); if (!l || l.type !== 'image') return;
    commit();
    var a = area(), vr = visibleRange(a), h = areaH();
    l.rot = 0;
    if (UV) {
      /* fyll huvudvyns zon (väska: framsidan) – hela filen bara när vyn visar hela ytan */
      var z = viewZone(placement, TY.ytor[placement].vy);
      if (!z || zoneArea(z) >= 0.85) z = { lo: 0, hi: 1, vlo: 0, vhi: 1 };
      var zw = R_W * (z.hi - z.lo), zh = h * (z.vhi - z.vlo);
      l.w = Math.max(zw, zh * l.ar);
      l.x = R_W * (z.lo + z.hi) / 2; l.y = h * (z.vlo + z.vhi) / 2;
    } else {
      l.w = Math.max(R_W, h * l.ar);          /* minsta bredd som täcker både bredd och höjd */
      l.x = a.wrap ? R_W * (vr.lo + vr.hi) / 2 : R_W / 2; l.y = h / 2;
    }
    selected = id; renderPanels(); draw();
  }

  function duplicateLayer(id) {
    var src = layerById(id); if (!src || src.fast) return;
    commit();
    var copy = (JSON.parse(snapshot()).sides[placement] || []).find(function (l) { return l.id === id; });
    if (!copy) return;
    copy.id = (src.type === 'image' ? 'b' : 't') + (++uid);
    if (src.type === 'image') { assets[copy.id] = assets[src.id]; copy.versions = src.versions; }
    copy.x = Math.min(R_W * 0.98, copy.x + R_W * 0.05);
    copy.y = Math.min(areaH() * 0.98, copy.y + R_W * 0.05);
    layers.splice(layers.indexOf(src) + 1, 0, copy);
    selected = copy.id;
    renderPanels(); draw();
    focusGear(copy.id);
  }
  function moveLayer(id, dir) {
    var i = layers.findIndex(function (l) { return l.id === id; });
    var j = i + dir;
    if (i < 0 || j < 0 || j >= layers.length) return;
    commit();
    var t = layers[i]; layers[i] = layers[j]; layers[j] = t;
    renderPanels(); draw();
  }

  /* textens startfärg: vit på mörka plagg, mörk på ljusa (plaggfärgen ur Färg-valet och COLOR_HEX) */
  function plaggArMorkt() {
    var fi = options.findIndex(function (o) { return o.name === 'Färg'; });
    var hex = fi >= 0 ? COLOR_HEX[selectedValues()[fi]] : null;
    var m = hex && /^#([0-9a-f]{6})$/i.exec(hex); if (!m) return false;
    var n = parseInt(m[1], 16), r = n >> 16 & 255, g = n >> 8 & 255, b = n & 255;
    return (0.299 * r + 0.587 * g + 0.114 * b) < 120;
  }
  function addTextLayer() {
    var id = 't' + (++uid);
    var img = layers.filter(function (l) { return l.type === 'image'; }).slice(-1)[0];
    var size = Math.round(areaH() * 0.1);
    var y = img ? Math.min(areaH() - size, img.y + (img.w / img.ar) / 2 + size * 0.8) : areaH() / 2;
    var vr = visibleRange(area());
    if (!img && vr.vlo != null) y = areaH() * (vr.vlo + vr.vhi) / 2;
    /* ärmar och andra smala, höga ytor: texten går längs ytan (läses nedifrån och upp, som namn längs ärmen)
       och storleken räknas mot ytans bredd, så att den inte klipps i kanten */
    var langs = /sleeve/.test(String(placement)) || area().ar < 0.6;
    /* ärmen: namnen staplas uppåt, rad under rad (Enter = ny rad), i skrivstil en bit ner mot mudden.
       "Längs ärmen" (vridet) finns som val under Placering. */
    if (langs) { size = Math.round(R_W * 0.34); if (!img) y = areaH() * 0.6; }
    layers.push({ id: id, type: 'text', text: '', font: langs ? 'Dancing Script' : 'Outfit', color: plaggArMorkt() ? '#ffffff' : '#1f1f1f', stroke: false, size: size, x: R_W * (vr.lo + vr.hi) / 2, y: y, rot: 0, w: 0, h: 0, ar: 1, align: 'center' });
    selected = id;
  }

  /* ---------- Rendering ---------- */

  var stageW = 0, stageH = 0, dpr = 1;
  var mockImg = null, mockKey = null, mockRect = null;
  var areaCanvas = document.createElement('canvas');
  var drawScheduled = false;
  var PLACEHOLDER_TEXT = 'Skriv något …';

  function fitStage() {
    var r = stage.getBoundingClientRect();
    dpr = Math.min(2, window.devicePixelRatio || 1);
    stageW = Math.max(1, Math.round(r.width));
    stageH = Math.max(1, Math.round(r.height));
    canvas.width = Math.round(stageW * dpr);
    canvas.height = Math.round(stageH * dpr);
    canvas.style.width = stageW + 'px';
    canvas.style.height = stageH + 'px';
  }

  function scheduleDraw() {
    if (drawScheduled) return;
    drawScheduled = true;
    requestAnimationFrame(function () { drawScheduled = false; draw(); });
  }

  function textOf(l, preview) {
    var t = String(l.text || '');
    if (t.trim()) return t;
    return preview ? PLACEHOLDER_TEXT : '';
  }
  function textLines(l, preview) { return textOf(l, preview).split('\n'); }
  function fontString(l, px) { return fontWeight(l.font) + ' ' + px + 'px "' + l.font + '", Outfit, sans-serif'; }
  function measureText(l, gctx) {
    gctx.font = fontString(l, l.size);
    var lines = textLines(l, true);
    var maxW = 0;
    lines.forEach(function (t) { maxW = Math.max(maxW, gctx.measureText(t).width); });
    var lh = l.size * 1.15;
    var pad = l.stroke ? l.size * 0.14 : 0;
    return { w: Math.max(maxW, l.size * 0.6) + pad, h: lh * lines.length + pad, lh: lh };
  }
  function layerBox(l) {
    if (l.type === 'text') { var m = measureText(l, ctx); l.w = m.w; l.h = m.h; return { w: m.w, h: m.h }; }
    return { w: l.w, h: l.w / l.ar };
  }

  function isLight(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '')); if (!m) return false;
    var n = parseInt(m[1], 16);
    return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) > 150;
  }

  /* gravyr: tryckfilen är gråskala (mörkt = graveras). Förhandsvisningen visar gravyren som
     etsade märken: ljusa på mörk metall, mörka på ljus metall – färgvalet spelar ingen roll. */
  var engravePreview = null; /* null = tryckfil, annars { dark: bool } */
  function toEngrave(cv) {
    var g = cv.getContext('2d');
    var d = g.getImageData(0, 0, cv.width, cv.height), p = d.data;
    var etch = engravePreview ? (engravePreview.dark ? [214, 214, 210] : [58, 58, 60]) : null;
    for (var i = 0; i < p.length; i += 4) {
      if (!p[i + 3]) continue;
      var v = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2];
      v = Math.max(0, Math.min(255, (v - 128) * 1.15 + 128));
      if (etch) {
        /* mörkare original = djupare gravyr = tydligare märke */
        p[i] = etch[0]; p[i + 1] = etch[1]; p[i + 2] = etch[2];
        p[i + 3] = Math.round(p[i + 3] * (1 - v / 255) * 0.95);
      } else {
        p[i] = p[i + 1] = p[i + 2] = v;
      }
    }
    g.putImageData(d, 0, 0);
  }
  var metalCache = {};
  function metalIsDark(im, a) {
    var key = im.src + '|' + a.box.l + ',' + a.box.t;
    if (key in metalCache) return metalCache[key];
    var c = document.createElement('canvas'); c.width = 40; c.height = 40;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(im, a.box.l * im.naturalWidth, a.box.t * im.naturalHeight, a.box.w * im.naturalWidth, a.box.h * im.naturalHeight, 0, 0, 40, 40);
    var d = g.getImageData(0, 0, 40, 40).data, sum = 0;
    for (var i = 0; i < d.length; i += 4) sum += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
    metalCache[key] = sum / (d.length / 4) < 110;
    return metalCache[key];
  }

  /* ritar alla lager in i en canvas som motsvarar hela tryckytan (skala k = px per referens-px) */
  function renderArea(target, k, opts) {
    var preview = !!(opts && opts.preview);
    var g = target.getContext('2d');
    g.setTransform(1, 0, 0, 1, 0, 0);
    g.clearRect(0, 0, target.width, target.height);
    if (opts && opts.origin) g.setTransform(1, 0, 0, 1, opts.origin.x, opts.origin.y);
    g.imageSmoothingEnabled = true;
    g.imageSmoothingQuality = 'high';
    layers.forEach(function (l) {
      var b = layerBox(l);
      var txt = l.type === 'text' ? textOf(l, preview) : null;
      if (l.type === 'text' && !txt) return;
      if (inlineId === l.id && preview) return; /* scenen (preview): texten redigeras på plats, fältet ovanpå visar den; tryckfilen ritas som vanligt */
      g.save();
      g.translate(l.x * k, l.y * k);
      g.rotate(l.rot);
      if (l.type === 'image') {
        if (l.flip) g.scale(-1, 1);
        g.drawImage(activeVersion(l).img, -b.w * k / 2, -b.h * k / 2, b.w * k, b.h * k);
      } else {
        if (!String(l.text || '').trim()) g.globalAlpha = 0.35;
        g.font = fontString(l, l.size * k);
        g.fillStyle = l.color;
        g.textAlign = 'center';
        g.textBaseline = 'middle';
        var lines = txt.split('\n');
        var lh = l.size * 1.15 * k;
        var y0 = -((lines.length - 1) * lh) / 2;
        if (l.stroke) {
          /* kontur i kontrastfärg – gör ljus text läsbar på ljusa plagg och tvärtom */
          g.lineJoin = 'round';
          g.lineWidth = Math.max(1, l.size * k * 0.14);
          g.strokeStyle = isLight(l.color) ? '#1f1f1f' : '#ffffff';
          lines.forEach(function (t, i) { g.strokeText(t, 0, y0 + i * lh); });
        }
        lines.forEach(function (t, i) { g.fillText(t, 0, y0 + i * lh); });
      }
      g.restore();
    });
    if (ENGRAVE) toEngrave(target);
  }

  /* skuggkarta: mockupens ljus/skuggor normaliserade mot medianljuset så att
     plaggets färg inte bakas in (vit text på svart tröja ska synas) */
  var shadeCache = {};
  function shadeMap(im, a, aw, ah) {
    var key = im.src + '|' + aw + 'x' + ah + '|' + a.box.l + ',' + a.box.t;
    if (shadeCache[key]) return shadeCache[key];
    var c = document.createElement('canvas'); c.width = aw; c.height = ah;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(im, a.box.l * im.naturalWidth, a.box.t * im.naturalHeight, a.box.w * im.naturalWidth, a.box.h * im.naturalHeight, 0, 0, aw, ah);
    var d = g.getImageData(0, 0, aw, ah), p = d.data, lum = new Float32Array(aw * ah), sample = [];
    for (var i = 0, j = 0; i < p.length; i += 4, j++) {
      lum[j] = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2];
      if ((j & 63) === 0) sample.push(lum[j]);
    }
    sample.sort(function (x, y) { return x - y; });
    var med = Math.max(12, sample[Math.floor(sample.length / 2)] || 200);
    for (var i2 = 0, j2 = 0; i2 < p.length; i2 += 4, j2++) {
      var v = Math.round(255 * Math.min(1.08, lum[j2] / med));
      p[i2] = p[i2 + 1] = p[i2 + 2] = v; p[i2 + 3] = 255;
    }
    g.putImageData(d, 0, 0);
    shadeCache[key] = c;
    return c;
  }

  /* lagren → tryckytan → produkten (platt eller cylinder) med skuggkarta */
  function composeOnMock(g, im, a, box, scale, preview) {
    var aw = Math.round(box.w * scale), ah = Math.round(box.h * scale);
    if (aw < 2 || ah < 2) return;
    /* tryckytans canvas ritas i den upplösning som behövs på skärmen i BÅDA leder – annars blir
       breda tryckytor (glas, muggar) några pixlar höga och suddiga när de sträcks ut */
    var k = Math.max(aw / R_W, ah / areaH());
    if (a.wrap) k = Math.max(k, (a.wrap.R * (box.w / a.box.w) * scale * a.wrap.S) / R_W); /* mitt på cylindern är skalan R·S */
    k = Math.min(k, 6000 / R_W);
    areaCanvas.width = Math.max(2, Math.round(R_W * k)); areaCanvas.height = Math.max(2, Math.round(areaH() * k));
    var dark = ENGRAVE && metalIsDark(im, a);
    engravePreview = ENGRAVE ? { dark: dark } : null;
    renderArea(areaCanvas, k, { preview: preview });
    engravePreview = null;
    var layer = document.createElement('canvas'); layer.width = aw; layer.height = ah;
    var lg = layer.getContext('2d');
    lg.imageSmoothingEnabled = true; lg.imageSmoothingQuality = 'high';
    if (a.wrap) drawWrapped(lg, areaCanvas, aw, ah, a); else lg.drawImage(areaCanvas, 0, 0, aw, ah);
    var mask = document.createElement('canvas'); mask.width = aw; mask.height = ah;
    mask.getContext('2d').drawImage(layer, 0, 0);
    if (!dark) {
      lg.globalCompositeOperation = 'multiply';
      var sw = Math.min(aw, 900), sh = Math.max(2, Math.round(sw * ah / aw));
      lg.drawImage(shadeMap(im, a, sw, sh), 0, 0, aw, ah);
    }
    lg.globalCompositeOperation = 'destination-in';
    lg.drawImage(mask, 0, 0);
    g.drawImage(layer, box.x, box.y, box.w, box.h);
  }

  var zoomed = null; /* null = auto (in på mobil), true/false = användarens val */
  function arArm() { return /sleeve/.test(String(placement)); }
  /* ärmen är liten i mockupen: inzoomad om kunden inte valt själv, också på datorn */
  function isZoomed() { return zoomed === null ? (stageW < 700 || arArm()) : zoomed; }

  var flatCanvas = document.createElement('canvas');
  function drawFlat(a, opts) {
    var r = flatRect(a);
    mockRect = null;
    ctx.fillStyle = '#f3ede7'; ctx.fillRect(0, 0, stageW, stageH);
    ctx.save(); ctx.shadowColor = 'rgba(31,31,31,0.18)'; ctx.shadowBlur = 24; ctx.shadowOffsetY = 8;
    ctx.fillStyle = '#ffffff'; ctx.fillRect(r.x, r.y, r.w, r.h); ctx.restore();
    /* lagren över hela scenen: utanför tryckytan tonat, innanför fullt */
    var W = Math.round(stageW * dpr), H = Math.round(stageH * dpr), k = r.w * dpr / R_W;
    flatCanvas.width = W; flatCanvas.height = H;
    renderArea(flatCanvas, k, { preview: true, origin: { x: r.x * dpr, y: r.y * dpr } });
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.globalAlpha = 0.32; ctx.drawImage(flatCanvas, 0, 0); ctx.restore();
    ctx.save(); ctx.beginPath(); ctx.rect(r.x, r.y, r.w, r.h); ctx.clip(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(flatCanvas, 0, 0); ctx.restore();
    if (!(opts && opts.fit)) { drawAreaOutline(a, r); drawZones(r); drawSelection(); }
  }
  /* zoner på den platta ytan: vilken del av tryckfilen som hamnar var (Fram / Undersida / Bak …) */
  function overlapFrac(a, b) {
    var iu = Math.max(0, Math.min(a.hi, b.hi) - Math.max(a.lo, b.lo)), iv = Math.max(0, Math.min(a.vhi, b.vhi) - Math.max(a.vlo, b.vlo));
    return (iu * iv) / Math.max(1e-6, Math.min(zoneArea(a), zoneArea(b)));
  }
  /* zonerna som ritas: huvudvyn först; zoner som överlappar en redan ritad zon (sidornas vikkanter) hoppas
     över, annars blir det rörigt */
  function flatZones() {
    if (!UV) return [];
    var y = TY.ytor[placement], views = y.vyer || [y.vy];
    var all = views.map(function (v) { return { view: v, z: viewZone(placement, v) }; }).filter(function (o) { return o.z && zoneArea(o.z) < 0.85; });
    all.sort(function (a, b) { return (a.view === y.vy ? -1 : 0) - (b.view === y.vy ? -1 : 0); });
    var zones = [];
    all.forEach(function (o) { if (!zones.some(function (q) { return overlapFrac(q.z, o.z) > 0.25; })) zones.push(o); });
    return zones;
  }
  /* Zonernas etiketter står som flikar ovanför tryckytan när zonen börjar i ytans överkant. Inne i hörnet
     hamnade "Fram" under bilden och markeringens hörnhandtag på muggen och lästes som "Fr am".
     flatRect lämnar raden fri. */
  var ZONE_TAB = 26; /* fliken är 20 px hög, plus 6 px luft ner till tryckytan */
  function zoneTabRoom() { return flatZones().some(function (o) { return o.z.vlo < 0.02; }) ? ZONE_TAB : 0; }
  /* Markeringens delar på scenen som en etikett inte får hamna under: handtagen (cirklar) och ramens
     kanter med skaftet upp till rotationspricken. */
  function selectionParts() {
    var l = selectedLayer(); if (!l) return null;
    var qd = layerQuad(l), segs = [];
    qd.edges.forEach(function (seg) { for (var i = 1; i < seg.length; i++) segs.push([seg[i - 1], seg[i]]); });
    segs.push([qd.top, qd.rot]);
    var dots = qd.corners.map(function (c) { return { x: c.x, y: c.y, r: HANDLE / 2 + 1 }; });
    dots.push({ x: qd.rot.x, y: qd.rot.y, r: 7 });
    return { segs: segs, dots: dots };
  }
  /* rör rutan b (med 3 px luft) något av markeringens handtag eller kanter? */
  function hitsSelection(b, parts) {
    if (!parts) return false;
    var x0 = b.x - 3, y0 = b.y - 3, x1 = b.x + b.w + 3, y1 = b.y + b.h + 3;
    var dot = function (d) { var nx = Math.max(x0, Math.min(x1, d.x)), ny = Math.max(y0, Math.min(y1, d.y)); return Math.hypot(d.x - nx, d.y - ny) <= d.r; };
    /* Liang–Barsky: skär sträckan a–c rutan? */
    var seg = function (sg) {
      var a = sg[0], c = sg[1], t0 = 0, t1 = 1, dx = c.x - a.x, dy = c.y - a.y;
      var P = [-dx, dx, -dy, dy], Q = [a.x - x0, x1 - a.x, a.y - y0, y1 - a.y];
      for (var i = 0; i < 4; i++) {
        if (P[i] === 0) { if (Q[i] < 0) return false; continue; }
        var t = Q[i] / P[i];
        if (P[i] < 0) { if (t > t1) return false; if (t > t0) t0 = t; }
        else { if (t < t0) return false; if (t < t1) t1 = t; }
      }
      return true;
    };
    return parts.dots.some(dot) || parts.segs.some(seg);
  }
  function drawZones(r) {
    var zones = flatZones();
    if (!zones.length) return;
    ctx.save();
    /* tona ned allt utanför huvudvyns zon */
    var mz = zones[0].z;
    ctx.fillStyle = 'rgba(31,31,31,0.06)';
    ctx.beginPath(); ctx.rect(r.x, r.y, r.w, r.h);
    ctx.rect(r.x + mz.lo * r.w, r.y + mz.vlo * r.h, (mz.hi - mz.lo) * r.w, (mz.vhi - mz.vlo) * r.h);
    ctx.fill('evenodd');
    ctx.font = '600 12px Outfit, sans-serif'; ctx.textBaseline = 'top';
    /* Markeringen ritas efter zonerna, så en etikett som når in under ett handtag eller en kant blir
       överstruken. Varje etikett prövar därför några platser i tur och ordning och tar den första som
       varken rör markeringen eller en annan etikett: flik ovanför ytan (zonen börjar i ytans överkant),
       annars zonens övre hörn, strax ovanför eller under zonen och sist zonens nedre hörn. */
    var parts = selectionParts(), placed = [];
    var free = function (b) {
      if (hitsSelection(b, parts)) return false;
      return !placed.some(function (t) { return b.x < t.x + t.w + 4 && t.x < b.x + b.w + 4 && b.y < t.y + t.h + 4 && t.y < b.y + b.h + 4; });
    };
    zones.forEach(function (o) {
      var z = o.z, x = r.x + z.lo * r.w, yy = r.y + z.vlo * r.h, w = (z.hi - z.lo) * r.w, h = (z.vhi - z.vlo) * r.h;
      ctx.setLineDash([4, 4]); ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(163,98,90,0.55)';
      ctx.strokeRect(x + 0.5, yy + 0.5, w - 1, h - 1);
      var name = viewLabel(o.view), tw = ctx.measureText(name).width + 14, th = 20;
      var spot = function (bx, by) { return { x: Math.max(4, Math.min(stageW - tw - 4, bx)), y: Math.max(4, Math.min(stageH - th - 4, by)), w: tw, h: th }; };
      var left = x + 6, right = x + w - tw - 6, top = yy + 6, bottom = yy + h - th - 6;
      var spots = z.vlo < 0.02
        ? [spot(x, r.y - ZONE_TAB), spot(x + w - tw, r.y - ZONE_TAB), spot(left, top), spot(right, top), spot(left, bottom), spot(right, bottom)]
        : [spot(left, top), spot(right, top), spot(x, yy - th - 4), spot(x, yy + h + 4), spot(left, bottom), spot(right, bottom)];
      var b = spots[0];
      for (var i = 0; i < spots.length; i++) { if (free(spots[i])) { b = spots[i]; break; } }
      placed.push(b);
      ctx.setLineDash([]); ctx.fillStyle = 'rgba(163,98,90,0.9)';
      if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(b.x, b.y, tw, th, 10); ctx.fill(); } else ctx.fillRect(b.x, b.y, tw, th);
      ctx.fillStyle = '#fff'; ctx.fillText(name, b.x + 7, b.y + 4);
    });
    ctx.restore();
  }
  var senasteMt = 0;
  function draw(opts) {
    if (!stageW) fitStage();
    var a = area();
    /* ändrad mallrubrik ändrar priset direkt (tillägget Egen text på mall) */
    if (MALLTEXT_VARIANT) { var mtNu = malltextCount(); if (mtNu !== senasteMt) { senasteMt = mtNu; renderOptions(); if (mtNu) toast('Egen text på mallen: +' + money(MALLTEXT_PRIS), 2600); } }
    updatePreviewNote(a); /* bildtext + verktygsrad i synk även när kartorna blir klara efter första ritningen */
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, stageW, stageH);
    if (a.flat) { drawFlat(a, opts); return; }
    if (mockKey !== a.src) {
      mockKey = a.src; mockImg = null;
      loadMock(a.src).then(function (im) { if (mockKey !== a.src) return; mockImg = im || false; scheduleDraw(); });
    }
    var pad = 8, nw, nh;
    if (mockImg) { nw = mockImg.naturalWidth; nh = mockImg.naturalHeight; }
    else if (mockImg === false) { nw = nh = 1200; }
    else return;
    /* mockupen (och den inzoomade tryckytan) passas in i scenens fria band – ovanför lägesväljaren och
       bildtexten som flyter nederst – så att de inte täcker trycket på en kort mobilscen */
    var band = stageBand(a), bandY = band.y, bandH = band.h;
    var fitS = Math.min((stageW - pad * 2) / nw, (bandH - pad * 2) / nh);
    var s = fitS, mw, mh, mx, my;
    if (isZoomed() && !(opts && opts.fit)) {
      var zs = Math.min((stageW - pad * 2) / (a.box.w * nw * 1.55), (bandH - pad * 2) / (a.box.h * nh * 1.55));
      s = Math.max(fitS, Math.min(zs, fitS * (arArm() ? 3.4 : 2.4)));
      mw = nw * s; mh = nh * s;
      mx = stageW / 2 - (a.box.l + a.box.w / 2) * mw;
      my = bandY + bandH / 2 - (a.box.t + a.box.h / 2) * mh;
      if (mw <= stageW) mx = (stageW - mw) / 2;
      if (mh <= bandH) my = bandY + (bandH - mh) / 2;
    } else {
      mw = nw * s; mh = nh * s; mx = (stageW - mw) / 2; my = bandY + (bandH - mh) / 2;
    }
    mockRect = { x: mx, y: my, w: mw, h: mh };
    var box = { x: mx + a.box.l * mw, y: my + a.box.t * mh, w: a.box.w * mw, h: a.box.h * mh };
    if (mockImg && a.uv) {
      ctx.drawImage(mockImg, mx, my, mw, mh);
      /* lägre upplösning medan ett lager eller arket dras: kompositeringen hinner inte med varje rörelse */
      var dragging = !!((drag && drag.mode !== 'none') || sheetDrag);
      composeUV(ctx, mockImg, a.view, { x: mx, y: my, w: mw, h: mh }, { scale: dpr, max: dragging ? 640 : 1100 }, true);
      /* ingen tonad "utanför"-bild i produktvyn – den hör hemma på den platta ytan */
    } else if (mockImg) {
      ctx.drawImage(mockImg, mx, my, mw, mh);
      composeOnMock(ctx, mockImg, a, box, dpr, true);
    } else {
      /* mockupen gick inte att ladda: visa tryckytan på neutral botten */
      ctx.fillStyle = '#ffffff'; ctx.fillRect(mx, my, mw, mh);
      var aw = Math.round(box.w * dpr);
      areaCanvas.width = aw; areaCanvas.height = Math.max(2, Math.round(aw / a.ar));
      renderArea(areaCanvas, aw / R_W, { preview: true });
      ctx.drawImage(areaCanvas, box.x, box.y, box.w, box.h);
    }
    if (!(opts && opts.fit)) {
      if (mockImg) drawVisibleEdge(a, { x: mx, y: my, w: mw, h: mh });
      /* ej redigerbar vy: inga handtag. Bildtexten (DOM) säger att ett tryck tar kunden dit det går att flytta */
      if (realEditable()) drawSelection();
    }
  }

  /* cylinderprojektion: tryckfilen (u 0–1) läggs runt produkten enligt kalibreringen.
     x i rutan = (cx − box.l + R·sin(S·(u − u0))) / box.w, i andel av rutans bredd */
  function drawWrapped(g, src, aw, ah, a) {
    var w = a.wrap, slices = Math.max(160, Math.min(400, Math.round(aw / 4)));
    var sw = src.width / slices;
    var xOf = function (u) { return (w.cx - a.box.l + w.R * Math.sin(Math.max(-Math.PI / 2, Math.min(Math.PI / 2, w.S * (u - w.u0))))) / a.box.w * aw; };
    for (var i = 0; i < slices; i++) {
      var u0 = i / slices, u1 = (i + 1) / slices;
      var am = w.S * ((u0 + u1) / 2 - w.u0);
      if (Math.abs(am) >= Math.PI / 2 - 0.01) continue;
      var x0 = xOf(u0), x1 = xOf(u1);
      if (x1 <= x0) continue;
      /* mjuk avtoning mot kanten där ytan viker undan */
      g.globalAlpha = Math.max(0, Math.min(1, Math.pow(Math.cos(am), 0.6) * 1.15));
      g.drawImage(src, i * sw, 0, sw, src.height, x0, 0, Math.max(1, x1 - x0 + 1.5), ah); /* liten överlappning döljer skarvarna */
    }
    g.globalAlpha = 1;
  }

  /* Scenens fria band: det som lägesväljaren nederst och platsen ovanför den inte täcker, och i det platta
     läget på små scener inte heller verktygsraden upptill, eftersom tryckytan med sina handtag fyller bandet
     där (i produktvyn ligger tryckytan redan med marginal). Platsen ovanför lägesväljaren delas av tipset och
     bildtexten, som står på samma höjd. Tipset ligger kvar osynligt i layouten när det gjort sitt (se
     updateHint), så bandet är detsamma före och efter första draget och produkten hoppar inte. Dolda element
     (display:none) tar ingen plats. Ett utfällt ark lämnar bara några rader scen, då får allt överlappa. */
  function stageBand(a) {
    var top = 0, bottom = 0, el;
    ['[data-mnd-modes]', '[data-mnd-preview-note]', '[data-mnd-hint]'].forEach(function (sel) {
      var b = q(sel);
      if (b && b.offsetHeight) bottom = Math.max(bottom, stageH - b.offsetTop);
    });
    if (a.flat && smallStage()) { el = q('[data-mnd-stage-top]'); if (el && el.offsetHeight) top = el.offsetTop + el.offsetHeight; }
    if (stageH - top - bottom < 80) { top = 0; bottom = 0; }
    return { y: top, h: Math.max(1, stageH - top - bottom) };
  }
  /* scen ↔ lagerkoordinater. Muggar: x projiceras på cylindern, y skalas mot tryckytans höjd. */
  function flatRect(a) {
    var band = stageBand(a), pad = Math.max(24, Math.min(stageW, stageH) * 0.12);
    /* 12 % marginal, men aldrig in i verktygsraden (uppe) eller lägesväljaren (nere). Zonernas flikar står
       ovanför ytan: då hålls deras rad fri från verktygsraden också på stora scener, utom när scenen är så
       kort att det inte går. */
    var padB = Math.max(pad, stageH - band.y - band.h + 6), padT = Math.max(pad, band.y + 6), tab = zoneTabRoom();
    if (tab) {
      var st = q('[data-mnd-stage-top]'), topEdge = band.y;
      if (st && st.offsetHeight) topEdge = Math.max(topEdge, st.offsetTop + st.offsetHeight);
      if (stageH - (topEdge + 6 + tab) - padB >= 80) padT = Math.max(pad, topEdge + 6 + tab);
    }
    var aw = Math.max(1, stageW - pad * 2), ah = Math.max(1, stageH - padT - padB);
    var w = aw, h = w / a.ar;
    if (h > ah) { h = ah; w = h * a.ar; }
    /* aldrig under en pixel: en hopklämd scen får inte ge en ruta med bredd eller höjd noll */
    w = Math.max(1, w); h = Math.max(1, h);
    return { x: (stageW - w) / 2, y: padT + (ah - h) / 2, w: w, h: h };
  }
  function boxOnStage(a) {
    if (a.flat) return flatRect(a);
    if (!mockRect) return { x: 0, y: 0, w: stageW, h: stageH };
    return { x: mockRect.x + a.box.l * mockRect.w, y: mockRect.y + a.box.t * mockRect.h, w: a.box.w * mockRect.w, h: a.box.h * mockRect.h };
  }
  function mapping() {
    var a = area(); var box = boxOnStage(a);
    var ky = box.h / areaH();
    if (a.uv && !a.flat) {
      var mr = mockRect || { x: 0, y: 0, w: stageW, h: stageH };
      var grid = viewMapsReady[a.view] ? forwardGrid(a.view, placement) : null;
      var maps = viewMapsReady[a.view], m = maps && maps[surf().grupp], y = surf();
      var aH = areaH(), G = grid ? grid.G : 1;
      var fwd = function (px, py) {
        if (!grid) return { x: box.x + px * (box.w / R_W), y: box.y + py * ky };
        var p = gridAt(grid, px / R_W, py / aH);
        return { x: mr.x + p.x * mr.w, y: mr.y + p.y * mr.h };
      };
      var scaleAt = function (px, py) {
        if (!grid) return { kx: box.w / R_W, ky: ky };
        var h = R_W / G;
        var p1 = fwd(px - h, py), p2 = fwd(px + h, py), p3 = fwd(px, py - h / (R_W / aH)), p4 = fwd(px, py + h / (R_W / aH));
        return { kx: Math.max(0.02, Math.hypot(p2.x - p1.x, p2.y - p1.y) / (2 * h)), ky: Math.max(0.02, Math.hypot(p4.x - p3.x, p4.y - p3.y) / (2 * h / (R_W / aH))) };
      };
      var mid = scaleAt(R_W / 2, aH / 2);
      return {
        uv: true, box: box, kx: mid.kx, ky: mid.ky,
        kxAt: function (px) { return scaleAt(px, aH / 2).kx; },
        scaleAt: scaleAt,
        toStage: fwd,
        toLayer: function (sx, sy) {
          var fx = (sx - mr.x) / mr.w, fy = (sy - mr.y) / mr.h;
          var hit = m ? mapAt(m, fx, fy, 6) : null;
          if (hit) {
            var su = (hit.u - y.del[0]) / (y.del[2] - y.del[0]), sv = (hit.v - y.del[1]) / (y.del[3] - y.del[1]);
            if (su >= -0.05 && su <= 1.05 && sv >= -0.05 && sv <= 1.05) return { x: su * R_W, y: sv * aH };
          }
          if (!grid) return { x: (sx - box.x) / (box.w / R_W), y: (sy - box.y) / ky };
          /* utanför trycket: närmaste rutnätsnod + lokal linjär lösning */
          var best = 0, bd = Infinity;
          for (var k = 0; k < grid.x.length; k++) { var dx = mr.x + grid.x[k] * mr.w - sx, dy = mr.y + grid.y[k] * mr.h - sy, dd = dx * dx + dy * dy; if (dd < bd) { bd = dd; best = k; } }
          var gi = best % (G + 1), gj = (best / (G + 1)) | 0;
          var px0 = gi / G * R_W, py0 = gj / G * aH, c0 = fwd(px0, py0);
          var i1 = Math.min(G, gi + 1) === gi ? gi - 1 : gi + 1, j1 = Math.min(G, gj + 1) === gj ? gj - 1 : gj + 1;
          var cu = fwd(i1 / G * R_W, py0), cv = fwd(px0, j1 / G * aH);
          var au = cu.x - c0.x, bu = cu.y - c0.y, av = cv.x - c0.x, bv = cv.y - c0.y, det = au * bv - av * bu;
          if (Math.abs(det) < 1e-6) return { x: px0, y: py0 };
          var rx = sx - c0.x, ry = sy - c0.y;
          var tu = (rx * bv - av * ry) / det, tv = (au * ry - bu * rx) / det;
          return { x: px0 + tu * ((i1 - gi) / G) * R_W, y: py0 + tv * ((j1 - gj) / G) * aH };
        }
      };
    }
    if (a.wrap) {
      var w = a.wrap, mr = mockRect || { x: 0, w: stageW };
      var K = w.R * mr.w, cx = mr.x + w.cx * mr.w;   /* radie och mittlinje på scenen */
      var kx0 = K * w.S / R_W;                          /* px på scenen per lager-px vid vinkel 0 */
      var ang = function (px) { return Math.max(-Math.PI / 2, Math.min(Math.PI / 2, w.S * (px / R_W - w.u0))); };
      return {
        wrap: true, box: box, ky: ky, kx: kx0,
        kxAt: function (px) { return kx0 * Math.max(0.2, Math.cos(ang(px))); },
        toStage: function (px, py) { return { x: cx + K * Math.sin(ang(px)), y: box.y + py * ky }; },
        toLayer: function (sx, sy) {
          var t = Math.asin(Math.max(-1, Math.min(1, (sx - cx) / K)));
          return { x: R_W * (w.u0 + t / w.S), y: (sy - box.y) / ky };
        }
      };
    }
    var kx = box.w / R_W;
    return {
      wrap: false, box: box, kx: kx, ky: ky,
      kxAt: function () { return kx; },
      toStage: function (px, py) { return { x: box.x + px * kx, y: box.y + py * ky }; },
      toLayer: function (sx, sy) { return { x: (sx - box.x) / kx, y: (sy - box.y) / ky }; }
    };
  }
  function toStage(px, py) {
    var m = mapping(); var p = m.toStage(px, py);
    if (m.scaleAt) { var sc = m.scaleAt(px, py); p.k = sc.kx; p.ky = sc.ky; } else { p.k = m.kxAt(px); p.ky = m.ky; }
    return p;
  }

  var HANDLE = 9;
  /* Vridpricken sitter längre ut på små scener (fingrar): där är flyttzonen runt bilden 16 px och
     prickens greppzon 16 px, så zonerna möts aldrig. Förut började vridzonen 8 px ovanför kanten, inne i
     flyttzonen, och ett drag som började strax ovanför bilden vred den i stället för att flytta den. */
  function rotOff() { return stageW < 700 ? 38 : 28; }

  /* tryckytans kontur (streckad) – som i Printifys/Gelatos editorer så att man ser var trycket hamnar */
  function surfacePath(a, g) {
    var N = 24, aH = areaH(), pts = [];
    var edge = function (fx0, fy0, fx1, fy1) { for (var i = 0; i < N; i++) { var t = i / N; pts.push(toStage((fx0 + (fx1 - fx0) * t) * R_W, (fy0 + (fy1 - fy0) * t) * aH)); } };
    if (a.uv && !a.flat) { edge(0, 0, 1, 0); edge(1, 0, 1, 1); edge(1, 1, 0, 1); edge(0, 1, 0, 0); }
    else { var b = boxOnStage(a); pts = [{ x: b.x, y: b.y }, { x: b.x + b.w, y: b.y }, { x: b.x + b.w, y: b.y + b.h }, { x: b.x, y: b.y + b.h }]; }
    g.beginPath();
    pts.forEach(function (p, i) { if (i) g.lineTo(p.x, p.y); else g.moveTo(p.x, p.y); });
    g.closePath();
    return pts;
  }
  function drawAreaOutline(a, box) {
    if (!mockRect && !a.flat) return;
    ctx.save();
    if (mockRect) { ctx.beginPath(); ctx.rect(mockRect.x, mockRect.y, mockRect.w, mockRect.h); ctx.clip(); }
    surfacePath(a, ctx);
    ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(255,255,255,0.55)'; ctx.setLineDash([]); ctx.stroke();
    ctx.lineWidth = 1.2; ctx.strokeStyle = 'rgba(31,31,31,0.55)'; ctx.setLineDash([6, 5]); ctx.stroke();
    ctx.restore();
  }
  /* markeringens hörn och kanter följer ytans form (perspektiv, rundning) */
  function layerQuad(l) {
    var b = layerBox(l), hw = b.w / 2, hh = b.h / 2, cos = Math.cos(l.rot), sin = Math.sin(l.rot);
    var at = function (lx, ly) { return toStage(l.x + lx * cos - ly * sin, l.y + lx * sin + ly * cos); };
    var corners = [at(-hw, -hh), at(hw, -hh), at(hw, hh), at(-hw, hh)];
    var edges = [];
    for (var e = 0; e < 4; e++) {
      var p0 = [[-hw, -hh], [hw, -hh], [hw, hh], [-hw, hh]][e], p1 = [[hw, -hh], [hw, hh], [-hw, hh], [-hw, -hh]][e];
      var seg = [];
      for (var i = 0; i <= 6; i++) { var t = i / 6; seg.push(at(p0[0] + (p1[0] - p0[0]) * t, p0[1] + (p1[1] - p0[1]) * t)); }
      edges.push(seg);
    }
    var top = at(0, -hh), c = at(0, 0);
    var up = { x: top.x - c.x, y: top.y - c.y }, len = Math.hypot(up.x, up.y) || 1;
    var ro = rotOff();
    var rotH = { x: top.x + up.x / len * ro, y: top.y + up.y / len * ro };
    return { corners: corners, edges: edges, top: top, rot: rotH, center: c };
  }
  /* det som hamnar utanför tryckytan visas tonat i stället för att bara försvinna (UV-läget) */
  var maskCanvasCache = {};
  function maskCanvasFor(m, key) {
    if (maskCanvasCache[key]) return maskCanvasCache[key];
    var c = document.createElement('canvas'); c.width = m.w; c.height = m.h;
    var d = c.getContext('2d').createImageData(m.w, m.h), p = d.data;
    for (var i = 0, j = 3; i < m.ok.length; i++, j += 4) if (m.ok[i]) p[j] = 255;
    c.getContext('2d').putImageData(d, 0, 0);
    maskCanvasCache[key] = c;
    return c;
  }
  var fadeCanvas = document.createElement('canvas');
  function drawOutsideFaded(g, a, rect) {
    if (!a.uv || a.flat || !sideHasContent(placement)) return;
    var maps = viewMapsReady[a.view]; var y = surf(); var m = maps && maps[y.grupp];
    var grid = m ? forwardGrid(a.view, placement) : null;
    if (!grid) return;
    /* ytans lager som platt bild */
    var sc = document.createElement('canvas'), kW = 700, arS = area().ar;
    sc.width = kW; sc.height = Math.max(2, Math.round(kW / arS));
    renderArea(sc, kW / R_W, { preview: true });
    var W = Math.round(stageW * dpr), H = Math.round(stageH * dpr);
    fadeCanvas.width = W; fadeCanvas.height = H;
    var f = fadeCanvas.getContext('2d');
    f.setTransform(dpr, 0, 0, dpr, 0, 0);
    /* nät av trianglar över ytan (0–1) → scenen via rutnätet */
    var G = grid.G, step = 6, mr = mockRect;
    var P = function (i, j) { var k = j * (G + 1) + i; return { x: mr.x + grid.x[k] * mr.w, y: mr.y + grid.y[k] * mr.h }; };
    var tri = function (s0, s1, s2, d0, d1, d2) {
      var det = (s1.x - s0.x) * (s2.y - s0.y) - (s2.x - s0.x) * (s1.y - s0.y); if (Math.abs(det) < 1e-6) return;
      var A = ((d1.x - d0.x) * (s2.y - s0.y) - (d2.x - d0.x) * (s1.y - s0.y)) / det;
      var B = ((d1.y - d0.y) * (s2.y - s0.y) - (d2.y - d0.y) * (s1.y - s0.y)) / det;
      var C = ((d2.x - d0.x) * (s1.x - s0.x) - (d1.x - d0.x) * (s2.x - s0.x)) / det;
      var D = ((d2.y - d0.y) * (s1.x - s0.x) - (d1.y - d0.y) * (s2.x - s0.x)) / det;
      var E = d0.x - A * s0.x - C * s0.y, F = d0.y - B * s0.x - D * s0.y;
      f.save(); f.beginPath();
      /* liten utvidgning av triangeln döljer skarvar */
      var cx = (d0.x + d1.x + d2.x) / 3, cy = (d0.y + d1.y + d2.y) / 3;
      [d0, d1, d2].forEach(function (d, i) { var ex = d.x + (d.x - cx) * 0.03, ey = d.y + (d.y - cy) * 0.03; if (i) f.lineTo(ex, ey); else f.moveTo(ex, ey); });
      f.closePath(); f.clip();
      f.transform(A, B, C, D, E, F);
      f.drawImage(sc, 0, 0);
      f.restore();
    };
    for (var j = 0; j < G; j += step) for (var i = 0; i < G; i += step) {
      var i2 = Math.min(G, i + step), j2 = Math.min(G, j + step);
      var s00 = { x: i / G * sc.width, y: j / G * sc.height }, s10 = { x: i2 / G * sc.width, y: j / G * sc.height }, s01 = { x: i / G * sc.width, y: j2 / G * sc.height }, s11 = { x: i2 / G * sc.width, y: j2 / G * sc.height };
      tri(s00, s10, s11, P(i, j), P(i2, j), P(i2, j2));
      tri(s00, s11, s01, P(i, j), P(i2, j2), P(i, j2));
    }
    /* ta bort det som ligger innanför tryckytan (ritas exakt av composeUV) */
    f.globalCompositeOperation = 'destination-out';
    f.drawImage(maskCanvasFor(m, a.view + '|' + y.grupp), rect.x, rect.y, rect.w, rect.h);
    f.globalCompositeOperation = 'source-over';
    g.save(); g.globalAlpha = 0.32;
    g.beginPath(); g.rect(mockRect.x, mockRect.y, mockRect.w, mockRect.h); g.clip();
    g.setTransform(1, 0, 0, 1, 0, 0); g.drawImage(fadeCanvas, 0, 0); g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.restore();
  }

  /* Får man flytta och skala direkt i produktvyn? 'ja', 'nej' eller 'vanta'. Bara när kartläggningen är
     verifierat exakt (fel < 2 %), annars visar vyn hur det blir och ett tryck tar kunden till hela tryckytan.
     'nej' kommer ur produktens metadata (speglad eller vriden vy, vyn visar bara en del av ytan) eller ur en
     färdigladdad karta. Medan kartan laddas är svaret 'vanta': då händer ingenting vid ett tryck, och varken
     verktygen, tipset eller bildtexten visas, så att inget hinner blinka förbi innan svaret är klart. */
  function realState() {
    var a = area();
    if (!a.uv || a.flat) return 'ja';
    if (a.editable === false) return 'nej';
    var z = viewZone(placement, a.view);
    if (z && zoneArea(z) < 0.85) return 'nej';          /* vyn visar bara en del av ytan (väska, mugg) */
    if (!viewMapsReady[a.view]) return 'vanta';
    var grid = forwardGrid(a.view, placement);
    return grid && grid.err < 0.02 ? 'ja' : 'nej';
  }
  function realEditable() { return realState() === 'ja'; }
  /* konturen i produktvyn: kanten av det tryck som faktiskt syns (ur kartan) – aldrig extrapolerad */
  var edgeCache = {};
  function edgeCanvasFor(m, key) {
    if (edgeCache[key]) return edgeCache[key];
    var mask = maskCanvasFor(m, key);
    var c = document.createElement('canvas'); c.width = m.w; c.height = m.h;
    var g = c.getContext('2d');
    g.fillStyle = '#1f1f1f';
    [[1.5, 0], [-1.5, 0], [0, 1.5], [0, -1.5], [1, 1], [-1, -1], [1, -1], [-1, 1]].forEach(function (o) { g.drawImage(mask, o[0], o[1]); });
    g.globalCompositeOperation = 'source-in'; g.fillRect(0, 0, c.width, c.height);
    g.globalCompositeOperation = 'destination-out'; g.drawImage(mask, 0, 0);
    edgeCache[key] = c;
    return c;
  }
  function drawVisibleEdge(a, rect) {
    var maps = viewMapsReady[a.view]; var y = surf(); var m = maps && maps[y.grupp];
    if (!m) return;
    /* Syns hela ytan och är kartan jämn (samma villkor som för att få redigera i vyn) ritas
       tryckytans kant genom polynomanpassningen, som är slät per konstruktion men följer
       produktens perspektiv och böj. Kartans egen pixelkant bär kalibreringens brus i kanten,
       och på en tröja blev linjen runt tryckytan full av små hack och utbuktningar. */
    if (realEditable()) {
      var grid = forwardGrid(a.view, placement);
      if (grid) {
        var N = 48, forsta = true;
        ctx.save();
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = '#1f1f1f';
        ctx.lineWidth = Math.max(1, 1.1 * dpr);
        ctx.lineJoin = 'round';
        ctx.beginPath();
        var punkt = function (su, sv) {
          var p = gridAt(grid, su, sv), X = rect.x + p.x * rect.w, Y = rect.y + p.y * rect.h;
          if (forsta) { ctx.moveTo(X, Y); forsta = false; } else ctx.lineTo(X, Y);
        };
        for (var i = 0; i <= N; i++) punkt(i / N, 0);
        for (var j = 1; j <= N; j++) punkt(1, j / N);
        for (var i2 = N - 1; i2 >= 0; i2--) punkt(i2 / N, 1);
        for (var j2 = N - 1; j2 > 0; j2--) punkt(0, j2 / N);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
        return;
      }
    }
    /* Vyer där bara en del av ytan syns (mugg, flaska, väska): kartans kant, lätt mjukad så att
       enstaka pixelsteg inte syns som hack. Här kan kanten inte räknas fram ur polynomet, eftersom
       det skulle rita ut delar av ytan som ligger på baksidan av produkten. */
    ctx.save(); ctx.globalAlpha = 0.45; ctx.imageSmoothingEnabled = true;
    if ('filter' in ctx) ctx.filter = 'blur(' + (0.6 * dpr).toFixed(2) + 'px)';
    ctx.drawImage(edgeCanvasFor(m, a.view + '|' + y.grupp), rect.x, rect.y, rect.w, rect.h);
    ctx.restore();
  }
  function viewLabel(view) { var n = VIEW_NAMES[view] || 'fram'; return n.charAt(0).toUpperCase() + n.slice(1); }
  function smallStage() { return (stageW || root.clientWidth) < 700; }
  /* Bildtexten (DOM-element ovanför lägesväljaren, mn_designer_tap_note) visas när produktvyn inte går att
     redigera i och säger vad ett tryck gör. Samtidigt döljs verktygsraden, och tipset lämnar plats åt
     bildtexten. Anropas från draw() så att allt hänger med när kartorna blir klara. */
  function updatePreviewNote(a) {
    var note = q('[data-mnd-preview-note]'), empty = q('[data-mnd-empty]');
    var st = a && a.uv && !a.flat ? realState() : 'ja';
    /* allt här döljs också medan tomma-läget täcker scenen (som lägesväljaren) */
    var emptyOn = !!(empty && !empty.hidden);
    if (note) {
      if (note.textContent !== TXT_TAP_NOTE) note.textContent = TXT_TAP_NOTE;
      note.hidden = st !== 'nej' || emptyOn;
    }
    var sel = selectedLayer();
    q('[data-mnd-seltools]').hidden = !sel || st !== 'ja';
    updateHint(st, emptyOn);
    updateBgQuick(st, emptyOn);
    renderCtx();
  }
  /* ---------- Textraden (stående mobil): typsnitt, färg och symbol för den markerade texten ----------
     Det man nästan alltid vill göra med en text ska inte kräva att arket fälls ut och menyn öppnas.
     Raden har samma knappar och data-attribut som Ändra-menyn (data-font, data-color, data-sym + data-id),
     så att lyssnarna på root gör jobbet. Den ritas om bara när något den visar ändras: draw() anropar
     den hela tiden, och en omritning mitt i ett tryck hade tappat trycket. Medan raden syns står
     produktvalen undan (CSS) – ett tryck bredvid texten avmarkerar den och tar fram dem igen. */
  var ctxEl = q('[data-mnd-ctx]'), ctxKey = '', ctxTab = 'font';
  function renderCtx() {
    if (!ctxEl) return;
    var l = selectedLayer();
    var on = !!(l && l.type === 'text' && phonePortrait() && bottomSheet() && sheet === 'peek');
    root.classList.toggle('mnd--ctx', on);
    if (!on) { if (!ctxEl.hidden) { ctxEl.hidden = true; ctxKey = ''; measurePeek(); } return; }
    var flikar = [['font', '<b class="mnd__ctx-aa">Aa</b>', 'Typsnitt']];
    if (!ENGRAVE) flikar.push(['color', '<i class="mnd__ctx-dot" style="background:' + esc(l.color) + '"></i>', 'Färg']);
    if (SYMBOLER.length) flikar.push(['sym', '<b>' + esc(SYMBOLER[0]) + '</b>', 'Symbol']);
    flikar.push(['rikt', '<b>↻</b>', 'Placering']);
    if (!flikar.some(function (f) { return f[0] === ctxTab; })) ctxTab = 'font';
    var prov = String(l.text || '').trim().split('\n')[0].slice(0, 10) || 'Abc';
    var key = [l.id, l.font, l.color, prov, ctxTab, Math.round(l.rot * 100)].join('|');
    var visades = !ctxEl.hidden;
    ctxEl.hidden = false;
    if (key === ctxKey) return;
    var strip = q('.mnd__ctx-strip', ctxEl);
    var left = strip && ctxKey.split('|')[4] === ctxTab && ctxKey.split('|')[0] === l.id ? strip.scrollLeft : 0;
    ctxKey = key;
    var id = ' data-id="' + l.id + '"', inne;
    if (ctxTab === 'color') {
      inne = TEXT_COLORS.map(function (c) { return '<button type="button" class="mnd__swatch' + (l.color === c ? ' is-on' : '') + '" style="background:' + c + '" data-color="' + c + '"' + id + ' aria-label="Färg ' + c + '"></button>'; }).join('');
    } else if (ctxTab === 'rikt') {
      inne = riktKnappar(l);
    } else if (ctxTab === 'sym') {
      inne = SYMBOLER.map(function (c) { return '<button type="button" class="mnd__sym" data-sym="' + esc(c) + '"' + id + ' aria-label="Lägg till ' + esc(c) + '">' + esc(c) + '</button>'; }).join('');
    } else {
      inne = FONTS.map(function (f) { return '<button type="button" class="mnd__cfont' + (l.font === f[0] ? ' is-on' : '') + '" data-font="' + f[0] + '"' + id + ' aria-label="' + f[1] + '"><span style="font-family:\'' + f[0] + '\';font-weight:' + f[2] + '">' + esc(prov) + '</span></button>'; }).join('');
    }
    ctxEl.innerHTML = '<div class="mnd__ctx-tabs" role="tablist" aria-label="Texten">' + flikar.map(function (f) {
      return '<button type="button" role="tab" class="mnd__ctx-tab' + (f[0] === ctxTab ? ' is-on' : '') + '" data-ctx-tab="' + f[0] + '" aria-selected="' + (f[0] === ctxTab) + '">' + f[1] + '<span>' + f[2] + '</span></button>';
    }).join('') + '</div><div class="mnd__ctx-strip">' + inne + '</div>';
    q('.mnd__ctx-strip', ctxEl).scrollLeft = left;
    if (!visades) { measurePeek(); setTimeout(function () { fitStage(); scheduleDraw(); }, 0); }
  }
  if (ctxEl) {
    ctxEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ctx-tab]');
      if (t) { ctxTab = t.dataset.ctxTab; renderCtx(); }
    });
    /* trycket på raden får inte ta fokus från texten man skriver i: tangentbordet stannar uppe */
    var behallFokus = function (e) { if (e.target.closest('button') && stage.querySelector('.mnd__inline')) e.preventDefault(); };
    ctxEl.addEventListener('pointerdown', behallFokus);
    ctxEl.addEventListener('mousedown', behallFokus);
  }
  /* fältet man skriver i på plagget följer med när typsnitt, färg eller text ändras från en knapp */
  function syncInline(l) {
    var ta = stage.querySelector('.mnd__inline');
    if (!ta || !l || inlineId !== l.id) return;
    if (ta.value !== l.text) ta.value = l.text;
    if (ta._folj) ta._folj();
  }
  /* Ta bort bakgrunden direkt på produkten (stående mobil, CSS). Gäller den markerade bilden, eller den
     enda bilden på ytan när inget är markerat. Samma reglage och samma texter som bildkortets chip. */
  var bgQuick = q('[data-mnd-bgquick]');
  function bgTarget() {
    var l = selectedLayer();
    if (l && l.type === 'image') return l;
    var imgs = layers.filter(function (x) { return x.type === 'image' && !x.fast; });
    return imgs.length === 1 ? imgs[0] : null;
  }
  function updateBgQuick(st, emptyOn) {
    if (!bgQuick) return;
    var l = bgTarget();
    bgQuick.hidden = BRODYR || !l || emptyOn || st === 'vanta';
    if (bgQuick.hidden) return;
    var removed = !l.bg;
    var txt = removed ? TXT_BG_ON : TXT_BG_OFF;
    var span = q('[data-mnd-bgquick-text]', bgQuick);
    if (span.textContent !== txt) span.textContent = txt;
    bgQuick.setAttribute('aria-pressed', removed ? 'true' : 'false');
    bgQuick.classList.toggle('is-on', removed);
  }
  /* kort besked på scenen som försvinner av sig själv (ett tryck tar bort det direkt) */
  var toastEl = q('[data-mnd-toast]'), toastTimer = null;
  function toast(text, ms) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.textContent = text;
    toastEl.hidden = false;
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, ms || 7000);
  }
  if (toastEl) toastEl.addEventListener('click', function () { clearTimeout(toastTimer); toastEl.hidden = true; });
  /* Tipset om hur man flyttar syns första gången det finns något på scenen och tonas bort när kunden börjat
     dra (hintDone, se ensureCommitted). Det kommer inte tillbaka under besöket. Elementet ligger kvar
     osynligt i layouten så länge scenen har innehåll: stageBand räknar då med samma plats hela tiden, och
     produkten hoppar inte när tipset försvinner mitt i första draget. I en vy som inte går att redigera i
     står bildtexten på samma plats i stället. */
  var hintDone = false;
  function updateHint(st, emptyOn) {
    var h = q('[data-mnd-hint]');
    if (!h) return;
    h.hidden = emptyOn || st === 'nej';
    h.classList.toggle('is-on', !hintDone && st === 'ja' && sideHasContent(placement));
  }
  function drawSelection() {
    if (inlineId) return; /* inga handtag medan texten redigeras på plats */
    var l = selectedLayer();
    if (!l) return;
    var qd = layerQuad(l);
    ctx.save();
    ctx.strokeStyle = '#1f1f1f'; ctx.lineWidth = 1.2; ctx.setLineDash([]);
    ctx.beginPath();
    qd.edges.forEach(function (seg) { seg.forEach(function (p, i) { if (i === 0 && seg === qd.edges[0]) ctx.moveTo(p.x, p.y); else ctx.lineTo(p.x, p.y); }); });
    ctx.closePath(); ctx.stroke();
    ctx.fillStyle = '#ffffff';
    qd.corners.forEach(function (p) { ctx.beginPath(); ctx.arc(p.x, p.y, HANDLE / 2 + 1, 0, Math.PI * 2); ctx.fill(); ctx.stroke(); });
    var ux = qd.rot.x - qd.top.x, uy = qd.rot.y - qd.top.y, ul = Math.hypot(ux, uy) || 1;
    ctx.beginPath(); ctx.moveTo(qd.top.x, qd.top.y); ctx.lineTo(qd.rot.x - ux / ul * 6, qd.rot.y - uy / ul * 6); ctx.stroke();
    ctx.beginPath(); ctx.arc(qd.rot.x, qd.rot.y, 7, 0, Math.PI * 2); ctx.fillStyle = '#d9958e'; ctx.fill(); ctx.stroke();
    ctx.restore();
    if (guides.v || guides.h) {
      var box = boxOnStage(area());
      ctx.save(); ctx.strokeStyle = 'rgba(217,149,142,0.9)'; ctx.setLineDash([4, 4]); ctx.lineWidth = 1;
      if (guides.v) { var vr2 = visibleRange(area()), gx = toStage(R_W * (vr2.lo + vr2.hi) / 2, 0).x; ctx.beginPath(); ctx.moveTo(gx, box.y); ctx.lineTo(gx, box.y + box.h); ctx.stroke(); }
      if (guides.h) { ctx.beginPath(); ctx.moveTo(box.x, box.y + box.h / 2); ctx.lineTo(box.x + box.w, box.y + box.h / 2); ctx.stroke(); }
      ctx.restore();
    }
  }

  /* ---------- Pekare: flytta, skala, rotera, pinch ---------- */

  var guides = { v: false, h: false };
  var drag = null;
  var pointers = {};

  function hitTest(sx, sy) {
    var l = selectedLayer();
    var small = stageW < 700, grab = small ? 20 : 14, rotGrab = small ? 16 : 14, pad = small ? 22 : 10;
    if (l) {
      var qd = layerQuad(l);
      if (Math.hypot(sx - qd.rot.x, sy - qd.rot.y) <= rotGrab) return { mode: 'rotate', layer: l };
      for (var i = 0; i < 4; i++) if (Math.hypot(sx - qd.corners[i].x, sy - qd.corners[i].y) <= grab) return { mode: 'scale', layer: l, corner: i };
    }
    var inside = function (pt, poly) {
      var ok = false;
      for (var a = 0, b = poly.length - 1; a < poly.length; b = a++) {
        if ((poly[a].y > pt.y) !== (poly[b].y > pt.y) && pt.x < (poly[b].x - poly[a].x) * (pt.y - poly[a].y) / (poly[b].y - poly[a].y) + poly[a].x) ok = !ok;
      }
      return ok;
    };
    for (var j = layers.length - 1; j >= 0; j--) {
      var L = layers[j], q2 = layerQuad(L), poly = [];
      if (L.fast) continue;   /* låst tryck: kan varken flyttas, skalas eller roteras */
      q2.edges.forEach(function (seg) { seg.slice(0, -1).forEach(function (p) { poly.push(p); }); });
      /* lite marginal runt om (10 px, 16 px på små scener) */
      var cx = q2.center.x, cy = q2.center.y;
      var padded = poly.map(function (p) { var dx = p.x - cx, dy = p.y - cy, d = Math.hypot(dx, dy) || 1; return { x: p.x + dx / d * pad, y: p.y + dy / d * pad }; });
      if (inside({ x: sx, y: sy }, padded)) return { mode: 'move', layer: L };
    }
    return null;
  }

  function pos(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }

  /* ---------- Redigera text direkt på plagget ---------- */
  var inlineId = null, lastTap = null, textStart = false;
  function inlineEdit(l) {
    if (!l || l.type !== 'text') return;
    inlineStop();
    commit(); selected = l.id; inlineId = l.id;
    var ta = document.createElement('textarea');
    ta.className = 'mnd__inline'; ta.rows = 1; ta.maxLength = 60; ta.value = l.text || ''; ta.placeholder = (/sleeve/.test(String(placement)) || area().ar < 0.6) ? 'Ett namn per rad' : 'Skriv här';
    ta.setAttribute('aria-label', 'Redigera texten'); ta.setAttribute('data-inline', l.id);
    stage.appendChild(ta);
    var placera = function () {
      var c = toStage(l.x, l.y), px = Math.max(16, l.size * c.k);
      ta.style.font = fontString(l, px); ta.style.color = l.color; ta.style.textAlign = l.align || 'center';
      ta.style.left = c.x + 'px'; ta.style.top = c.y + 'px'; ta.style.transform = 'translate(-50%, -50%) rotate(' + l.rot + 'rad)';
      ta.style.width = 'auto'; ta.style.height = 'auto';
      var rader = String(ta.value || ta.placeholder).split('\n'), m = measureText(l, ctx);
      ta.style.width = Math.max(80, m.w * c.k + px) + 'px'; ta.style.height = Math.max(px * 1.4, rader.length * px * 1.15 + px * 0.4) + 'px';
    };
    ta.addEventListener('input', function () { if (ta.value.indexOf('\n') >= 0 && (ta.value.match(/\n/g) || []).length > 3) ta.value = ta.value.replace(/\n(?=[^\n]*$)/, ' '); l.text = ta.value; passaArm(l); var p = q('[data-mnd-text-layers] textarea[data-id="' + l.id + '"]'); if (p) { p.value = ta.value; fitTa(p); } placera(); scheduleDraw();
      /* köpknappen ska säga "Välj storlek"/"Lägg i varukorgen" så fort det finns text – inte "Ladda upp en bild" medan man skriver */
      if (!!ta.value.trim() !== ta._hade) { ta._hade = !!ta.value.trim(); renderOptions(); }
    });
    /* På ärmen (och andra smala ytor) ger Enter en ny rad: namnen ska stå över varandra, som på förebilden.
       Man blir klar genom att trycka bredvid. På bröstet avslutar Enter som förut (Shift+Enter = ny rad). */
    /* mobil: ett svep i skrivfältet flyttar texten i stället för att göra ingenting */
    var tStart = null;
    ta.addEventListener('touchstart', function (e) { var t = e.touches[0]; tStart = { x: t.clientX, y: t.clientY, lx: l.x, ly: l.y, flyttar: false }; }, { passive: true });
    ta.addEventListener('touchmove', function (e) {
      if (!tStart) return; var t = e.touches[0], dx = t.clientX - tStart.x, dy = t.clientY - tStart.y;
      if (!tStart.flyttar && Math.hypot(dx, dy) < 8) return;
      if (!tStart.flyttar) { tStart.flyttar = true; commit(); }
      var m = mapping(), r = canvas.getBoundingClientRect(), a0 = m.toLayer(tStart.x - r.left, tStart.y - r.top), a1 = m.toLayer(t.clientX - r.left, t.clientY - r.top);
      l.x = tStart.lx + (a1.x - a0.x); l.y = tStart.ly + (a1.y - a0.y); clampLayer(l);
      e.preventDefault(); placera(); scheduleDraw();
    }, { passive: false });
    ta.addEventListener('touchend', function () { tStart = null; });
    ta.addEventListener('keydown', function (e) {
      var arm = /sleeve/.test(String(placement)) || area().ar < 0.6;
      if (e.key === 'Enter' && !e.shiftKey && arm && (ta.value.match(/\n/g) || []).length < 3) { return; }
      if (e.key === 'Escape' || (e.key === 'Enter' && !e.shiftKey)) { e.preventDefault(); e.stopPropagation(); inlineStop(); }
    });
    /* bara om det fortfarande är det här fältet som redigeras (ett nytt kan ha ersatt det) */
    ta.addEventListener('blur', function () { setTimeout(function () { if (stage.querySelector('.mnd__inline') === ta) inlineStop(); }, 0); });
    /* tangentbordet på mobil krymper skärmen: scenen ritas om, fältet följer med */
    ta._folj = function () { requestAnimationFrame(placera); };
    if (window.visualViewport) window.visualViewport.addEventListener('resize', ta._folj);
    window.addEventListener('resize', ta._folj);
    placera(); draw();
    ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length);
    setTimeout(fitToViewport, 50);
  }
  function inlineStop() {
    var ta = stage.querySelector('.mnd__inline');
    if (!ta) { inlineId = null; return; }
    var l = layerById(inlineId); inlineId = null;
    if (ta._folj) { if (window.visualViewport) window.visualViewport.removeEventListener('resize', ta._folj); window.removeEventListener('resize', ta._folj); }
    ta.remove();
    if (l) { l.text = ta.value; renderPanels(); }
    draw();
    setTimeout(fitToViewport, 50);
  }
  canvas.addEventListener('dblclick', function (e) {
    var p = pos(e), hit = hitTest(p.x, p.y);
    if (hit && hit.layer && hit.layer.type === 'text') { e.preventDefault(); drag = null; inlineEdit(hit.layer); }
  });

  /* anropas vid första rörelsen i varje drag (flytta, skala, rotera, nypa) */
  function ensureCommitted() {
    if (drag && !drag.committed) { pushHistory(drag.before); drag.committed = true; }
    /* kunden har börjat dra: tipset har gjort sitt och tonas bort (platsen står kvar, se updateHint) */
    if (!hintDone) { hintDone = true; var h = q('[data-mnd-hint]'); if (h) h.classList.remove('is-on'); }
  }
  /* Ett tryck eller drag på en produktvy som inte går att redigera i (mugg, flaska, väska) byter till hela
     tryckytan, där bilden går att flytta och skala, så att kunden inte hamnar i en återvändsgränd där
     ingenting händer. Det översta lagret markeras om inget är valt, så att handtagen syns direkt. */
  function flatFromPreview() {
    modes[placement] = 'flat';
    if (!selectedLayer() && layers.length) selected = layers[layers.length - 1].id;
    renderPanels(); draw();
  }

  canvas.addEventListener('pointerdown', function (e) {
    var st = realState();
    /* Muggen, flaskan, väskan: trycket byter till hela trycket och samma drag fortsätter där. Förut
       flyttade första draget ingenting, bara bytet syntes, och kunden fick dra en gång till. */
    var fromPreview = false;
    if (st === 'nej') { e.preventDefault(); flatFromPreview(); st = realState(); fromPreview = true; }
    if (st !== 'ja') return; /* kartan laddas fortfarande: svaret kommer strax */
    var p = pos(e);
    pointers[e.pointerId] = p;
    try { canvas.setPointerCapture(e.pointerId); } catch (err) { /* syntetiska pekare saknar id */ }
    if (document.activeElement && document.activeElement.blur && document.activeElement !== document.body) document.activeElement.blur();
    var ids = Object.keys(pointers);
    if (ids.length >= 2) {
      /* pinch: skala + rotera valt lager (eller det man siktar på / det senaste) */
      var L = selectedLayer() || (drag && drag.layer) || (hitTest(p.x, p.y) || {}).layer || layers[layers.length - 1];
      if (!L) return;
      selected = L.id;
      var before = drag && drag.before ? drag.before : snapshot();
      var committed = !!(drag && drag.committed);
      var p1 = pointers[ids[0]], p2 = pointers[ids[1]];
      drag = { mode: 'pinch', layer: L, ids: [ids[0], ids[1]], before: before, committed: committed, d0: Math.hypot(p2.x - p1.x, p2.y - p1.y), a0: Math.atan2(p2.y - p1.y, p2.x - p1.x), w0: L.type === 'image' ? L.w : L.size, r0: L.rot };
      renderPanels();
      return;
    }
    var hit = hitTest(p.x, p.y);
    /* dubbeltryck på en text: redigera den direkt på plagget (musens dblclick fångas separat) */
    var nu = Date.now();
    if (hit && hit.mode === 'move' && hit.layer.type === 'text' && lastTap && lastTap.id === hit.layer.id && nu - lastTap.t < 400 && e.pointerType !== 'mouse') {
      lastTap = null; delete pointers[e.pointerId]; e.preventDefault(); inlineEdit(hit.layer); return;
    }
    lastTap = hit && hit.layer && hit.layer.type === 'text' ? { id: hit.layer.id, t: nu } : null;
    /* efter bytet ligger bilden på ett annat ställe än fingret: draget flyttar den markerade bilden ändå */
    if (!hit && fromPreview && selectedLayer()) hit = { mode: 'move', layer: selectedLayer() };
    if (!hit) { drag = { mode: 'none', pointerId: e.pointerId, before: snapshot(), start: p }; return; }
    /* ett tryck med fingret på en text som redan är markerad öppnar den för skrivning (se endDrag) */
    var tapEdit = hit.mode === 'move' && hit.layer.type === 'text' && selected === hit.layer.id && e.pointerType !== 'mouse';
    selected = hit.layer.id;
    renderPanels();
    var l = hit.layer; var c = toStage(l.x, l.y);
    drag = { mode: hit.mode, layer: l, pointerId: e.pointerId, before: snapshot(), committed: false, tapEdit: tapEdit, start: p, x0: l.x, y0: l.y, w0: l.type === 'image' ? l.w : l.size, r0: l.rot, cx: c.x, cy: c.y, d0: Math.hypot(p.x - c.x, p.y - c.y), a0: Math.atan2(p.y - c.y, p.x - c.x) };
    draw();
    e.preventDefault();
  });

  canvas.addEventListener('pointermove', function (e) {
    if (pointers[e.pointerId]) pointers[e.pointerId] = pos(e);
    if (!drag || drag.mode === 'none') {
      if (!drag) {
        var st = realState(), h = st === 'ja' ? hitTest(pos(e).x, pos(e).y) : null;
        /* en vy som inte går att redigera i är klickbar i sin helhet (klicket byter till hela tryckytan) */
        canvas.style.cursor = h ? (h.mode === 'rotate' ? 'grab' : h.mode === 'scale' ? 'nwse-resize' : 'move') : st === 'nej' ? 'pointer' : 'default';
      }
      return;
    }
    var p = pos(e);
    var l = drag.layer;
    if (drag.mode === 'pinch') {
      if (drag.ids.indexOf(String(e.pointerId)) < 0) return;
      var p1 = pointers[drag.ids[0]], p2 = pointers[drag.ids[1]];
      if (!p1 || !p2) return;
      ensureCommitted();
      var d = Math.hypot(p2.x - p1.x, p2.y - p1.y), a = Math.atan2(p2.y - p1.y, p2.x - p1.x);
      /* dämpad: halva fingerrörelsen, och aldrig mer än dubbelt/hälften per nyp – rå skalning gjorde texten jättestor av en liten rörelse */
      var f = Math.max(0.5, Math.min(2, 1 + (d / drag.d0 - 1) * 0.5));
      setSize(l, drag.w0 * f);
      var dv = a - drag.a0; if (Math.abs(dv) > 0.08) l.rot = drag.r0 + dv;
    } else {
      if (e.pointerId !== drag.pointerId) return;
      if (drag.mode === 'move') {
        var m = mapping();
        var a0 = m.toLayer(drag.start.x, drag.start.y), a1 = m.toLayer(p.x, p.y);
        if (Math.hypot(p.x - drag.start.x, p.y - drag.start.y) < 2 && !drag.committed) return;
        ensureCommitted();
        l.x = drag.x0 + (a1.x - a0.x);
        l.y = drag.y0 + (a1.y - a0.y);
        var th = 8 / m.kx, vr = visibleRange(area()), vc = R_W * (vr.lo + vr.hi) / 2;
        guides.v = Math.abs(l.x - vc) < th; if (guides.v) l.x = vc;
        guides.h = Math.abs(l.y - areaH() / 2) < th; if (guides.h) l.y = areaH() / 2;
        clampLayer(l);
      } else if (drag.mode === 'scale') {
        ensureCommitted();
        var d2 = Math.hypot(p.x - drag.cx, p.y - drag.cy);
        setSize(l, drag.w0 * Math.max(0.05, d2 / drag.d0));
      } else if (drag.mode === 'rotate') {
        ensureCommitted();
        var ang = Math.atan2(p.y - drag.cy, p.x - drag.cx);
        var rot = drag.r0 + (ang - drag.a0);
        var snapTo = Math.round(rot / (Math.PI / 2)) * (Math.PI / 2);
        l.rot = Math.abs(rot - snapTo) < 0.06 ? snapTo : rot;
      }
    }
    scheduleDraw();
    syncPanelValues();
  });

  function endDrag(e) {
    delete pointers[e.pointerId];
    if (!drag) return;
    if (drag.mode === 'pinch') {
      if (drag.ids.indexOf(String(e.pointerId)) >= 0) drag = null;
    } else if (drag.mode === 'none') {
      /* avmarkera bara vid ett tryck – ett svep över tomt område (mobil) ska inte tappa markeringen */
      if (e.pointerId === drag.pointerId) { var p0 = pos(e), rorde = Math.hypot(p0.x - drag.start.x, p0.y - drag.start.y) > 10; drag = null; if (selected && !rorde) { selected = null; renderPanels(); } }
    } else if (e.pointerId === drag.pointerId) {
      var d = drag, p = pos(e);
      drag = null;
      if (d.tapEdit && !d.committed && Math.hypot(p.x - d.start.x, p.y - d.start.y) < 10) { guides.v = guides.h = false; inlineEdit(d.layer); return; }
    }
    guides.v = guides.h = false;
    scheduleDraw();
  }
  canvas.addEventListener('pointerup', endDrag);
  canvas.addEventListener('pointercancel', endDrag);

  function setSize(l, v) {
    if (l.type === 'image') l.w = Math.max(R_W * 0.05, Math.min(R_W * 2.5, v));
    else l.size = Math.max(areaH() * 0.03, Math.min(areaH() * 0.6, v));
    clampLayer(l);
  }
  function clampLayer(l) {
    var m = R_W * 0.02, vr = visibleRange(area());
    if (vr.free) vr = { lo: 0, hi: 1 };
    l.x = Math.max(R_W * vr.lo + m, Math.min(R_W * vr.hi - m, l.x));
    l.y = Math.max(m, Math.min(areaH() - m, l.y));
  }
  function refitLayers() {
    /* efter byte av sida (annan tryckyta): håll lagren innanför */
    var a0 = area(), vr0 = visibleRange(a0);
    var maxW = vr0.free ? R_W * 0.98 : R_W * (vr0.hi - vr0.lo) * (a0.wrap ? 0.86 : 0.98);
    layers.forEach(function (l) {
      if (l.type === 'image' && l.w > maxW) l.w = maxW;
      if (l.type === 'text') l.size = Math.min(l.size, areaH() * 0.6);
      clampLayer(l);
    });
  }

  var keyCommitTimer = null;
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    /* en öppen inställningsmeny fångar Esc före editorn – och före fältkollen nedan, så att
       Esc funkar även när fokus står i menyns reglage */
    if (menuFor && e.key === 'Escape') { e.preventDefault(); closeMenu(menuFor); return; }
    /* Menyn är modal: medan den är öppen hör tangenterna till den, inte till scenen. Utan den här
       raden rinner piltangenterna vidare hit när fokus står på en menyrad (en <button> slinker förbi
       fältkollen nedan) och puttar det markerade lagret 4 px per steg – med en ångra-post per tryck –
       och Backspace raderar lagret man just skulle ställa in. */
    if (menuFor) return;
    var tag = (e.target && e.target.tagName) || '';
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z') { e.preventDefault(); if (e.shiftKey) redo(); else undo(); return; }
    if (e.key === 'Escape') { requestClose(); return; }
    var l = selectedLayer();
    if (!l) return;
    var step = e.shiftKey ? 20 : 4;
    if (e.key === 'Delete' || e.key === 'Backspace') { removeLayer(l.id); e.preventDefault(); return; }
    var dx = e.key === 'ArrowLeft' ? -step : e.key === 'ArrowRight' ? step : 0;
    var dy = e.key === 'ArrowUp' ? -step : e.key === 'ArrowDown' ? step : 0;
    if (!dx && !dy) return;
    e.preventDefault();
    if (!keyCommitTimer) commit();
    clearTimeout(keyCommitTimer);
    keyCommitTimer = setTimeout(function () { keyCommitTimer = null; }, 600);
    l.x += dx; l.y += dy;
    clampLayer(l);
    scheduleDraw();
  });

  function removeLayer(id) {
    var lr = layerById(id); if (lr && lr.fast) return;
    commit();
    layers = layers.filter(function (l) { return l.id !== id; });
    if (selected === id) selected = layers.length ? layers[layers.length - 1].id : null;
    renderPanels(); draw();
    if (selected) focusGear(selected);
  }
  /* efter dubblera/ta bort finns inte det gamla kugghjulet kvar – lämna fokus på det kort som blev kvar */
  function focusGear(id) {
    var g = gearFor(id);
    if (g && g.focus && document.activeElement === document.body) g.focus({ preventScroll: true });
  }

  q('[data-mnd-delete]').addEventListener('click', function () { var l = selectedLayer(); if (l) removeLayer(l.id); });
  q('[data-mnd-flip]').addEventListener('click', function () { var l = selectedLayer(); if (!l || l.type !== 'image') return; commit(); l.flip = !l.flip; draw(); });
  q('[data-mnd-dup]').addEventListener('click', function () { var l = selectedLayer(); if (l) duplicateLayer(l.id); });
  q('[data-mnd-back]').addEventListener('click', function () { var l = selectedLayer(); if (l) moveLayer(l.id, -1); });
  q('[data-mnd-front]').addEventListener('click', function () { var l = selectedLayer(); if (l) moveLayer(l.id, 1); });
  q('[data-mnd-center]').addEventListener('click', function () {
    var l = selectedLayer(); if (!l) return;
    var vr = visibleRange(area());
    commit(); l.x = R_W * (vr.lo + vr.hi) / 2; l.y = areaH() / 2; l.rot = 0; draw();
  });
  q('[data-mnd-zoom]').addEventListener('click', function () { zoomed = !isZoomed(); this.classList.toggle('is-on', isZoomed()); draw(); });
  q('[data-mnd-undo]').addEventListener('click', undo);
  q('[data-mnd-redo]').addEventListener('click', redo);

  /* ---------- Bildbearbetning (PhotoRoom + pappersborttagning) ---------- */

  function canvasBlob(cv, type, qv) {
    return new Promise(function (resolve, reject) {
      cv.toBlob(function (b) { if (b) resolve(b); else reject(new Error('toBlob failed')); }, type, qv);
    });
  }
  function blobToImage(blob) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () { resolve({ img: img, url: url, ar: img.naturalWidth / img.naturalHeight, blob: blob }); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode failed')); };
      img.src = url;
    });
  }
  /* skala ned till MAX_SIDE / MAX_PIXELS och håll filen under funktionsgränsen (stegvis) */
  function prepare(file) {
    return createImageBitmap(file).then(function (bmp) {
      var side = Math.max(bmp.width, bmp.height);
      var scale = Math.min(1, MAX_SIDE / side, Math.sqrt(MAX_PIXELS / (bmp.width * bmp.height)));
      if (scale === 1 && file.size <= MAX_UPLOAD_BYTES && /image\/(jpeg|png|webp)/.test(file.type)) { bmp.close(); return { file: file, side: side }; }
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * scale); c.height = Math.round(bmp.height * scale);
      var cg = c.getContext('2d', { willReadFrequently: true });
      cg.drawImage(bmp, 0, 0, c.width, c.height);
      bmp.close();
      var alfa = harGenomskinlighet(cg.getImageData(0, 0, c.width, c.height).data);
      function shrink(cv, qv) {
        return canvasBlob(cv, alfa ? 'image/png' : 'image/jpeg', qv).then(function (b) {
          if (b.size <= MAX_UPLOAD_BYTES || Math.max(cv.width, cv.height) <= 1600) return { file: b, side: Math.max(cv.width, cv.height) };
          if (qv > 0.8 && !alfa) return shrink(cv, 0.8);
          var s2 = document.createElement('canvas');
          s2.width = Math.round(cv.width * 0.82); s2.height = Math.round(cv.height * 0.82);
          s2.getContext('2d').drawImage(cv, 0, 0, s2.width, s2.height);
          return shrink(s2, 0.8);
        });
      }
      return shrink(c, 0.92);
    }).catch(function () { return { file: file, side: 0 }; });
  }
  /* Photoroom räknar ett anrop till bildredigeringen (v2/edit) som 5 bilder och ren bakgrundsborttagning
     (v1/segment) som 1. Bildredigeringen behövs bara för AI-ljuset, som är en temainställning (av som
     standard). Utan den går bilden till bakgrundsborttagningen i full upplösning som png. */
  function photoroom(file, relight) {
    var fd = new FormData(), url = PROXY_URL;
    if (relight) {
      fd.append('imageFile', file, file.name || 'foto.jpg');
      fd.append('removeBackground', 'true');
      fd.append('outputSize', 'originalImage');
      fd.append('export.dpi', '300');
      fd.append('lighting.mode', 'ai.auto');
    } else {
      fd.append('image_file', file, file.name || 'foto.jpg');
      fd.append('size', 'full');
      fd.append('format', 'png');
      url += (url.indexOf('?') < 0 ? '?' : '&') + 'api=segment';
    }
    return fetch(url, { method: 'POST', body: fd }).then(function (res) {
      if (!res.ok) { var err = new Error('PhotoRoom HTTP ' + res.status); err.status = res.status; throw err; }
      return res.blob();
    });
  }
  function estimatePaperColor(p) {
    var samples = [];
    for (var i = 0; i < p.length; i += 4 * 97) {
      if (p[i + 3] > 200) {
        var lum = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2];
        var sat = Math.max(p[i], p[i + 1], p[i + 2]) - Math.min(p[i], p[i + 1], p[i + 2]);
        if (lum > 160 && sat < 40) samples.push([p[i], p[i + 1], p[i + 2]]);
      }
    }
    if (!samples.length) return [245, 242, 235];
    samples.sort(function (a, b) { return (a[0] + a[1] + a[2]) - (b[0] + b[1] + b[2]); });
    return samples[Math.floor(samples.length / 2)];
  }
  function contentBox(p, w, h) {
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      if (p[(y * w + x) * 4 + 3] > 8) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
    }
    if (maxX < 0) return { x: 0, y: 0, w: w, h: h };
    var pad = 12;
    minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad); maxX = Math.min(w - 1, maxX + pad); maxY = Math.min(h - 1, maxY + pad);
    return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  }
  /* Svag dimma (pappersskugga, vinjettering, arkets kant) som hänger ihop med
     bildkanten utan att korsa ett riktigt streck tas bort helt – annars trycks
     den som en ljus rektangel på mörka plagg. Räknas på ett rutnät så att
     streckens egna mjuka kanter (rutor intill starka rutor) lämnas orörda. */
  function clearBorderHaze(p, w, h) {
    var f = Math.max(1, Math.ceil(Math.max(w, h) / 900));
    var cw = Math.ceil(w / f), ch = Math.ceil(h / f);
    var aMax = new Uint8Array(cw * ch);
    for (var y = 0; y < h; y++) {
      var cy = (y / f) | 0;
      for (var x = 0; x < w; x++) {
        var a = p[(y * w + x) * 4 + 3];
        if (!a) continue;
        var ci = cy * cw + ((x / f) | 0);
        if (a > aMax[ci]) aMax[ci] = a;
      }
    }
    var STRONG = 150;
    var near = new Uint8Array(cw * ch); /* rutor intill (eller på) ett starkt streck */
    for (var j = 0; j < ch; j++) for (var i2 = 0; i2 < cw; i2++) {
      if (aMax[j * cw + i2] <= STRONG) continue;
      for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
        var nx = i2 + dx, ny = j + dy;
        if (nx >= 0 && ny >= 0 && nx < cw && ny < ch) near[ny * cw + nx] = 1;
      }
    }
    var seen = new Uint8Array(cw * ch), stack = [];
    function push(ci) { if (!seen[ci] && aMax[ci] <= STRONG) { seen[ci] = 1; stack.push(ci); } }
    for (var bx = 0; bx < cw; bx++) { push(bx); push((ch - 1) * cw + bx); }
    for (var by = 0; by < ch; by++) { push(by * cw); push(by * cw + cw - 1); }
    var removed = 0;
    while (stack.length) {
      var c = stack.pop();
      var cxi = c % cw, cyi = (c / cw) | 0;
      if (aMax[c] && !near[c]) { near[c] = 2; removed++; } /* 2 = rensas nedan */
      if (cxi > 0) push(c - 1);
      if (cxi < cw - 1) push(c + 1);
      if (cyi > 0) push(c - cw);
      if (cyi < ch - 1) push(c + cw);
    }
    if (!removed) return;
    for (var y2 = 0; y2 < h; y2++) {
      var cy2 = (y2 / f) | 0;
      for (var x2 = 0; x2 < w; x2++) {
        if (near[cy2 * cw + ((x2 / f) | 0)] === 2) p[(y2 * w + x2) * 4 + 3] = 0;
      }
    }
  }

  /* finns det genomskinliga pixlar av betydelse (mer än 0,2 % av bilden)? */
  function harGenomskinlighet(p) {
    var n = 0, t = 0;
    for (var i = 3; i < p.length; i += 4 * 17) { t++; if (p[i] < 250) n++; }
    return t > 0 && n / t > 0.002;
  }
  function makeVersion(img, removePaper, boost) {
    var w = img.naturalWidth, h = img.naturalHeight;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    if (removePaper) x.filter = 'saturate(1.25) contrast(1.05)'; else if (boost) x.filter = 'saturate(1.15) contrast(1.03)';
    x.drawImage(img, 0, 0); x.filter = 'none';
    var d = x.getImageData(0, 0, w, h), p = d.data;
    var genomskinlig = harGenomskinlighet(p);
    if (removePaper) {
      var paper = estimatePaperColor(p), NEAR = 36, FAR = 84;
      for (var i = 0; i < p.length; i += 4) {
        if (p[i + 3] === 0) continue;
        /* PhotoRooms halvgenomskinliga kant är pappersarkets kant, inte teckningen */
        if (p[i + 3] < 230) { p[i + 3] = 0; continue; }
        var dr = p[i] - paper[0], dg = p[i + 1] - paper[1], db = p[i + 2] - paper[2];
        var dist = Math.sqrt(dr * dr + dg * dg + db * db);
        var k = dist <= NEAR ? 0 : dist >= FAR ? 1 : (dist - NEAR) / (FAR - NEAR);
        /* svag dimma (pappersskuggor, ojämnt papper) släpps helt – syns annars på mörka plagg */
        k = k <= 0.3 ? 0 : (k - 0.3) / 0.7;
        if (k > 0 && k < 1) {
          p[i] = Math.max(0, Math.min(255, Math.round((p[i] - (1 - k) * paper[0]) / k)));
          p[i + 1] = Math.max(0, Math.min(255, Math.round((p[i + 1] - (1 - k) * paper[1]) / k)));
          p[i + 2] = Math.max(0, Math.min(255, Math.round((p[i + 2] - (1 - k) * paper[2]) / k)));
        }
        p[i + 3] = Math.round(p[i + 3] * k);
      }
      clearBorderHaze(p, w, h);
      x.putImageData(d, 0, 0);
    }
    var box = contentBox(p, w, h);
    d = null; p = null;
    var up = 1, longSide = Math.max(box.w, box.h);
    if (longSide < TARGET_SIDE) up = Math.min(MAX_UPSCALE, TARGET_SIDE / longSide);
    var out = document.createElement('canvas');
    out.width = Math.round(box.w * up); out.height = Math.round(box.h * up);
    var ox = out.getContext('2d');
    ox.imageSmoothingEnabled = true; ox.imageSmoothingQuality = 'high';
    ox.drawImage(c, box.x, box.y, box.w, box.h, 0, 0, out.width, out.height);
    c.width = c.height = 1;
    /* Ett foto av en teckning läggs på vitt (pappret följer med, som i fotot). En bild som redan är
       frilagd (png med genomskinlig bakgrund, en logga) får behålla genomskinligheten. Den lades också
       på vitt, och den vita fyrkanten syntes i förhandsvisningen och följde med i tryckfilen. */
    if (!removePaper && !genomskinlig) {
      var flat = document.createElement('canvas'); flat.width = out.width; flat.height = out.height;
      var fx = flat.getContext('2d'); fx.fillStyle = '#fff'; fx.fillRect(0, 0, flat.width, flat.height); fx.drawImage(out, 0, 0);
      out.width = out.height = 1;
      out = flat;
    }
    return canvasBlob(out, 'image/png').then(function (b) { out.width = out.height = 1; return blobToImage(b); });
  }

  var fileQueue = [], queueTotal = 0, queueDone = 0;
  function processFiles(list) {
    if (!kanLaggaTill()) return;
    var files = Array.prototype.slice.call(list || []).filter(function (f) { return f && (f.type ? /^image\//.test(f.type) : /\.(heic|heif|jpe?g|png|webp)$/i.test(f.name)); });
    if (!files.length) return;
    var idle = !fileQueue.length && q('[data-mnd-busy]').hidden;
    fileQueue = fileQueue.concat(files);
    queueTotal += files.length;
    if (idle) nextFile();
  }
  function nextFile() {
    var f = fileQueue.shift();
    if (!f) { queueTotal = queueDone = 0; return; }
    processFile(f).then(function () { queueDone++; nextFile(); });
  }
  function busyLabel(text) { return queueTotal > 1 ? 'Bild ' + (queueDone + 1) + ' av ' + queueTotal + '. ' + text : text; }

  /* Uppladdning: bilden visas som den är. Bakgrunden tas bort först när kunden slår på det
     (per bild) – då körs PhotoRoom + pappersrensning och resultatet sparas i bildbiblioteket. */
  function processFile(file) {
    setBusy(busyLabel('Läser in bilden …'));
    var prepared = null;
    return prepare(file).then(function (p) { prepared = p; return blobToImage(p.file); })
      .then(function (r) { return makeVersion(r.img, false, false).then(function (paper) { URL.revokeObjectURL(r.url); return { clean: null, paper: paper }; }); })
      .then(function (versions) {
        commit();
        addImageLayer(versions, file.name);
        var l = layerById(selected);
        l.libId = 'lib' + Date.now() + Math.random().toString(36).slice(2, 6);
        saveToLibrary(l.libId, file.name, prepared.file, null, versions.paper);
        setBusy(null);
        showTab('bild');
        renderPanels(); draw();
        /* En skärmdump eller en bild från en chatt kan vara för liten för ett skarpt tryck. Kunden får veta
           det direkt, och texten står kvar på bildkortet. prepared.side är originalets längsta sida. */
        var im = versions.paper && versions.paper.img;
        var side = prepared && prepared.side ? prepared.side : (im ? Math.max(im.naturalWidth, im.naturalHeight) : 0);
        if (side && side < LOWRES_SIDE) { l.lowres = true; renderPanels(); toast(TXT_LOWRES, 9000); }
      })
      .catch(function (err) {
        console.error('[Minnely-designern]', err);
        setBusy(null);
        alert('Hoppsan, bilden ' + (file.name ? '"' + file.name + '" ' : '') + 'gick inte att läsa in. Prova ett annat foto (JPG eller PNG).');
      });
  }

  /* friläggning på begäran: PhotoRoom (bord/bakgrund) + lokal pappersrensning */
  function makeClean(l) {
    if (l.versions.clean) return Promise.resolve(l.versions.clean);
    if (l._cleaning) return l._cleaning;
    setBusy('Tar bort bakgrunden …');
    var src = l.versions.paper.blob;
    var relightUsed = false, fallback = false;
    var wantRelight = AI_LJUS && Math.max(l.versions.paper.img.naturalWidth, l.versions.paper.img.naturalHeight) <= RELIGHT_MAX;
    relightUsed = wantRelight;
    l._cleaning = photoroom(src, wantRelight)
      .catch(function (err) { if (err && err.status === 400 && wantRelight) { relightUsed = false; return photoroom(src, false); } throw err; })
      .catch(function (err) { console.warn('[Minnely-designern] PhotoRoom föll bort, lokal friläggning', err); relightUsed = false; fallback = true; return src; })
      .then(function (blob) { setBusy('Snyggar till färgerna …'); return blobToImage(blob); })
      .then(function (r) { return makeVersion(r.img, true, true).then(function (clean) { URL.revokeObjectURL(r.url); return clean; }); })
      .then(function (clean) {
        l.versions.clean = clean;
        if (fallback) l.note = 'Bakgrunden kunde inte tas bort automatiskt just nu. Vi har rensat bort pappret så gott det går. Prova gärna igen om en stund.';
        if (l.libId) saveToLibrary(l.libId, l.name, null, clean.blob, null);
        setBusy(null); l._cleaning = null;
        return clean;
      })
      .catch(function (err) { setBusy(null); l._cleaning = null; console.error('[Minnely-designern]', err); alert('Bakgrunden gick inte att ta bort just nu. Försök igen om en stund.'); throw err; });
    return l._cleaning;
  }

  /* ---------- Bildbibliotek i webbläsaren (IndexedDB): dina uppladdade bilder på alla produkter ---------- */

  var LIB_MAX = 12, libDb = null, libItems = [];
  function libOpen() {
    if (libDb) return Promise.resolve(libDb);
    return new Promise(function (resolve) {
      try {
        var rq = indexedDB.open('minnely-designer', 2);
        rq.onupgradeneeded = function () {
          var db = rq.result;
          if (!db.objectStoreNames.contains('bilder')) db.createObjectStore('bilder', { keyPath: 'id' });
          if (!db.objectStoreNames.contains('designer')) db.createObjectStore('designer', { keyPath: 'id' });
        };
        rq.onsuccess = function () { libDb = rq.result; resolve(libDb); };
        rq.onerror = function () { resolve(null); };
      } catch (e) { resolve(null); }
    });
  }
  function libAll() {
    return libOpen().then(function (db) {
      if (!db) return [];
      return new Promise(function (resolve) {
        var rq = db.transaction('bilder').objectStore('bilder').getAll();
        rq.onsuccess = function () { resolve((rq.result || []).sort(function (a, b) { return b.added - a.added; })); };
        rq.onerror = function () { resolve([]); };
      });
    });
  }
  function libPut(item) {
    return libOpen().then(function (db) {
      if (!db) return;
      return new Promise(function (resolve) { var tx = db.transaction('bilder', 'readwrite'); tx.objectStore('bilder').put(item); tx.oncomplete = resolve; tx.onerror = resolve; });
    });
  }
  function libDelete(id) {
    return libOpen().then(function (db) {
      if (!db) return;
      return new Promise(function (resolve) { var tx = db.transaction('bilder', 'readwrite'); tx.objectStore('bilder').delete(id); tx.oncomplete = resolve; tx.onerror = resolve; });
    });
  }
  function thumbOf(version) {
    var c = document.createElement('canvas'), s = 160 / Math.max(version.img.naturalWidth, version.img.naturalHeight);
    c.width = Math.max(1, Math.round(version.img.naturalWidth * s)); c.height = Math.max(1, Math.round(version.img.naturalHeight * s));
    c.getContext('2d').drawImage(version.img, 0, 0, c.width, c.height);
    try { return c.toDataURL('image/jpeg', 0.8); } catch (e) { return ''; }
  }
  function saveToLibrary(id, name, original, clean, paperVersion) {
    libOpen().then(function (db) {
      if (!db) return;
      var tx = db.transaction('bilder', 'readwrite'), store = tx.objectStore('bilder'), rq = store.get(id);
      rq.onsuccess = function () {
        var item = rq.result || { id: id, name: name || 'Bild', added: Date.now() };
        if (original) item.original = original;
        if (clean) item.clean = clean;
        if (paperVersion) item.thumb = thumbOf(paperVersion);
        store.put(item);
      };
      tx.oncomplete = function () {
        libAll().then(function (all) {
          all.slice(LIB_MAX).forEach(function (old) { libDelete(old.id); });
          libItems = all.slice(0, LIB_MAX); renderLibrary();
        });
      };
    });
  }
  function renderLibrary() {
    var host = q('[data-mnd-library]');
    if (!host) return;
    updateHasContent();
    if (!libItems.length) { host.hidden = true; host.innerHTML = ''; return; }
    host.hidden = false;
    host.innerHTML = '<p class="mnd__lib-title">Dina tidigare bilder</p><div class="mnd__lib">' + libItems.map(function (it) {
      return '<button type="button" class="mnd__lib-item" data-lib="' + it.id + '" title="' + esc(it.name || 'Bild') + '"><img src="' + (it.thumb || '') + '" alt=""><i data-lib-del="' + it.id + '" title="Ta bort ur biblioteket">×</i></button>';
    }).join('') + '</div>';
  }
  function addFromLibrary(id) {
    if (!kanLaggaTill()) return;
    var it = libItems.find(function (x) { return x.id === id; });
    if (!it || !it.original) return;
    setBusy('Hämtar bilden …');
    blobToImage(it.original).then(function (r) {
      return makeVersion(r.img, false, false).then(function (paper) {
        URL.revokeObjectURL(r.url);
        var versions = { clean: null, paper: paper };
        if (it.clean) return blobToImage(it.clean).then(function (c) { versions.clean = c; return versions; });
        return versions;
      });
    }).then(function (versions) {
      commit(); addImageLayer(versions, it.name);
      var l = layerById(selected); l.libId = it.id; l.bg = !versions.clean;
      setBusy(null); renderPanels(); draw();
    }).catch(function (err) { console.error('[Minnely-designern]', err); setBusy(null); });
  }
  /* ---------- Designen som post: sparas i webbläsaren så att den går att ändra från varukorgen ---------- */

  var PARAMS = new URLSearchParams(location.search);
  var EDIT_LINE = PARAMS.get('line') || null;            /* varukorgsrad som ska ersättas */
  var DESIGN_ID = PARAMS.get('design') || null;
  function newDesignId() { return 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function dbPut(store, item) {
    return libOpen().then(function (db) {
      if (!db) return;
      return new Promise(function (resolve) { var tx = db.transaction(store, 'readwrite'); tx.objectStore(store).put(item); tx.oncomplete = resolve; tx.onerror = resolve; });
    });
  }
  function dbGet(store, id) {
    return libOpen().then(function (db) {
      if (!db) return null;
      return new Promise(function (resolve) { var rq = db.transaction(store).objectStore(store).get(id); rq.onsuccess = function () { resolve(rq.result || null); }; rq.onerror = function () { resolve(null); }; });
    });
  }
  function saveDesignRecord() {
    if (!DESIGN_ID) DESIGN_ID = newDesignId();
    sides[placement] = layers;
    var rec = { id: DESIGN_ID, handle: root.dataset.productHandle || '', variant: (currentVariant() || {}).id || null, placement: placement, sides: {}, saved: Date.now() };
    SURF.forEach(function (id) { rec.sides[id] = stripLayers(sides[id]); });
    dbPut('designer', rec);
    return DESIGN_ID;
  }
  /* återställ lagren (bilder från biblioteket via libId) – för "Ändra design" i varukorgen */
  function restoreDesign(id) {
    return dbGet('designer', id).then(function (rec) {
      if (!rec || !rec.sides) return false;
      var restoreLayer = function (l) {
        var n = parseInt(String(l.id).slice(1), 10); if (n > uid) uid = n;
        if (l.type === 'text') return Promise.resolve(l);
        if (!l.libId) return Promise.resolve(null);
        return dbGet('bilder', l.libId).then(function (it) {
          if (!it || !it.original) return null;
          return blobToImage(it.original).then(function (r) {
            return makeVersion(r.img, false, false).then(function (paper) {
              URL.revokeObjectURL(r.url);
              var versions = { clean: null, paper: paper };
              var next = it.clean ? blobToImage(it.clean).then(function (c) { versions.clean = c; }) : Promise.resolve();
              return next.then(function () {
                if (!versions.clean) l.bg = true;
                l.versions = versions; assets[l.id] = { versions: versions };
                return l;
              });
            });
          });
        }).catch(function (e) { console.warn('[Minnely-designern] kunde inte återställa bild', e); return null; });
      };
      var sids = Object.keys(rec.sides).filter(function (sid) { return !!sides[sid]; });
      return Promise.all(sids.map(function (sid) { return Promise.all(rec.sides[sid].map(restoreLayer)); })).then(function (lists) {
        sids.forEach(function (sid, i) { sides[sid] = lists[i].filter(Boolean); });
        if (rec.placement && sides[rec.placement]) placement = rec.placement;
        layers = sides[placement];
        return sids.some(function (sid) { return sides[sid].length > 0; });
      });
    });
  }
  /* dolda fält i formuläret (properties[…]) som designern äger */
  function setHiddenProp(name, value) {
    var main = document.querySelector('input[data-bt-teckning]');
    var form = main && main.closest('form'); if (!form) return;
    var i = form.querySelector('input[data-mnd-prop="' + name + '"]');
    if (value == null || value === '') { if (i) i.remove(); return; }
    if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.setAttribute('data-mnd-prop', name); form.appendChild(i); }
    i.value = value;
  }
  /* liten förhandsbild (huvudvyn med trycken) som följer med raden – varukorgen och ordern visar den */
  function previewBlob(withContent) {
    var first = withContent[0];
    var view = UV ? TY.ytor[first].vy : first;
    var src = UV ? viewImage(view) : withSide(first, function () { return area().src; });
    /* UV-kartan måste vara laddad innan kompositionen ritas. Har kunden bara arbetat i den platta
       vyn är den inte det, och då blev förhandsbilden tom: varukorgen visade den vanliga
       produktbilden utan designen, och kunden fick aldrig se vad hon beställt. */
    var kartor = UV ? (viewMapsReady[view] ? Promise.resolve(viewMapsReady[view]) : (viewMaps(view), viewMapsReady['_' + view] || Promise.resolve(null))) : Promise.resolve(null);
    return Promise.all([loadMock(src), kartor]).then(function (r) {
      var im = r[0];
      if (!im) return null;
      var url = null;
      if (UV) url = viewDataUrl(view, im, 720);
      else url = withSide(first, function () { var pm = mockImg, pk = mockKey; mockImg = im; mockKey = src; var u = galleryDataUrl(720); mockImg = pm; mockKey = pk; return u; });
      if (!url) return null;
      var bin = atob(url.split(',')[1]), arr = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      return new Blob([arr], { type: 'image/jpeg' });
    }).catch(function () { return null; });
  }
  /* Förhandsbilden görs när designern stängs. Byter kunden sedan djur eller färg på produktsidan
     visade miniatyren och varukorgen fortfarande det gamla valet (björnen fast elefanten var vald).
     Då görs den om: miniatyren direkt, raden i varukorgen när den nya bilden är uppladdad. */
  var forhandsVariant = null;
  function uppdateraForhandsbild() {
    if (!hasDesign()) return;
    var nyckel = selectedValues().join('|');
    if (nyckel === forhandsVariant) return;
    forhandsVariant = nyckel;
    sides[placement] = layers;
    tillampaForm();
    previewBlob(surfacesWithContent()).then(function (b) {
      if (!b || selectedValues().join('|') !== nyckel) return;
      var lokal = URL.createObjectURL(b);
      document.querySelectorAll('[data-bt-thumb]').forEach(function (img) { img.src = lokal; });
      return uploadSmall(b).then(function (u) {
        if (u && selectedValues().join('|') === nyckel) setHiddenProp('_forhandsvisning', u);
      });
    }).catch(function () {});
  }
  function uploadSmall(blob) {
    return fetch(SAVE_URL, { method: 'POST', headers: { 'content-type': blob.type }, body: blob })
      .then(function (r) { if (!r.ok) throw new Error('spara misslyckades'); return r.json(); }).then(function (d) { return d.url; });
  }

  root.addEventListener('click', function (e) {
    var del = e.target.closest('[data-lib-del]');
    if (del) { e.preventDefault(); e.stopPropagation(); var id = del.dataset.libDel; libDelete(id).then(function () { libItems = libItems.filter(function (x) { return x.id !== id; }); renderLibrary(); }); return; }
    var b = e.target.closest('[data-lib]');
    if (b) addFromLibrary(b.dataset.lib);
  });

  function setBusy(text) {
    var b = q('[data-mnd-busy]');
    b.hidden = !text;
    if (text) q('[data-mnd-busy-text]').textContent = text;
    q('[data-mnd-empty]').hidden = !!text || layers.length > 0;
  }

  /* Färdiga produkter: ytan där det färdiga trycket sitter tar inte emot fler texter eller bilder – det
     kunden lägger till ska vara ett eget tryck på en annan yta (ärm, rygg) och kostar extra tryck som vanligt.
     Försöker man lägga till på den låsta ytan flyttas man till första lediga yta och får veta varför. */
  function lastYta(sid) { return FARDIG.some(function (f) { return f.placering === sid; }); }
  function forstaFria() {
    var fria = SURF.filter(function (s) { return !lastYta(s); });
    var pref = ['left_sleeve', 'right_sleeve', 'back'];
    for (var i = 0; i < pref.length; i++) if (fria.indexOf(pref[i]) >= 0) return pref[i];
    return fria[0] || null;
  }
  function kanLaggaTill() {
    if (!FARDIG.length || !lastYta(placement)) return true;
    var fri = forstaFria(), fran = surfName(placement).toLowerCase();
    if (!fri) { toast('Den här produkten har redan sitt tryck.', 3200); return false; }
    setPlacement(fri);
    renderSides();
    toast('Trycket på ' + fran + ' är färdigt. Det du lägger till hamnar på ' + surfName(fri).toLowerCase() + (EXTRA_PRIS ? ' (extra tryck ' + money(EXTRA_PRIS) + ')' : '') + '.', 4200);
    return true;
  }
  function pickImage() { if (!kanLaggaTill()) return; fileInput.click(); }
  var emptyText = q('[data-mnd-empty-text]');
  if (emptyText) emptyText.addEventListener('click', function () { textStart = true; quickAddText(); textStart = false; });
  qa('[data-mnd-pick]').forEach(function (b) { b.addEventListener('click', pickImage); });
  fileInput.addEventListener('change', function () {
    var files = fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
    fileInput.value = '';
    processFiles(files);
  });
  stage.addEventListener('dragover', function (e) { e.preventDefault(); stage.classList.add('is-dragover'); });
  stage.addEventListener('dragleave', function () { stage.classList.remove('is-dragover'); });
  stage.addEventListener('drop', function (e) {
    e.preventDefault(); stage.classList.remove('is-dragover');
    processFiles(e.dataTransfer && e.dataTransfer.files);
  });

  /* ---------- Panelen ---------- */

  /* samma tio typsnitt som admin-appens textmotiv: [namn, etikett, vikt] */
  var FONTS = [['Caveat', 'Handskrift', '700'], ['Dancing Script', 'Skrivstil', '700'], ['Pacifico', 'Lekfull', '400'], ['Great Vibes', 'Elegant', '400'], ['Lobster', 'Fet retro', '400'], ['Playfair Display', 'Klassisk', '700'], ['Fredoka', 'Rund', '600'], ['Baloo 2', 'Tjock', '800'], ['Bebas Neue', 'Versaler', '400'], ['Outfit', 'Modern', '700']];
  function fontWeight(name) { var f = FONTS.filter(function (x) { return x[0] === name; })[0]; return f ? f[2] : '600'; }
  var TEXT_COLORS = ['#1f1f1f', '#a3625a', '#d9958e', '#2b5fc7', '#2f8f4e', '#ea7a2a', '#f2c14e', '#6b3fa0', '#ffffff'];

  qa('[data-mnd-tab]').forEach(function (t) { t.addEventListener('click', function () { showTab(t.dataset.mndTab); }); });
  function showTab(name) {
    qa('[data-mnd-tab]').forEach(function (t) { t.classList.toggle('is-on', t.dataset.mndTab === name); t.setAttribute('aria-selected', t.dataset.mndTab === name); });
    qa('[data-mnd-pane]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.mndPane === name); });
    if (name === 'mallar') renderMallar();
    /* textrutorna går att mäta först när fliken syns */
    qa('[data-mnd-text-layers] .mnd__ta').forEach(fitTa);
  }

  function addTextAndEdit() {
    if (!kanLaggaTill()) return;
    commit(); addTextLayer(); renderPanels(); draw();
    var ta = q('[data-mnd-text-layers] textarea[data-id="' + selected + '"]');
    if (ta) ta.focus();
  }
  q('[data-mnd-add-text]').addEventListener('click', addTextAndEdit);

  /* ---------- Kikradens chip: Bild och Text alltid inom räckhåll (stående mobil) ----------
     Chippen får samma data-attribut som knapparna i panelen (så att t.ex. BRODYR-döljningen i open()
     träffar dem) och kallar samma funktioner – ingen kopierad logik. */
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var ICON_TEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 6V4h14v2M12 4v16M9 20h6"/></svg>';
  var quickDone = false;
  function quickPick() { showTab('bild'); setSheet('half'); pickImage(); }
  /* Text: halvt ark räcker för att se fältet – men fokus i textfältet fäller ut helt (focusin nedan),
     för med tangentbordet uppe ryms inte ett halvt ark utan att foten hamnar under skärmkanten. */
  /* ---------- Tryckmallar (sektionen Tryckmallar i produktmallen, #mn-mallar) ----------
     En mall är ett mönster (vit PNG) och en rubrik som kunden skriver om. Mönstret läggs som bild över
     ytans bredd, rubriken som text ovanför i mallens typsnitt. På ljusa plagg färgas båda mörka. */
  var ICON_MALL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
  var mallLista = null;
  /* Säsong: "MM-DD" från/till (får gå över nyår). Körs i webbläsaren så att en cachad sida inte visar fel säsong. */
  function iSasong(m) {
    var tal = function (s) { var x = /^(\d{1,2})-(\d{1,2})$/.exec(String(s || '').trim()); return x ? Number(x[1]) * 100 + Number(x[2]) : null; };
    var f = tal(m.fran), t = tal(m.till); if (f == null && t == null) return true;
    var d = new Date(), idag = (d.getMonth() + 1) * 100 + d.getDate();
    if (f == null) return idag <= t; if (t == null) return idag >= f;
    return f <= t ? (idag >= f && idag <= t) : (idag >= f || idag <= t);
  }
  function mallar() {
    if (mallLista) return mallLista;
    var el = document.getElementById('mn-mallar'), alla = [];
    try { alla = (el ? JSON.parse(el.textContent) : []) || []; } catch (e) { alla = []; }
    mallLista = (BRODYR || FARDIG.length) ? [] : alla.filter(function (m) { return m && m.delar && m.delar.length && ((iSasong(m) && !m.dold) || m.id === PARAMS.get('mall')); });
    /* säsongsmallar (med datum) först – det är dem kunden letar efter just nu */
    mallLista.forEach(function (m, i) { m._i = i; m._sasong = !!(m.fran || m.till); });
    mallLista.sort(function (a, b) { return (b._sasong - a._sasong) || (a._i - b._i); });
    return mallLista;
  }
  function mallById(id) { return mallar().filter(function (x) { return x.id === id; })[0] || null; }
  /* mallens delar uppifrån och ned: bildernas adresser och rubriken ('T') där butiken valt */
  function mallOrdning(m) {
    var o = m.delar.slice();
    if (m.text) { var at = m.plats === 'overst' ? 0 : m.plats === 'underst' ? o.length : Math.min(1, o.length); o.splice(at, 0, 'T'); }
    return o;
  }
  /* mallens placering i en yta (bredd × H). 'fyll': mönstret kant i kant mot nederkanten, rubriken i
     luften ovanför (krymper hellre rubriken än mönstret). 'mindre': delarna staplas centrerat som förut.
     ars = delarnas bredd/höjd, th = rubrikens höjd. Svarar med skala för bilderna (f) och rubriken (ts). */
  function mallLayout(m, ars, bredd, H, th) {
    var fyll = m.storlek !== 'mindre', ord = mallOrdning(m), ut = [], y, f, ts = 1;
    if (fyll) ord = ord.filter(function (p) { return p !== 'T'; });
    var gap = bredd * (fyll ? 0.012 : 0.035);
    var hs = ord.map(function (p) { return p === 'T' ? th : bredd / ars[m.delar.indexOf(p)]; });
    var tot = hs.reduce(function (s, h) { return s + h; }, 0) + gap * (ord.length - 1);
    if (!fyll) {
      f = Math.min(1, (H * 0.94) / tot); y = (H - tot * f) / 2;
      ord.forEach(function (p, i) { var h = hs[i] * f; ut.push({ p: p, y: y + h / 2, h: h }); y += h + gap * f; });
      return { f: f, ts: f, delar: ut };
    }
    var harT = !!(m.text && th > 0);
    if (harT && tot + th * 1.3 > H) { var ny = Math.max(th * 0.55, (H - tot) / 1.3); ts = ny / th; th = ny; }
    f = Math.min(1, (H - (harT ? th * 1.3 : 0)) / tot);
    y = H - tot * f; var topp = y;
    ord.forEach(function (p, i) { var h = hs[i] * f; ut.push({ p: p, y: y + h / 2, h: h }); y += h + gap * f; });
    if (harT) ut.unshift({ p: 'T', y: topp - Math.min(topp / 2, th * 1.1), h: th });
    return { f: f, ts: ts, delar: ut };
  }
  var bildCache = {};
  function hamtaBild(url) {
    if (!bildCache[url]) bildCache[url] = fetch(url, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error('mall ' + r.status); return r.blob(); });
    return bildCache[url];
  }
  /* miniatyr för mallar byggda av remsor: ritas här av samma delar som läggs på plagget */
  function ritaTumme(m, img) {
    var ord = mallOrdning(m), font = m.typsnitt || 'Playfair Display';
    Promise.all([Promise.all(m.delar.map(function (u) { return hamtaBild(u).then(blobToImage); })), loadFont(font)]).then(function (res) {
      var bilder = res[0], W = 600, pad = 30, bredd = W - pad * 2;
      var c = document.createElement('canvas'), x = c.getContext('2d');
      x.font = fontWeight(font) + ' 100px "' + font + '"';
      var tw = x.measureText(m.text || '').width || 1, ts = Math.min(80, 100 * bredd * 0.9 / tw);
      if (m.storlek !== 'mindre') {   /* hela bredden: tumnageln i tryckytans format */
        /* utan höjdgräns och tätt beskuren: rutan i listan är liggande */
        var p2 = 24, br = W - p2 * 2, Hy = 1e5, L = mallLayout(m, bilder.map(function (b) { return b.img.naturalWidth / b.img.naturalHeight; }), br, Hy, m.text ? ts * 1.1 : 0);
        var topp = Math.min.apply(null, L.delar.map(function (o) { return o.y - o.h / 2; })), dy = p2 - topp;
        c.width = W; c.height = Math.round(Hy - topp + p2 * 2);
        L.delar.forEach(function (o) {
          if (o.p === 'T') { x.fillStyle = '#fff'; x.textAlign = 'center'; x.textBaseline = 'middle'; x.font = fontWeight(font) + ' ' + (ts * L.ts) + 'px "' + font + '"'; x.fillText(m.text, W / 2, dy + o.y); }
          else { var bw = br * L.f; x.drawImage(bilder[m.delar.indexOf(o.p)].img, p2 + (br - bw) / 2, dy + o.y - o.h / 2, bw, o.h); }
        });
        bilder.forEach(function (b) { URL.revokeObjectURL(b.url); });
        img.src = c.toDataURL('image/png'); return;
      }
      var gap = bredd * 0.035;
      var hs = ord.map(function (p, i) { return p === 'T' ? ts * 1.1 : bredd / (bilder[m.delar.indexOf(p)].img.naturalWidth / bilder[m.delar.indexOf(p)].img.naturalHeight); });
      var tot = hs.reduce(function (s, h) { return s + h; }, 0) + gap * (ord.length - 1);
      c.width = W; c.height = Math.round(Math.max(tot + pad * 2, W * 0.5));
      var y = (c.height - tot) / 2;
      ord.forEach(function (p, i) {
        if (p === 'T') { x.fillStyle = '#fff'; x.textAlign = 'center'; x.textBaseline = 'middle'; x.font = fontWeight(font) + ' ' + ts + 'px "' + font + '"'; x.fillText(m.text, W / 2, y + hs[i] / 2); }
        else x.drawImage(bilder[m.delar.indexOf(p)].img, pad, y, bredd, hs[i]);
        y += hs[i] + gap;
      });
      bilder.forEach(function (b) { URL.revokeObjectURL(b.url); });
      img.src = c.toDataURL('image/png');
    }).catch(function () {});
  }
  function renderMallar() {
    var host = q('[data-mnd-mallar]'); if (!host || host.dataset.klar) return;
    host.dataset.klar = '1';
    var grupper = [];
    mallar().forEach(function (m) { var g = m.grupp || ''; var hit = grupper.filter(function (x) { return x.namn === g; })[0]; if (!hit) { hit = { namn: g, lista: [] }; grupper.push(hit); } hit.lista.push(m); });
    host.innerHTML = grupper.map(function (g) {
      return (g.namn ? '<p class="mnd__menu-head">' + esc(g.namn) + '</p>' : '') + '<div class="mnd__mallgrid">' + g.lista.map(function (m) {
        return '<button type="button" class="mnd__mall" data-mall="' + esc(m.id) + '"><span class="mnd__mall-bild"><img ' + (m.tumme ? 'src="' + esc(m.tumme) + '" ' : '') + 'alt="" loading="lazy"></span><span>' + esc(m.namn) + '</span></button>';
      }).join('') + '</div>';
    }).join('');
    mallar().forEach(function (m) { if (m.tumme) return; var img = host.querySelector('[data-mall="' + m.id + '"] img'); if (img) ritaTumme(m, img); });
  }
  function visaMallar() {
    renderMallar(); showTab('mallar');
    setSheet(bottomSheet() ? 'full' : sheet);   /* mobil: hela arket, annars hamnar mallarna under skärmkanten */
  }
  function farga(blob, farg) {
    return blobToImage(blob).then(function (r) {
      var c = document.createElement('canvas'); c.width = r.img.naturalWidth; c.height = r.img.naturalHeight;
      var x = c.getContext('2d'); x.drawImage(r.img, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = farg; x.fillRect(0, 0, c.width, c.height);
      URL.revokeObjectURL(r.url);
      return new Promise(function (ok) { c.toBlob(function (b) { ok(b); }, 'image/png'); });
    });
  }
  /* mönstret i plaggets ton: vitt på mörka plagg, nästan svart på ljusa */
  function mallVersion(url, mork) {
    return hamtaBild(url).then(function (b) { return mork ? b : farga(b, '#1f1f1f'); }).then(blobToImage)
      .then(function (r) { return makeVersion(r.img, false, false).then(function (paper) { URL.revokeObjectURL(r.url); return { paper: paper, clean: null }; }); });
  }
  function anvandMall(m) {
    if (!m || !kanLaggaTill()) return;
    var mork = plaggArMorkt(), farg = mork ? '#ffffff' : '#1f1f1f';
    setBusy('Hämtar mallen …');
    var font = m.typsnitt || 'Playfair Display';
    Promise.all([Promise.all(m.delar.map(function (u) { return mallVersion(u, mork); })), loadFont(font)]).then(function (res) {
      var vers = res[0];
      commit();
      for (var k = layers.length - 1; k >= 0; k--) if (layers[k].mall) layers.splice(k, 1);   /* ny mall ersätter den förra på samma yta */
      var a = area(), vr = visibleRange(a), H = areaH(), cx = R_W * (vr.lo + vr.hi) / 2;
      var bredd = R_W * (vr.hi - vr.lo) * (m.storlek === 'mindre' ? 0.9 : 1);
      var t = null, th = 0;
      if (m.text) {
        addTextLayer(); t = layerById(selected);
        t.text = m.text; t.font = font; t.color = farg; t.rot = 0; t.align = 'center'; t.mall = m.id; t.mallText = m.text;
        t.size = 100; var mt = measureText(t, ctx); t.size = Math.min(H * 0.2, 100 * bredd * 0.94 / (mt.w || 1));
        th = measureText(t, ctx).h || t.size;
      }
      var L = mallLayout(m, vers.map(function (v) { return v.paper.ar; }), bredd, H, th);
      if (t) t.size *= L.ts;
      L.delar.forEach(function (o) {
        if (o.p === 'T') { t.x = cx; t.y = o.y; }
        else {
          addImageLayer(vers[m.delar.indexOf(o.p)], m.namn);
          var b = layerById(selected); b.w = bredd * L.f; b.x = cx; b.y = o.y; b.bg = true; b.mall = m.id; b.kalla = o.p; b.mork = mork;
        }
      });
      if (t) { var ti = layers.indexOf(t); layers.splice(ti, 1); layers.push(t); selected = t.id; }   /* rubriken överst i lagerlistan */
      setBusy(null); renderPanels(); draw(); renderOptions();
      if (bottomSheet()) setSheet('peek');   /* visa plagget med mallen */
      var pris = MALLTEXT_VARIANT ? ' Ändrar du rubriken tillkommer ' + money(MALLTEXT_PRIS) + '.' : '';
      toast(m.namn + ' ligger på plagget.' + pris, 3600);
    }).catch(function (e) { console.error('[Minnely-designern] mall', e); setBusy(null); toast('Mallen gick inte att hämta just nu. Försök igen.', 3200); });
  }
  /* Mallen ingår i priset. Ändrad rubrik, eller egen text/bild på samma yta som mallen = tillägget
     "Egen text på mall" (en gång per design). Flytta, skala och byta färg är gratis. */
  function mallAnpassad() {
    return SURF.some(function (id) {
      var arr = (id === placement ? layers : sides[id]) || []; if (!arr.some(function (l) { return l.mall; })) return false;
      return arr.some(function (l) {
        var harInnehall = l.type === 'image' || String(l.text || '').trim();
        if (!harInnehall) return false;
        if (!l.mall) return true;
        return l.type === 'text' && String(l.text || '').trim() !== String(l.mallText || '').trim();
      });
    });
  }
  function mallNamn() {
    var id = null; SURF.forEach(function (s) { ((s === placement ? layers : sides[s]) || []).forEach(function (l) { if (l.mall && !id) id = l.mall; }); });
    var m = id && mallById(id); return m ? m.namn : (id ? 'Mall' : '');
  }
  function malltextCount() { return MALLTEXT_VARIANT && mallAnpassad() ? 1 : 0; }
  /* byter kunden till ett ljust/mörkt plagg efter att mallen lagts: mönster och rubrik byter ton */
  function tonaMallar() {
    var mork = plaggArMorkt(), farg = mork ? '#ffffff' : '#1f1f1f', jobb = [];
    SURF.forEach(function (s) {
      ((s === placement ? layers : sides[s]) || []).forEach(function (l) {
        if (!l.mall) return;
        if (l.type === 'text' && /^#(ffffff|1f1f1f)$/i.test(l.color || '')) l.color = farg;
        if (l.type === 'image' && l.kalla && l.mork !== mork) {
          l.mork = mork;
          jobb.push(mallVersion(l.kalla, mork).then(function (v) { l.versions = v; assets[l.id] = { versions: v }; }));
        }
      });
    });
    if (jobb.length) Promise.all(jobb).then(function () { draw(); }).catch(function () {}); else draw();
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mall]'); if (!b) return;
    anvandMall(mallById(b.dataset.mall));
  });
  if (mallar().length) {
    var mallTab = q('[data-mnd-tab="mallar"]'); if (mallTab) mallTab.hidden = false;
  }

  function quickAddText() {
    if (!kanLaggaTill()) return;
    showTab('text');
    if (!bottomSheet()) { setSheet('half'); addTextAndEdit(); return; }
    /* mobil: panelen stannar nere så att plagget syns, och tangentbordet öppnas på texten där den hamnar */
    setSheet('peek');
    var tom = layers.filter(function (x) { return x.type === 'text' && !String(x.text || '').trim(); }).slice(-1)[0];
    if (tom) selected = tom.id; else { commit(); addTextLayer(); }
    renderPanels(); draw();
    var l = layerById(selected);
    requestAnimationFrame(function () { requestAnimationFrame(function () { fitStage(); draw(); inlineEdit(l); }); });
  }
  function chip(attr, icon, label, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mnd__chip';
    b.setAttribute(attr, '');
    b.innerHTML = icon + '<span>' + label + '</span>';
    b.addEventListener('click', onClick);
    return b;
  }
  function renderQuick() {
    var host = q('[data-mnd-quick]');
    if (!host || quickDone) return;
    quickDone = true;
    /* chippen först i raden – de är alltid samma två och ska inte flytta sig i sidled varje gång ett
       lager markeras. Lagerverktygen (placeTools) läggs efter dem. */
    var frag = document.createDocumentFragment();
    if (!BRODYR) frag.appendChild(chip('data-mnd-pick', ICON_PLUS, 'Bild', quickPick));
    if (mallar().length) frag.appendChild(chip('data-mnd-mallchip', ICON_MALL, 'Mallar', visaMallar));
    frag.appendChild(chip('data-mnd-add-text', ICON_TEXT, 'Text', quickAddText));
    host.insertBefore(frag, host.firstChild);
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Inställningsmenyn: ett kugghjul per lagerkort ----------
     Korten är en enda rad (miniatyr · namn · kugghjul). Allt pillande – bakgrund, spegla,
     dubblera, fyll, lagerordning, typsnitt, färg, storlek, kontur, ta bort – bor i den här
     menyn. Raderna bär SAMMA data-attribut som panelen hade förut (data-bg, data-flip,
     data-font, data-size …) så att de befintliga lyssnarna på root gör jobbet – ingen
     kopierad logik. Menyn ligger INNE i #mn-designer, därför fortsätter delegeringen att
     träffa den (och fokusfällan räknar den som en del av editorn). */
  function micon(d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  var ICON_GEAR = micon('<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>');
  var MICON = {
    bg: micon('<circle cx="6" cy="6" r="2.6"/><circle cx="6" cy="18" r="2.6"/><path d="M20 4 8.5 15.5M14.5 14.5 20 20M8.5 8.5 12 12"/>'),
    flip: micon('<path d="M12 3v18"/><path d="M8 7 3 12l5 5"/><path d="m16 7 5 5-5 5"/>'),
    dup: micon('<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M15 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1"/>'),
    fill: micon('<path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3"/><rect x="8" y="8" width="8" height="8" rx="1"/>'),
    back: micon('<path d="M12 5v14"/><path d="m6 13 6 6 6-6"/>'),
    front: micon('<path d="M12 19V5"/><path d="m6 11 6-6 6 6"/>'),
    del: micon('<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>'),
    font: micon('<path d="M5 6V4h14v2M12 4v16M9 20h6"/>'),
    color: micon('<path d="M12 2.8 6.6 8.2a7.6 7.6 0 1 0 10.8 0z"/>'),
    size: micon('<path d="M8 3 4 7l4 4"/><path d="M4 7h16"/><path d="m16 13 4 4-4 4"/><path d="M20 17H4"/>'),
    stroke: micon('<circle cx="12" cy="12" r="9" stroke-dasharray="3 3.2"/><circle cx="12" cy="12" r="3.6"/>')
  };

  var menuEl = null, menuCard = null, menuFor = null;
  function gearFor(id) { return q('[data-menu="' + id + '"]'); }
  function ensureMenu() {
    if (menuEl) return;
    menuEl = document.createElement('div');
    menuEl.className = 'mnd__menu';
    menuEl.setAttribute('data-mnd-menu', '');
    menuEl.hidden = true;
    /* role="dialog", inte role="menu": menyn innehåller reglage, typsnittschip, färgprickar och ett
       storleksreglage, och ARIA låter bara menuitem-liknande barn bo i en meny – en uppläsare i
       menyläge hoppar över precis de raderna. Som en liten dialog läses allt, och namnet (lagrets)
       säger vilket kort man ställer in, vilket behövs på mobil där arket täcker kortet. */
    menuEl.innerHTML = '<button type="button" class="mnd__menu-veil" data-mnd-menu-close aria-label="Stäng"></button>' +
      '<div class="mnd__menu-card" role="dialog" aria-modal="true" data-mnd-menu-card></div>';
    root.appendChild(menuEl);
    menuCard = q('[data-mnd-menu-card]', menuEl);
  }
  /* en vanlig rad: ikon + text, hela bredden */
  function mrow(attrs, icon, label, cls, disabled) {
    return '<button type="button" class="mnd__menu-row' + (cls ? ' ' + cls : '') + '"' + (disabled ? ' disabled' : '') + ' ' + attrs + '>' + icon + '<span>' + label + '</span></button>';
  }
  /* en rad med reglage (återanvänder .mnd__switch) */
  function mswitch(attr, id, on, icon, label, key) {
    return '<label class="mnd__menu-row mnd__menu-row--switch">' + icon + '<span>' + label + '</span>' +
      '<span class="mnd__switch"><input type="checkbox" ' + attr + '="' + id + '" data-mrow="' + key + '"' + (on ? ' checked' : '') + '><span></span></span></label>';
  }
  function imageMenu(l) {
    var i = layers.indexOf(l);
    return mswitch('data-bg', l.id, !l.bg, MICON.bg, 'Ta bort bakgrunden', 'bg') +
      mrow('data-flip="' + l.id + '" data-mrow="flip"' + (l.flip ? ' aria-pressed="true"' : ''), MICON.flip, 'Spegla') +
      mrow('data-dup="' + l.id + '" data-mrow="dup"', MICON.dup, 'Dubblera') +
      mrow('data-fill="' + l.id + '" data-mrow="fill"', MICON.fill, 'Fyll hela ytan') +
      mrow('data-mnd-menu-back data-id="' + l.id + '" data-mrow="back"', MICON.back, 'Lägg bakom', '', i <= 0) +
      mrow('data-mnd-menu-front data-id="' + l.id + '" data-mrow="front"', MICON.front, 'Lägg framför', '', i < 0 || i >= layers.length - 1) +
      '<hr class="mnd__menu-sep">' +
      /* "Ta bort bilden", inte bara "Ta bort": raden ovanför heter "Ta bort bakgrunden" och i ett
         ark med sju rader är färgen (röd) det enda som skiljer dem åt – det hör man inte */
      mrow('data-del="' + l.id + '" data-mrow="del"', MICON.del, 'Ta bort bilden', 'mnd__menu-row--danger');
  }
  /* symboler som läggs till sist i texten med ett tryck (hjärta bredvid namnen osv.); ritas i textens färg */
  var SYMBOLER = String(root.dataset.symboler || '♡ ♥ ☆ ★ ✿ ∞').split(/[\s,]+/).filter(Boolean).slice(0, 30);
  /* riktning och rader: längs ärmen (läses nedifrån), tvärs över, vänd (180°) och ny rad. Flera namn får
     varsin rad – på datorn gör Enter i textrutan en ny rad, på mobilen finns knappen. */
  function riktKnappar(l) {
    var arm = /sleeve/.test(String(placement)) || area().ar < 0.6, id = ' data-id="' + l.id + '"';
    var langsOn = Math.abs(Math.abs(l.rot) - Math.PI / 2) < 0.2, tvarsOn = Math.abs(l.rot) < 0.2 || Math.abs(Math.abs(l.rot) - Math.PI) < 0.2;
    /* snabbplatser: ärmen – mot mudden eller mitt på; bröstet – vid kragen, vänster bröst (litet) eller mitt på */
    var plats = arm
      ? '<button type="button" class="mnd__rbtn" data-plats="mudd"' + id + '>Mot mudden</button><button type="button" class="mnd__rbtn" data-plats="mitt"' + id + '>Mitt på ärmen</button>'
      : '<button type="button" class="mnd__rbtn" data-plats="krage"' + id + '>Vid kragen</button><button type="button" class="mnd__rbtn" data-plats="brost"' + id + '>Vänster bröst</button><button type="button" class="mnd__rbtn" data-plats="mitt"' + id + '>Mitt på</button>';
    return (arm ? '<button type="button" class="mnd__rbtn' + (langsOn ? ' is-on' : '') + '" data-rikt="tvars"' + id + '>Staplat uppåt</button><button type="button" class="mnd__rbtn' + (langsOn ? ' is-on' : '') + '" data-rikt="langs"' + id + '>Längs ärmen</button>' : '') +
      plats + '<button type="button" class="mnd__rbtn" data-rikt="vand"' + id + '>Vänd</button><button type="button" class="mnd__rbtn" data-nyrad' + id + '>+ Ny rad</button>';
  }
  /* längs ärmen ligger raderna tvärs över ärmen: tre–fyra namn får inte bli bredare än ärmen, så
     storleken krymper när rader läggs till (växer inte tillbaka av sig själv – kunden kan dra i hörnen) */
  function passaArm(l) {
    if (!l || l.type !== 'text' || !(/sleeve/.test(String(placement)) || area().ar < 0.6)) return;
    /* bara den del av ärmens bredd som syns i vyn: annars hamnar de yttre raderna utanför det
       kunden ser i förhandsvisningen (trycket hade rymts, men det ska synas som det blir) */
    var vr = visibleRange(area()), bredd = R_W * (vr.free ? 1 : Math.max(0.3, vr.hi - vr.lo));
    var langs = Math.abs(Math.abs(l.rot) - Math.PI / 2) < 0.2, tvars = Math.abs(l.rot) < 0.2 || Math.abs(Math.abs(l.rot) - Math.PI) < 0.2;
    if (langs) {
      var rader = String(l.text || '').split('\n').length, max = bredd * 0.6 / (1.15 * rader);
      if (l.size > max) l.size = Math.round(max);
    } else if (tvars) {
      /* tvärs över: den längsta raden ska rymmas över ärmen (namnen staplas uppåt längs ärmen) */
      var m = measureText(l, ctx);
      if (m.w > bredd * 0.86) l.size = Math.max(8, Math.floor(l.size * bredd * 0.86 / m.w));
    }
    l.x = Math.max(l.x, R_W * vr.lo + bredd * 0.5 * 0.98); l.x = Math.min(l.x, R_W * vr.hi - bredd * 0.5 * 0.98);
  }
  function textMenu(l) {
    var syms = !SYMBOLER.length ? '' : '<p class="mnd__menu-head">Lägg till symbol</p><div class="mnd__menu-field"><div class="mnd__syms">' +
      SYMBOLER.map(function (c) { return '<button type="button" class="mnd__sym" data-sym="' + esc(c) + '" data-id="' + l.id + '" data-mrow="sym-' + esc(c) + '" aria-label="Lägg till ' + esc(c) + '">' + esc(c) + '</button>'; }).join('') + '</div></div>';
    var fonts = syms + '<p class="mnd__menu-head" id="mnd-h-font">' + MICON.font + 'Typsnitt</p><div class="mnd__menu-field" role="group" aria-labelledby="mnd-h-font"><div class="mnd__fonts">' +
      FONTS.map(function (f) { var prov = String(l.text || '').trim().split('\n')[0].slice(0, 12) || 'Abc'; return '<button type="button" class="mnd__font' + (l.font === f[0] ? ' is-on' : '') + '" data-font="' + f[0] + '" data-id="' + l.id + '" data-mrow="font-' + f[0] + '" aria-label="' + f[1] + '"><span class="mnd__font-prov" style="font-family:\'' + f[0] + '\';font-weight:' + f[2] + '">' + esc(prov) + '</span><small>' + f[1] + '</small></button>'; }).join('') +
      '</div></div>';
    /* graverat: materialet bestämmer färgen, så färgraden är inget val */
    var colors = ENGRAVE ? '<p class="mnd__menu-note">Texten graveras i metallen, så färgen bestäms av materialet.</p>'
      : '<p class="mnd__menu-head" id="mnd-h-color">' + MICON.color + 'Färg</p><div class="mnd__menu-field" role="group" aria-labelledby="mnd-h-color"><div class="mnd__colors">' +
        TEXT_COLORS.map(function (c) { return '<button type="button" class="mnd__swatch' + (l.color === c ? ' is-on' : '') + '" style="background:' + c + '" data-color="' + c + '" data-id="' + l.id + '" data-mrow="color-' + c + '" aria-label="Färg ' + c + '"></button>'; }).join('') +
        '<label class="mnd__swatch mnd__swatch--custom"><input type="color" value="' + l.color + '" data-color-input="' + l.id + '" data-mrow="custom" aria-label="Egen färg"></label></div></div>';
    var rikt = '<p class="mnd__menu-head">Placering och rader</p><div class="mnd__menu-field"><div class="mnd__rikt">' + riktKnappar(l) + '</div></div>';
    return fonts + colors + rikt +
      '<div class="mnd__menu-field"><label class="mnd__range">' + MICON.size + '<span>Storlek</span>' +
        '<input type="range" min="3" max="60" value="' + Math.round(l.size / areaH() * 100) + '" data-size="' + l.id + '" data-mrow="size"></label></div>' +
      mswitch('data-stroke', l.id, l.stroke, MICON.stroke, 'Kontur runt texten', 'stroke') +
      mrow('data-dup="' + l.id + '" data-mrow="dup"', MICON.dup, 'Dubblera') +
      '<hr class="mnd__menu-sep">' +
      mrow('data-del="' + l.id + '" data-mrow="del"', MICON.del, 'Ta bort texten', 'mnd__menu-row--danger');
  }
  /* menyn ritas om efter varje renderPanels så att markeringar (typsnitt, färg, reglage) stämmer –
     fokus flyttas tillbaka till samma rad, precis som lägesväljaren gör */
  function renderMenu() {
    if (!menuFor || !menuCard) return;
    var l = layerById(menuFor); if (!l) return;
    var a = document.activeElement;
    var keep = a && a.getAttribute && menuCard.contains(a) ? a.getAttribute('data-mrow') : null;
    menuCard.setAttribute('aria-label', 'Inställningar för ' + layerName(l));
    menuCard.innerHTML = l.type === 'text' ? textMenu(l) : imageMenu(l);
    var again = keep ? menuCard.querySelector('[data-mrow="' + keep + '"]') : null;
    if (again && again.focus) again.focus({ preventScroll: true });
  }
  function focusFirstRow() {
    var f = menuCard.querySelector('button:not([disabled]), input:not([disabled])');
    if (f && f.focus) f.focus({ preventScroll: true });
  }
  /* desktop och liggande: fast placerad under kugghjulet, högerkant mot högerkant, vänds upp
     när den inte får plats under. Stående mobil: ark nederst i editorn (CSS) – inga inline-mått. */
  function positionMenu() {
    if (!menuFor || !menuCard) return;
    if (phonePortrait()) { menuCard.style.top = menuCard.style.left = menuCard.style.right = ''; return; }
    var g = gearFor(menuFor); if (!g) return;
    var r = g.getBoundingClientRect(), vh = window.innerHeight;
    menuCard.style.left = 'auto';
    menuCard.style.right = Math.max(8, Math.round(window.innerWidth - r.right)) + 'px';
    menuCard.style.top = '0px';
    var h = menuCard.offsetHeight, below = r.bottom + 8, above = r.top - 8 - h;
    var top = (below + h > vh - 8 && above > 8) ? above : Math.min(below, Math.max(8, vh - 8 - h));
    menuCard.style.top = Math.round(top) + 'px';
  }
  function openMenu(id) {
    if (!layerById(id)) return;
    if (menuFor === id) { closeMenu(id); return; }
    closeMenu(null);
    ensureMenu();
    /* Stående mobil: menyn är ett ark nederst, och står panelen i helt läge blir produkten en 7 rem
       hög remsa – men Storlek, Färg, Typsnitt och Spegla är just de reglage man måste SE resultatet
       av. Fäll ner till halvt så att scenen syns ovanför menyn. */
    if (phonePortrait() && sheet === 'full') setSheet('half');
    menuFor = id;
    /* menyn gäller ett lager – markera det, så att scenens verktyg pekar på samma sak */
    if (selected !== id) { selected = id; renderPanels(); draw(); } else renderMenu();
    menuEl.hidden = false;
    var g = gearFor(id); if (g) g.setAttribute('aria-expanded', 'true');
    positionMenu();
    menuEl.classList.remove('is-open');
    requestAnimationFrame(function () { if (menuFor === id) menuEl.classList.add('is-open'); });
    focusFirstRow();
  }
  /* stänger och lämnar tillbaka fokus till kugghjulet (skicka null när fokus ska vara ifred) */
  function closeMenu(focusId) {
    if (!menuFor) return;
    var id = menuFor;
    menuFor = null;
    menuEl.classList.remove('is-open');
    menuEl.hidden = true;
    menuCard.innerHTML = '';
    var old = gearFor(id); if (old) old.setAttribute('aria-expanded', 'false');
    var back = focusId === undefined ? id : focusId;
    var g = back ? gearFor(back) : null;
    if (g && g.focus) g.focus({ preventScroll: true });
  }
  /* efter en omritning: lagret borta → stäng, annars håll kugghjul och rader i synk */
  function syncMenuState() {
    if (!menuFor) return;
    if (!layerById(menuFor)) { closeMenu(null); return; }
    var g = gearFor(menuFor); if (g) g.setAttribute('aria-expanded', 'true');
    renderMenu();
  }
  /* pilarna vandrar mellan menyns rader (Esc tas om hand i editorns keydown längre ner) */
  root.addEventListener('keydown', function (e) {
    if (!menuFor) return;
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    if (!menuCard.contains(e.target) || e.target.type === 'range') return;
    var items = qa('button:not([disabled]), input:not([disabled])', menuCard);
    var i = items.indexOf(e.target);
    if (i < 0) return;
    e.preventDefault();
    e.stopPropagation();
    items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus({ preventScroll: true });
  });
  window.addEventListener('resize', function () { if (menuFor) positionMenu(); });

  /* namnet på kortet och i menyns aria-label */
  function layerName(l) { return l.type === 'text' ? (String(l.text || '').trim() || 'Text') : String(l.name || 'Teckning'); }
  /* Knappens namn för uppläsare är den SYNLIGA etiketten + lagrets namn ("Ändra teckning.jpg").
     WCAG 2.5.3: det man ser ska gå att säga – därför inte längre "Inställningar för …". */
  function gearLabel(l) { return TXT_GEAR + ' ' + layerName(l); }
  /* Samma sak för bakgrundschippen: tre teckningar i listan gav tre kryssrutor som ALLA hette
     "Ta bort bakgrunden" – uppläsaren kunde inte säga vilken teckning man höll på med. Den synliga
     texten står först, så WCAG 2.5.3 håller. */
  function bgLabel(l) { return (l.bg ? TXT_BG_OFF : TXT_BG_ON) + ' ' + layerName(l); }
  function gearHtml(l) {
    /* Ingen data-tip: etiketten står i knappen, bubblan på desktop hade bara upprepat den. */
    return '<button type="button" class="mnd__gear" data-menu="' + l.id + '" aria-haspopup="dialog" aria-expanded="' + (menuFor === l.id ? 'true' : 'false') + '" aria-label="' + esc(gearLabel(l)) + '">' + ICON_GEAR + '<span class="mnd__gear-label">' + esc(TXT_GEAR) + '</span></button>';
  }
  /* kortet ritas inte om medan man skriver (då tappar textrutan markören) – men kugghjulets
     etikett ska ändå säga rätt namn */
  function labelGear(l) {
    var g = gearFor(l.id);
    if (g) g.setAttribute('aria-label', gearLabel(l));
  }
  /* textrutan växer till två rader (7rem) i stället för att rulla inuti sig själv.
     En dold flik mäter 0 – då lämnas höjden till CSS tills fliken visas (showTab mäter om). */
  function fitTa(el) {
    el.style.height = 'auto';
    var h = el.scrollHeight;
    el.style.height = h ? Math.min(70, h) + 'px' : '';
  }

  function renderPanels() {
    var il = q('[data-mnd-image-layers]');
    var imgs = layers.filter(function (l) { return l.type === 'image' && !l.fast; });
    /* fokus ska överleva omritningen: bakgrundschippen sitter i kortet som byts ut här nedan */
    var act = document.activeElement;
    var keepBg = act && act.dataset && act.dataset.bg && il.contains(act) ? act.dataset.bg : null;
    il.innerHTML = imgs.map(function (l) {
      /* Kortets underrad är inte längre ett besked utan ett handgrepp: chippen ÄR reglaget för
         bakgrunden – samma data-bg och samma checked-betydelse (ikryssad = bakgrunden borta) som
         raden i menyn, alltså samma lyssnare och samma PhotoRoom-anrop. Det enda man nästan alltid
         vill göra ska inte kräva att man hittar en meny. Chippen hänger på l.bg, inte på om en
         frilagd version finns – annars blev kortet tyst i precis det läget där man slagit på och av
         igen. */
      var chip = '<label class="mnd__bgchip"><input type="checkbox" data-bg="' + l.id + '"' + (l.bg ? '' : ' checked') + ' aria-label="' + esc(bgLabel(l)) + '"><span>' + esc(l.bg ? TXT_BG_OFF : TXT_BG_ON) + '</span></label>';
      /* Gick friläggningen fel står anteckningen kvar UNDER chippen, inte i stället för den: byter vi
         ut chippen mot anteckningen försvinner kortets enda väg tillbaka, och l.note nollställs bara
         när man rör reglaget – kunden blev inlåst i just det läge som menyjakten skulle bort. Den bor i
         en egen rad över hela kortet: i mittkolumnen (som pillret smalnat av) blev samma mening fem
         rader hög i stället för tre. */
      var noteText = l.note || (l.lowres ? TXT_LOWRES : '');
      var note = noteText ? '<span class="mnd__layer-sub mnd__warn mnd__layer-note">' + esc(noteText) + '</span>' : '';
      /* namnet är en riktig knapp: kortet är det enda sättet att markera ett bildlager och en <div>
         går inte att nå med tangentbord. aria-pressed säger vilket lager som är valt. Miniatyren
         ligger utanför knappen – chippen är en <label> och får inte bo inuti en <button>. */
      return '<div class="mnd__layer' + (l.id === selected ? ' is-on' : '') + '" data-layer="' + l.id + '">' +
        '<img class="mnd__thumb" src="' + activeVersion(l).url + '" alt="">' +
        '<span class="mnd__layer-main">' +
          '<button type="button" class="mnd__pick" data-pick="' + l.id + '" aria-pressed="' + (l.id === selected ? 'true' : 'false') + '"><span class="mnd__layer-name">' + esc(layerName(l)) + '</span></button>' +
          chip +
        '</span>' +
        gearHtml(l) + note + '</div>';
    }).join('') || '<p class="mnd__muted">Ingen bild ännu. Ladda upp barnets teckning så börjar vi.</p>';
    /* tangentbord: chippen man nyss bockade i finns kvar som ett nytt element – lämna fokus där */
    if (keepBg) { var backEl = q('[data-bg="' + keepBg + '"]', il); if (backEl && backEl.focus) backEl.focus({ preventScroll: true }); }

    var tl = q('[data-mnd-text-layers]');
    var texts = layers.filter(function (l) { return l.type === 'text'; });
    tl.innerHTML = texts.map(function (l) {
      return '<div class="mnd__layer mnd__layer--text' + (l.id === selected ? ' is-on' : '') + '" data-layer="' + l.id + '">' +
        '<span class="mnd__badge" style="font-family:\'' + l.font + '\'" aria-hidden="true">Aa</span>' +
        '<textarea class="mnd__ta" rows="1" maxlength="60" placeholder="T.ex. Elsa, 5 år" data-id="' + l.id + '">' + esc(l.text) + '</textarea>' +
        gearHtml(l) + '</div>';
    }).join('') || '<p class="mnd__muted">Ingen text ännu.</p>';
    qa('.mnd__ta', tl).forEach(fitTa);

    renderQuick();
    renderOptions();
    updateHasContent();
    /* tomma-läget bara när ingen yta alls har innehåll (byte till en tom yta ska inte täcka produkten) */
    q('[data-mnd-empty]').hidden = surfacesWithContent().length > 0 || layers.length > 0 || !q('[data-mnd-busy]').hidden;
    var sel = selectedLayer();
    /* verktygsraden och tipset visas eller döljs i updatePreviewNote (via renderSides nedan) */
    q('[data-mnd-flip]').hidden = !(sel && sel.type === 'image');
    /* Bakom och Framför gör ingenting med ett enda lager på ytan, så de visas först när det finns två */
    q('[data-mnd-back]').hidden = q('[data-mnd-front]').hidden = layers.length < 2;
    q('[data-mnd-back]').disabled = !sel || layers.indexOf(sel) === 0;
    q('[data-mnd-front]').disabled = !sel || layers.indexOf(sel) === layers.length - 1;
    renderSides();
    syncMenuState();
    /* Kikhöjden beror på kikradens innehåll, och det är just det renderPanels nyss bytte ut. Mätningen
       i setSheet('peek') kommer för tidigt vid öppning (arket sätts innan första renderPanels, då raden
       är tom) och gav 113 px i stället för 189 – ett golv under kikhöjden, så första draget nedåt släppte
       fingret de sista ~76 px och snappade uppåt i stället för ner. Mät om här i stället. */
    measurePeek();
  }

  /* hela tryckytan: en streckad ruta, samma som tryckytans kontur på scenen. Flytta-pilarna den hade förut
     sa "här flyttar man", och det gör man nu också på produkten. */
  var ICON_AREA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="3.5" width="17" height="17" rx="2" stroke-dasharray="3.2 2.6"/></svg>';
  var ICON_EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  /* ytväljaren: Fram / Rygg / Vänster sida … med prick på ytor som har innehåll */
  function renderSides() {
    var host = q('[data-mnd-sides]'); if (!host) return;
    host.hidden = SURF.length < 2;
    host.classList.toggle('mnd__seg--select', SURF.length > 3);
    if (SURF.length < 2) { host.innerHTML = ''; }
    else if (SURF.length > 3) {
      /* många ytor (ryggsäck): kompakt rullgardin som inte täcker produkten på mobil */
      host.innerHTML = '<span>Yta</span><select data-mnd-side-select aria-label="Tryckyta">' + SURF.map(function (id) {
        return '<option value="' + esc(id) + '"' + (id === placement ? ' selected' : '') + '>' + esc(surfName(id)) + (lastYta(id) ? ' – färdigt tryck' : '') + (sideHasContent(id) ? ' ●' : '') + '</option>';
      }).join('') + '</select>';
    } else host.innerHTML = SURF.map(function (id) {
      return '<button type="button"' + (id === placement ? ' class="is-on"' : '') + ' data-mnd-side="' + esc(id) + '"' + (lastYta(id) ? ' title="Färdigt tryck"' : '') + '>' + esc(surfName(id)) + (lastYta(id) ? ' ✓' : '') + '<i class="mnd__dot" data-mnd-dot="' + esc(id) + '"' + (sideHasContent(id) ? '' : ' hidden') + '></i></button>';
    }).join('');
    /* Lägesväljaren nederst på scenen: På produkten (standard, därför först) | Hela tryckytan. Texterna kommer
       från temainställningarna. Vyns namn står i knappen på desktop när produkten har flera vinklar; på liten
       skärm får pilarna runt knappen inte plats med det, där visar bilden själv vilken sida man ser. Döljs
       medan tomma-läget täcker scenen så att de inte ligger ovanpå varandra på en kort mobilscen. */
    var mh = q('[data-mnd-modes]');
    if (mh) {
      var empty = q('[data-mnd-empty]');
      mh.hidden = !UV || !!(empty && !empty.hidden);
      if (UV) {
        var mode = modeOf(placement), y = TY.ytor[placement], views = y.vyer || [y.vy], view = viewOf(placement);
        var label = TXT_MODE_REAL + (views.length > 1 && !smallStage() ? ' · ' + viewLabel(view) : '');
        /* fokus ska överleva omritningen (tangentbord: ›  ›  › utan att börja om från toppen) */
        var focused = document.activeElement, refocus = null;
        if (focused && mh.contains(focused)) refocus = focused.hasAttribute('data-mnd-mode') ? '[data-mnd-mode="' + focused.getAttribute('data-mnd-mode') + '"]' : '[data-mnd-view-step="' + focused.getAttribute('data-mnd-view-step') + '"]';
        var modeBtn = function (m, icon, text) { return '<button type="button"' + (mode === m ? ' class="is-on"' : '') + ' aria-pressed="' + (mode === m) + '" data-mnd-mode="' + m + '">' + icon + '<span>' + esc(text) + '</span></button>'; };
        mh.innerHTML = (mode === 'real' && views.length > 1 ? '<button type="button" class="mnd__arrow" data-mnd-view-step="-1" aria-label="Föregående vinkel">‹</button>' : '') +
          modeBtn('real', ICON_EYE, label) +
          (mode === 'real' && views.length > 1 ? '<button type="button" class="mnd__arrow" data-mnd-view-step="1" aria-label="Nästa vinkel">›</button>' : '') +
          modeBtn('flat', ICON_AREA, TXT_MODE_FLAT);
        var again = refocus && q(refocus, mh);
        if (again) again.focus({ preventScroll: true });
      }
    }
    updatePreviewNote(area());
  }
  /* mobil: förklaringen under "Lägg till bild" döljs (CSS) så fort det finns bilder – lager på någon yta eller i biblioteket */
  function updateHasContent() {
    var any = libItems.length > 0 || SURF.some(function (id) {
      var arr = id === placement ? layers : sides[id];
      return !!arr && arr.some(function (l) { return l.type === 'image'; });
    });
    root.classList.toggle('mnd--has-content', any);
    var fvK = q('[data-mnd-forhandsvisa]');
    if (fvK) fvK.disabled = !surfacesWithContent().length;
  }
  root.addEventListener('click', function (e) {
    var st = e.target.closest('[data-mnd-view-step]');
    if (st) {
      /* "snurra" produkten: nästa/föregående kameravinkel */
      var y0 = TY.ytor[placement], vs = y0.vyer || [y0.vy], i0 = vs.indexOf(viewOf(placement));
      realView[placement] = vs[(i0 + Number(st.dataset.mndViewStep) + vs.length) % vs.length];
      renderSides(); draw(); return;
    }
    var b = e.target.closest('[data-mnd-mode]'); if (!b) return;
    /* kundens eget val: står kvar tills kunden själv byter (se defaultMode och flatFromPreview) */
    modes[placement] = b.dataset.mndMode;
    renderSides(); draw();
  });
  function syncPanelValues() {
    var l = selectedLayer();
    if (!l || l.type !== 'text') return;
    var r = q('[data-size="' + l.id + '"]');
    if (r) r.value = Math.round(l.size / areaH() * 100);
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu],[data-mnd-menu-close],[data-mnd-menu-back],[data-mnd-menu-front],[data-del],[data-dup],[data-flip],[data-fill],[data-sym],[data-font],[data-color],[data-rikt],[data-plats],[data-nyrad],[data-pick],[data-layer],[data-mnd-side]');
    if (!t) return;
    if (t.dataset.menu) { openMenu(t.dataset.menu); return; }
    if (t.hasAttribute('data-mnd-menu-close')) { closeMenu(); return; }
    /* raderna som ändrar lagerlistan stänger menyn FÖRST – annars pekar den på ett kort som ritats om */
    if (t.hasAttribute('data-mnd-menu-back')) { var idb = t.dataset.id; closeMenu(idb); moveLayer(idb, -1); focusGear(idb); return; }
    if (t.hasAttribute('data-mnd-menu-front')) { var idf = t.dataset.id; closeMenu(idf); moveLayer(idf, 1); focusGear(idf); return; }
    if (t.dataset.del) { var idl = t.dataset.del; closeMenu(null); removeLayer(idl); return; }
    if (t.dataset.fill) { fillArea(t.dataset.fill); return; }
    if (t.dataset.dup) { var idd = t.dataset.dup; closeMenu(null); duplicateLayer(idd); return; }
    if (t.dataset.flip) { var lf = layerById(t.dataset.flip); if (!lf) return; commit(); lf.flip = !lf.flip; selected = lf.id; renderPanels(); draw(); return; }
    if (t.dataset.sym) {
      var ls = layerById(t.dataset.id); if (!ls) return; commit();
      var txt = String(ls.text || '');
      ls.text = (txt && !/\s$/.test(txt) ? txt + ' ' : txt) + t.dataset.sym; selected = ls.id;
      var ta = q('[data-mnd-text-layers] textarea[data-id="' + ls.id + '"]'); if (ta) { ta.value = ls.text; fitTa(ta); }
      syncInline(ls); renderPanels(); draw(); return;
    }
    if (t.dataset.rikt) {
      var lr = layerById(t.dataset.id); if (!lr) return; commit();
      if (t.dataset.rikt === 'langs') { lr.rot = -Math.PI / 2; passaArm(lr); }
      else if (t.dataset.rikt === 'tvars') { lr.rot = 0; passaArm(lr); }
      else { lr.rot += Math.PI; if (lr.rot > Math.PI) lr.rot -= 2 * Math.PI; }
      selected = lr.id; syncInline(lr); renderPanels(); draw(); return;
    }
    if (t.dataset.plats) {
      var lp = layerById(t.dataset.id); if (!lp) return; commit();
      var vr = visibleRange(area()), cx = R_W * (vr.lo + vr.hi) / 2, top = vr.vlo != null ? areaH() * vr.vlo : 0, bot = vr.vhi != null ? areaH() * vr.vhi : areaH();
      var m = measureText(lp, ctx), hh = (m.h || lp.size) / 2, ww = (m.w || lp.size) / 2;
      if (t.dataset.plats === 'mudd') { var vrid = Math.abs(Math.abs(lp.rot) - Math.PI / 2) < 0.2; lp.x = cx; lp.y = bot - (vrid ? ww : hh) - R_W * 0.08; }
      else if (t.dataset.plats === 'krage') { lp.x = cx; lp.y = top + hh + R_W * 0.03; }
      else if (t.dataset.plats === 'brost') { lp.size = Math.round(areaH() * 0.06); var m2 = measureText(lp, ctx); lp.x = R_W * 0.22 + (m2.w || lp.size) / 2; lp.y = top + (m2.h || lp.size) / 2 + R_W * 0.05; }
      else { lp.x = cx; lp.y = (top + bot) / 2; }
      selected = lp.id; syncInline(lp); renderPanels(); draw(); return;
    }
    if (t.hasAttribute('data-nyrad')) {
      var ln = layerById(t.dataset.id); if (!ln) return;
      var ia = stage.querySelector('.mnd__inline');
      if (!ia || inlineId !== ln.id) { inlineEdit(ln); ia = stage.querySelector('.mnd__inline'); }
      if (!ia) return;
      var p0 = ia.selectionStart == null ? ia.value.length : ia.selectionStart, p1 = ia.selectionEnd == null ? p0 : ia.selectionEnd;
      ia.value = ia.value.slice(0, p0) + '\n' + ia.value.slice(p1);
      ia.setSelectionRange(p0 + 1, p0 + 1); ia.dispatchEvent(new Event('input')); ia.focus();
      return;
    }
    if (t.dataset.font) { var l = layerById(t.dataset.id); commit(); l.font = t.dataset.font; selected = l.id; loadFont(l.font).then(function () { syncInline(l); renderPanels(); draw(); }); return; }
    if (t.dataset.color) { var l2 = layerById(t.dataset.id); commit(); l2.color = t.dataset.color; selected = l2.id; syncInline(l2); renderPanels(); draw(); return; }
    if (t.dataset.mndSide) { setPlacement(t.dataset.mndSide); return; }
    /* bildkortets väljarknapp (miniatyr + namn) – samma sak som ett klick på raden, men nåbar med
       tangentbord. Den ligger före data-layer: knappen bär båda och raden skulle annars kollas bort. */
    if (t.dataset.pick) { selected = t.dataset.pick; renderPanels(); draw(); return; }
    if (t.dataset.layer && !e.target.closest('input,textarea,button,label')) { selected = t.dataset.layer; renderPanels(); draw(); }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.dataset.id && t.tagName === 'TEXTAREA') { var l = layerById(t.dataset.id); if (!l) return; if (!t._committed) { commit(); t._committed = true; } var had = !!l.text.trim(); l.text = t.value; passaArm(l); fitTa(t); labelGear(l); selected = l.id; scheduleDraw(); if (had !== !!t.value.trim()) { renderOptions(); qa('[data-mnd-dot]').forEach(function (d) { d.hidden = !sideHasContent(d.dataset.mndDot); }); } return; }
    if (t.dataset.size) { var l2 = layerById(t.dataset.size); if (!l2) return; if (!t._committed) { commit(); t._committed = true; } l2.size = areaH() * (Number(t.value) / 100); selected = l2.id; scheduleDraw(); return; }
    if (t.dataset.colorInput) { var l3 = layerById(t.dataset.colorInput); if (!l3) return; l3.color = t.value; selected = l3.id; scheduleDraw(); return; }
  });
  /* Chippens text ska vända direkt när man trycker: friläggningen tar ett par sekunder och kortet
     ritas inte om förrän den är klar – utan det här stod det "✓ Ta bort bakgrunden" under tiden.
     Lyssnaren ligger FÖRE den som gör jobbet (den körs alltså först) och rör bara etiketten;
     nästa renderPanels sätter samma text igen. */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.dataset || !t.dataset.bg) return;
    /* classList, inte className: en jämförelse mot hela strängen hade tystnat i tysthet den dag
       chippen får en klass till, och då stod fel ord kvar under friläggningen. */
    var chip = t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('mnd__bgchip') ? t.parentNode.querySelector('span') : null;
    if (!chip) return;
    var lc = layerById(t.dataset.bg);
    var txt = t.checked ? TXT_BG_ON : TXT_BG_OFF;
    chip.textContent = txt;
    t.setAttribute('aria-label', lc ? txt + ' ' + layerName(lc) : txt);
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset.bg) {
      var l = layerById(t.dataset.bg); if (!l) return;
      setBgRemoved(l, t.checked);
    }
    if (t.dataset.stroke) {
      var ls = layerById(t.dataset.stroke); if (!ls) return;
      commit(); ls.stroke = !!t.checked; selected = ls.id; draw();
    }
    if (t.tagName === 'TEXTAREA' || t.dataset.size) t._committed = false;
  });
  root.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t.dataset && t.dataset.id && t.tagName === 'TEXTAREA') {
      selected = t.dataset.id;
      qa('.mnd__layer').forEach(function (x) { x.classList.toggle('is-on', x.dataset.layer === selected); });
      /* kortet ritas inte om medan man skriver – men bildkortens aria-pressed måste ändå släppa taget */
      qa('.mnd__pick').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.pick === selected ? 'true' : 'false'); });
      draw();
    }
  });

  var fontsLoaded = {};
  /* Bakgrunden bort (removed = true) eller tillbaka, för bildkortets chip och snabbknappen på scenen */
  function setBgRemoved(l, removed) {
    /* Anteckningen hörde till förra friläggningen. Rör man reglaget igen är den inaktuell – och
       eftersom ingen annan rad i filen nollställer l.note skulle den annars stå kvar hela besöket. */
    l.note = null;
    var apply = function () {
      commit();
      var h = l.w / l.ar;
      l.bg = !removed;
      l.ar = activeVersion(l).ar;
      l.w = Math.min(R_W * 2.5, h * l.ar);
      clampLayer(l);
      renderPanels(); draw();
    };
    if (removed && !l.versions.clean) { makeClean(l).then(apply).catch(function () { renderPanels(); }); } else apply();
  }
  if (bgQuick) bgQuick.addEventListener('click', function () {
    var l = bgTarget();
    if (!l || l._cleaning) return;
    selected = l.id;
    setBgRemoved(l, !!l.bg);
  });

  function loadFont(name) {
    if (fontsLoaded[name]) return fontsLoaded[name];
    if (!(document.fonts && document.fonts.load)) return Promise.resolve();
    fontsLoaded[name] = document.fonts.load(fontWeight(name) + ' 32px "' + name + '"').then(function (faces) {
      if (!faces || !faces.length) delete fontsLoaded[name]; /* inte laddat än – försök igen nästa gång */
    }).catch(function () { delete fontsLoaded[name]; });
    return fontsLoaded[name];
  }
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { if (!root.hidden) scheduleDraw(); });

  /* produktalternativ: speglar produktformuläret. Färg som prickar, övriga
     alternativ som rullista – alltid synliga ovanför flikarna */
  function renderOptions() {
    var host = q('[data-mnd-options]');
    if (!PRODUCT) { host.innerHTML = ''; return; }
    var vals = selectedValues();
    var html = '';
    options.forEach(function (o, oi) {
      if (o.values.length < 2) return;
      var isColor = o.name === 'Färg';
      /* storleken står som "Välj storlek" tills kunden själv valt (se sizePicked) */
      var need = o === sizeOpt && !sizePicked;
      html += '<div class="mnd__opt' + (isColor ? ' mnd__opt--color' : '') + (need ? ' is-need' : '') + '"><span class="mnd__opt-name">' + esc(o.name) + (isColor ? ': <strong>' + esc(vals[oi] || '') + '</strong>' : '') + '</span>';
      if (isColor) {
        html += '<div class="mnd__opt-values">';
        o.values.forEach(function (v) {
          var avail = PRODUCT.variants.some(function (va) { return va.options[oi] === v && va.available && va.options.every(function (x, i) { return i === oi || vals[i] == null || x === vals[i]; }); });
          var hex = COLOR_HEX[v];
          html += '<button type="button" class="mnd__cswatch' + (vals[oi] === v ? ' is-on' : '') + (avail ? '' : ' is-off') + '" data-opt="' + esc(o.name) + '" data-val="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '">' +
            (hex ? '<span style="background:' + hex + '"></span>' : '<small>' + esc(v) + '</small>') + '</button>';
        });
        html += '</div>';
      } else {
        html += '<select class="mnd__select" data-opt-select="' + esc(o.name) + '" aria-label="' + esc(o.name) + '">';
        if (need) html += '<option value="" selected disabled>' + esc(TXT_SIZE_PROMPT) + '</option>';
        sortedValues(o).forEach(function (v) {
          var avail = PRODUCT.variants.some(function (va) { return va.options[oi] === v && va.available && va.options.every(function (x, i) { return i === oi || vals[i] == null || x === vals[i]; }); });
          html += '<option value="' + esc(v) + '"' + (vals[oi] === v && !need ? ' selected' : '') + (avail ? '' : ' disabled') + '>' + esc(v) + (avail ? '' : ', slut') + '</option>';
        });
        html += '</select>';
      }
      html += '</div>';
    });
    host.innerHTML = html;
    host.hidden = !html;
    var v = currentVariant();
    var n = extraCount(), mt = malltextCount();
    var extra = (n > 0 && EXTRA_VARIANT ? EXTRA_PRIS * n : 0) + mt * MALLTEXT_PRIS;
    var priceStr = money(((v ? v.price : PRODUCT.price) + extra) * qty);
    q('[data-mnd-price]').textContent = priceStr;
    /* samma pris i knappen – syns bara på stående mobil där prisraden är dold (CSS); inte när varianten är slut */
    /* Köpknappen säger vad som är nästa steg: ladda upp en bild, välj storlek, eller lägg i varukorgen.
       Priset i knappen hör bara till det sista. Broderade produkter har bara text och behåller texten. */
    var empty = !BRODYR && !surfacesWithContent().length;
    var sizeNeeded = !empty && needsSize();
    var soldOut = !!(v && !v.available) && !sizeNeeded;
    var ctaPrice = q('[data-mnd-cta-price]');
    if (ctaPrice) { ctaPrice.textContent = priceStr; ctaPrice.hidden = soldOut || empty || sizeNeeded; }
    /* extra tryckytor kostar extra: på stående mobil visas prisraden (med förklaringen) i stället för priset i knappen */
    root.classList.toggle('mnd--extra-tryck', n > 0 || mt > 0);
    var note = q('[data-mnd-price-note]');
    if (note) {
      note.hidden = !n && !mt;
      var names = surfacesWithContent().slice(1).map(surfName).join(', ');
      var delar = [];
      if (n) delar.push(EXTRA_VARIANT ? 'extra tryck (' + names + ') ' + (n > 1 ? n + ' × ' : '') + money(EXTRA_PRIS) : 'tryck på flera ytor');
      if (mt) delar.push('egen text på mallen ' + money(MALLTEXT_PRIS));
      note.textContent = delar.length ? 'inkl. ' + delar.join(' och ') : '';
    }
    q('[data-mnd-add-to-cart]').disabled = soldOut && !empty;
    q('[data-mnd-add-to-cart]').classList.toggle('is-next', empty || sizeNeeded);
    q('[data-mnd-cta-label]').textContent = empty ? TXT_CTA_EMPTY : sizeNeeded ? TXT_SIZE_PROMPT : soldOut ? 'Slut i den varianten' : (EDIT_LINE ? 'Uppdatera varukorgen' : 'Lägg i varukorgen');
  }
  /* Köpknappen när storleken inte är vald: visa storleksrutan (fäll ihop arket så att den syns) och öppna
     den där webbläsaren kan. Rutan blinkar till så att ögat hittar den. */
  function promptSize() {
    if (bottomSheet() && sheet !== 'peek') setSheet('peek');
    /* textraden döljer produktvalen (färg, storlek) medan en text är markerad: avmarkera så att storleken syns */
    if (inlineId) inlineStop();
    if (selected) { selected = null; renderPanels(); draw(); }
    var sel = q('[data-opt-select="' + (sizeOpt ? sizeOpt.name : 'Storlek') + '"]');
    if (!sel) return;
    toast(TXT_SIZE_PROMPT + ' här nere', 2200);
    sel.classList.remove('is-pulse');
    void sel.offsetWidth;
    sel.classList.add('is-pulse');
    sel.focus({ preventScroll: true });
    try { if (typeof sel.showPicker === 'function') sel.showPicker(); } catch (err) { /* stöds inte överallt, fokus räcker */ }
  }
  /* storleken vald på sidan (pillren) eller i designern: räknas som vald även om kunden trycker på den
     storlek som redan var förvald, därför click och inte bara change */
  function markSizePicked(e) {
    if (sizePicked || !sizeOpt || !e.target || !e.target.matches) return;
    var n = sizeOpt.name;
    if (!e.target.matches('input[data-option-name="' + n + '"], select[name="options[' + n + ']"], select[data-opt-select="' + n + '"]')) return;
    if (e.target.tagName === 'SELECT' && !e.target.value) return;
    sizePicked = true;
  }
  document.addEventListener('click', markSizePicked, true);
  document.addEventListener('change', markSizePicked, true);
  function chooseOption(name, value) {
    var inp = formOptionInput(name, value);
    if (inp) inp.click();
    else {
      var sel = optionSelect(name);
      if (sel) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    setTimeout(function () { if (tillampaForm()) renderSides(); if (name === 'Färg') tonaMallar(); renderOptions(); draw(); }, 60);
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-opt]');
    if (!t) return;
    chooseOption(t.dataset.opt, t.dataset.val);
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset && t.dataset.optSelect) chooseOption(t.dataset.optSelect, t.value);
    if (t.hasAttribute && t.hasAttribute('data-mnd-side-select')) setPlacement(t.value);
  });
  document.addEventListener('change', function (e) {
    if (root.hidden || !e.target || !e.target.matches) return;
    if (e.target.matches('input[data-option-name], select[name^="options["]')) { if (tillampaForm()) renderSides(); renderOptions(); scheduleDraw(); }
  });

  /* antal: speglas till produktsidans antalsfält */
  var qty = 1;
  var qtyInput = q('[data-mnd-qty]');
  function pageQtyInput() { return document.querySelector('.product-form__quantity input[name="quantity"], input.quantity__input[name="quantity"]'); }
  function setQty(n) {
    qty = Math.max(1, Math.min(99, Math.round(Number(n) || 1)));
    qtyInput.value = qty;
    var pq = pageQtyInput();
    if (pq && Number(pq.value) !== qty) { pq.value = qty; pq.dispatchEvent(new Event('change', { bubbles: true })); }
    renderOptions();
  }
  q('[data-mnd-qty-minus]').addEventListener('click', function () { setQty(qty - 1); });
  q('[data-mnd-qty-plus]').addEventListener('click', function () { setQty(qty + 1); });
  qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

  /* ---------- Export: hela tryckytan som EN fil ---------- */

  function renderPrintFile(grupp) {
    var c = document.createElement('canvas');
    if (UV && grupp) {
      /* en tryckfil per Printify-yta; flera designytor (kuddens fram/bak) läggs in i sina delar av filen */
      var fil = TY.filer[grupp] || [3000, 3000];
      var W = Math.min(PRINT_MAX_SIDE, fil[0]), H = Math.round(W * fil[1] / fil[0]);
      if (H > PRINT_MAX_SIDE) { H = PRINT_MAX_SIDE; W = Math.round(H * fil[0] / fil[1]); }
      c.width = W; c.height = H;
      var g = c.getContext('2d');
      surfacesOf(grupp).forEach(function (sid) {
        if (!sideHasContent(sid)) return;
        var y = TY.ytor[sid];
        var x0 = Math.round(y.del[0] * W), y0 = Math.round(y.del[1] * H), w = Math.round((y.del[2] - y.del[0]) * W), h = Math.round((y.del[3] - y.del[1]) * H);
        var t = document.createElement('canvas'); t.width = w; t.height = h;
        withSide(sid, function () { renderArea(t, w / R_W, { preview: false }); });
        g.drawImage(t, x0, y0);
      });
      return canvasBlob(c, 'image/png').then(function (b) { return { blob: b, canvas: c }; });
    }
    var a = area();
    var yta = (TY && TY.yta && (TY.yta[placement === 'back' && TY.back ? 'back' : 'front'] || TY.yta.front)) || [3000, Math.round(3000 / a.ar)];
    var W2 = Math.min(PRINT_MAX_SIDE, yta[0]);
    var H2 = Math.round(W2 / a.ar);
    if (H2 > PRINT_MAX_SIDE) { H2 = PRINT_MAX_SIDE; W2 = Math.round(H2 * a.ar); }
    c.width = W2; c.height = H2;
    renderArea(c, W2 / R_W, { preview: false });
    return canvasBlob(c, 'image/png').then(function (b) { return { blob: b, canvas: c }; });
  }

  /* stora filer laddas upp direkt till Blob-lagringen (kringgår funktionsgränsen);
     små via proxyn; sista utväg: skala ned tills den ryms */
  function uploadPrintFile(res) {
    var blob = res.blob, current = res.canvas;
    function viaServer(b) {
      return fetch(SAVE_URL, { method: 'POST', headers: { 'content-type': 'image/png' }, body: b })
        .then(function (r) { if (!r.ok) throw new Error('spara misslyckades'); return r.json(); }).then(function (d) { return d.url; });
    }
    function shrinkUntilFits(b) {
      if (b.size <= MAX_UPLOAD_BYTES || Math.max(current.width, current.height) <= 1800) return viaServer(b);
      var s = document.createElement('canvas');
      s.width = Math.round(current.width * 0.82); s.height = Math.round(current.height * 0.82);
      var sx = s.getContext('2d'); sx.imageSmoothingEnabled = true; sx.imageSmoothingQuality = 'high';
      sx.drawImage(current, 0, 0, s.width, s.height);
      current = s;
      return canvasBlob(s, 'image/png').then(shrinkUntilFits);
    }
    if (blob.size <= MAX_UPLOAD_BYTES) return viaServer(blob);
    if (!CLIENT_UPLOAD_URL) return shrinkUntilFits(blob);
    /* direktuppladdning till Blob-lagringen (Vercel Blobs klientprotokoll, utan bibliotek):
       1) be vår proxy om en klienttoken, 2) PUT filen direkt till blob.vercel-storage.com */
    var pathname = 'teckningar/tryck-' + Date.now() + '.png';
    return fetch(CLIENT_UPLOAD_URL, { method: 'POST', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ type: 'blob.generate-client-token', payload: { pathname: pathname, callbackUrl: CLIENT_UPLOAD_URL, clientPayload: null, multipart: false } }) })
      .then(function (r) { if (!r.ok) throw new Error('token ' + r.status); return r.json(); })
      .then(function (d) {
        if (!d || !d.clientToken) throw new Error('ingen klienttoken');
        return fetch('https://blob.vercel-storage.com/' + pathname, { method: 'PUT', body: blob,
          headers: { authorization: 'Bearer ' + d.clientToken, 'x-api-version': '7', 'x-content-type': 'image/png' } });
      })
      .then(function (r) { if (!r.ok) throw new Error('put ' + r.status); return r.json(); })
      .then(function (r) { if (!r || !r.url) throw new Error('inget url-svar'); return r.url; })
      .catch(function (err) { console.warn('[Minnely-designern] direktuppladdning misslyckades, skalar ned', err); return shrinkUntilFits(blob); });
  }

  function galleryDataUrl(sizeOpt) {
    if (!mockImg) return null;
    var size = sizeOpt || 1400, a = area(), nw = mockImg.naturalWidth, nh = mockImg.naturalHeight;
    var s = size / Math.max(nw, nh), mw = nw * s, mh = nh * s, mx = (size - mw) / 2, my = (size - mh) / 2;
    var out = document.createElement('canvas'); out.width = size; out.height = size;
    var o = out.getContext('2d');
    o.fillStyle = '#ffffff'; o.fillRect(0, 0, size, size);
    o.drawImage(mockImg, mx, my, mw, mh);
    if (a.uv) { if (!composeUV(o, mockImg, a.view, { x: mx, y: my, w: mw, h: mh }, { scale: 1, max: size }, false)) return null; }
    else composeOnMock(o, mockImg, a, { x: mx + a.box.l * mw, y: my + a.box.t * mh, w: a.box.w * mw, h: a.box.h * mh }, 1, false);
    try { return out.toDataURL('image/jpeg', 0.88); } catch (e) { return null; }
  }
  /* komposit för en hel vy (kamera) – alla ytor som syns i den */
  function viewDataUrl(view, im, sizeOpt) {
    var size = sizeOpt || 1400, nw = im.naturalWidth, nh = im.naturalHeight;
    var s = size / Math.max(nw, nh), mw = nw * s, mh = nh * s, mx = (size - mw) / 2, my = (size - mh) / 2;
    var out = document.createElement('canvas'); out.width = size; out.height = size;
    var o = out.getContext('2d');
    o.fillStyle = '#ffffff'; o.fillRect(0, 0, size, size);
    o.drawImage(im, mx, my, mw, mh);
    if (!composeUV(o, im, view, { x: mx, y: my, w: mw, h: mh }, { scale: 1, max: size }, false)) return null;
    try { return out.toDataURL('image/jpeg', 0.88); } catch (e) { return null; }
  }

  /* dolda fält för extra tryckfiler (properties[_teckning_<yta>]) skapas i formuläret vid behov */
  function extraFileInputs(files) {
    var main = document.querySelector('input[data-bt-teckning]');
    var form = main && main.closest('form'); if (!form) return;
    qa('input[data-mnd-extra-file]', form).forEach(function (i) { i.remove(); });
    Object.keys(files).forEach(function (grupp) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[_teckning_' + grupp + ']'; i.value = files[grupp]; i.setAttribute('data-mnd-extra-file', grupp);
      form.appendChild(i);
    });
  }
  /* Designen som den såg ut när den senast sparades till sidan. Krysset sparar bara när något ändrats. */
  var savedKey = null, saving = false;
  function designKey() {
    sides[placement] = layers;
    var o = {};
    SURF.forEach(function (id) { o[id] = stripLayers(sides[id]).map(function (l) { var c = {}; Object.keys(l).forEach(function (k) { if (k.charAt(0) !== '_') c[k] = l[k]; }); return c; }); });
    return JSON.stringify(o);
  }
  /* closing = krysset (eller Esc): designen sparas till produktsidan och designern stängs, så att kunden
     ser sin bild på sidan och kan välja storlek där. Förut stängde krysset utan att spara, sidan visade
     en tom tröja och kunden trodde att bilden var borta. */
  function applyDesign(addToCart, closing) {
    var withContent = surfacesWithContent();
    if (!withContent.length) { if (closing) { close(); return; } showTab('bild'); fileInput.click(); return; }
    if (!SAVE_URL) { if (closing) close(); return; }
    if (saving) return;
    saving = true;
    if (closing) setBusy(TXT_SAVING);
    var btns = qa('[data-mnd-apply]');
    btns.forEach(function (b) { b.disabled = true; });
    var label = q('[data-mnd-cta-label]'); var orig = label.textContent; label.textContent = 'Sparar …';
    sides[placement] = layers;
    var all = [];
    SURF.forEach(function (id) { all = all.concat(sides[id]); });
    var used = all.filter(function (l) { return l.type === 'text'; }).map(function (l) { return l.font; });
    /* en tryckfil per Printify-yta (UV) eller per sida (fram/rygg) */
    var groups = UV ? Object.keys(TY.grupper).filter(function (g) { return surfacesOf(g).some(sideHasContent); }) : withContent;
    var exportGroup = function (g) {
      return (UV ? renderPrintFile(g) : withSide(g, function () { return renderPrintFile(); })).then(uploadPrintFile);
    };
    var urls = {};
    var chain = Promise.all(used.map(loadFont)).then(function () { return document.fonts && document.fonts.ready ? document.fonts.ready : null; });
    groups.forEach(function (g) { chain = chain.then(function () { return exportGroup(g); }).then(function (u) { urls[g] = u; }); });
    var previewUrl = null;
    chain = chain.then(function () { return previewBlob(withContent); }).then(function (b) { return b ? uploadSmall(b).catch(function () { return null; }) : null; }).then(function (u) { previewUrl = u; });
    chain
      .then(function () {
        var texts = all.filter(function (l) { return l.type === 'text' && l.text.trim(); }).map(function (l) { return l.text.trim().replace(/\s+/g, ' '); }).join(' · ');
        var mainGroup = groups[0], mainUrl = urls[mainGroup];
        var extra = {};
        groups.slice(1).forEach(function (g) { extra[g === 'back' && !UV ? 'rygg' : g] = urls[g]; });
        var placering = withContent.map(surfName).join(' + ');
        /* ytor med innehåll + vilken property som bär deras tryckfil (varukorgen visar chips och kan ta bort) */
        var propOf = function (g) { return g === mainGroup ? '_teckning' : (g === 'back' && !UV ? '_teckning_rygg' : '_teckning_' + g); };
        var ytor = withContent.map(function (id) { var g = UV ? TY.ytor[id].grupp : id; return { id: id, namn: surfName(id), grupp: g, fil: propOf(g) }; });
        var designId = saveDesignRecord();
        setHiddenProp('_design', designId);
        setHiddenProp('_ytor', JSON.stringify(ytor));
        setHiddenProp('_per', String(Math.max(0, ytor.length - 1)));
        setHiddenProp('_xv', ytor.length > 1 && EXTRA_VARIANT ? String(EXTRA_VARIANT) : '');
        var mtNu = malltextCount(), mNamn = mallNamn();
        setHiddenProp('_mt', mtNu ? '1' : (mNamn ? '0' : ''));
        setHiddenProp('_mtv', mtNu ? String(MALLTEXT_VARIANT) : '');
        setHiddenProp('Mall', mNamn ? mNamn + (mtNu ? ', egen text' : '') : '');
        setHiddenProp('_forhandsvisning', previewUrl || '');
        forhandsVariant = selectedValues().join('|');
        document.querySelectorAll('input[data-bt-teckning]').forEach(function (i) { i.value = mainUrl; });
        /* rygg (legacy-fältet) + övriga ytor som egna fält */
        document.querySelectorAll('input[data-bt-teckning-rygg]').forEach(function (i) { i.value = extra.rygg || extra.back || ''; i.disabled = !i.value; });
        delete extra.rygg; delete extra.back;
        extraFileInputs(extra);
        document.querySelectorAll('input[data-bt-layout]').forEach(function (i) { i.value = 'x:0.5,y:0.5,s:1'; });
        document.querySelectorAll('input[data-bt-placering]').forEach(function (i) { i.value = placering; });
        document.querySelectorAll('input[data-bt-text]').forEach(function (i) { i.value = texts; i.disabled = !texts; });
        document.querySelectorAll('[data-bt-start]').forEach(function (w) { w.classList.add('bt-start--done'); w.classList.remove('bt-start--added'); });
        document.body.classList.add('mnd-has-design');
        savedKey = designKey();
        var thumb = all.filter(function (l) { return l.type === 'image'; })[0];
        /* Miniatyren i "Din design är klar" visar produkten med designen på. Den råa bilden låg
           tidigare här via en tillfällig blob-adress, som slutar fungera när designern byter
           bildversion (till exempel när bakgrunden tas bort) och då visades bara en trasig bild.
           Förhandsbilden är uppladdad och har en riktig adress. */
        document.querySelectorAll('[data-bt-thumb]').forEach(function (img) {
          if (previewUrl) { img.src = previewUrl; img.alt = 'Din design på ' + (root.dataset.productTitle || 'produkten').toLowerCase(); }
          else if (thumb) img.src = activeVersion(thumb).url;
        });
        refreshGallery();
        close();
        if (addToCart) return addToCartNow();
      })
      .catch(function (err) { console.error('[Minnely-designern]', err); alert('Det gick inte att spara designen just nu. Försök igen om en stund.'); if (closing) close(); })
      .finally(function () { saving = false; if (closing) setBusy(null); btns.forEach(function (b) { b.disabled = false; }); label.textContent = orig; renderOptions(); });
  }
  function requestClose() {
    if (saving) return;
    if (surfacesWithContent().length && designKey() !== savedKey) { applyDesign(false, true); return; }
    close();
  }

  /* Designen på produktsidans bilder: den aktuella färgens bilder och deras miniatyrer får en komposit.
     Bilderna känns igen på filnamnet, som är samma fil som designern ritar på. Alt-texterna dög inte:
     de skrevs med produktens gamla namn (muggen heter Keramik mugg, bilderna Magisk mugg). Räknas om
     när färgen byts på produktsidan och läggs tillbaka när Dawn byter ut galleriet. */
  var composites = {}; /* bildfilens namn → dataURL */
  function filnyckel(url) {
    return String(url || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z]+$)/i, '').toLowerCase();
  }
  function paintGallery() {
    var applied = 0;
    document.querySelectorAll('.product__media-item img, .thumbnail-list__item img, product-modal img').forEach(function (img) {
      var key = img.dataset.mnFil || filnyckel(img.getAttribute('src') || (img.getAttribute('srcset') || '').split(' ')[0]);
      var url = composites[key];
      if (!url || img.src === url) return;
      img.dataset.mnFil = key;
      img.srcset = ''; img.removeAttribute('sizes'); img.src = url; applied++;
    });
    return applied;
  }
  function refreshGallery() {
    if (!hasDesign()) return;
    tillampaForm();
    sides[placement] = layers;
    if (UV) {
      /* varje kamera som visar någon yta med innehåll får en komposit */
      var views = {};
      surfacesWithContent().forEach(function (sid) { (TY.ytor[sid].vyer || [TY.ytor[sid].vy]).forEach(function (v) { views[v] = 1; }); });
      Object.keys(views).forEach(function (view) {
        var src = viewImage(view);
        Promise.all([loadMock(src), viewMapsReady[view] ? Promise.resolve(viewMapsReady[view]) : (viewMaps(view), viewMapsReady['_' + view])]).then(function (r) {
          var im = r[0]; if (!im) return;
          var url = viewDataUrl(view, im);
          if (url) composites[filnyckel(src)] = url;
          paintGallery();
        });
      });
      return;
    }
    ['front', 'back'].forEach(function (pos) {
      if (pos === 'back' && !(TY && TY.back)) return;
      if (!sideHasContent(pos)) return;
      var a = withSide(pos, area);
      loadMock(a.src).then(function (im) {
        if (!im) return;
        withSide(pos, function () {
          mockImg = im; mockKey = a.src;
          var url = galleryDataUrl();
          if (url) composites[filnyckel(a.src)] = url;
        });
        paintGallery();
      });
    });
  }
  if (typeof window.subscribe === 'function') {
    window.subscribe('variant-change', function () { if (root.hidden) setTimeout(function () { refreshGallery(); uppdateraForhandsbild(); }, 40); });
  }
  var galleryHost = document.querySelector('media-gallery, .product__media-wrapper');
  if (galleryHost && 'MutationObserver' in window) {
    var paintTimer = null;
    new MutationObserver(function () {
      if (!Object.keys(composites).length) return;
      clearTimeout(paintTimer);
      paintTimer = setTimeout(paintGallery, 30);
    }).observe(galleryHost, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  /* Lägg i varukorgen via Ajax-API:t (formuläret med våra properties) och
     öppna varukorgslådan – oberoende av andra appars formulärskript */
  function addToCartNow() {
    var inp = document.querySelector('input[data-bt-teckning]');
    var form = inp && inp.closest('form');
    if (!form) return;
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: qty, properties: {} };
    fd.forEach(function (val, key) { var m = /^properties\[(.+)\]$/.exec(key); if (m && String(val) !== '') item.properties[m[1]] = val; });
    var items = [item];
    /* fler tryckytor → tilläggsraden "Extra tryck" följer med: antal = extra ytor × antal, kopplad via _for */
    var n = extraCount();
    if (!n && item.properties._per) n = Math.max(0, parseInt(item.properties._per, 10) || 0);
    if (n > 0 && EXTRA_VARIANT) items.push({ id: Number(EXTRA_VARIANT), quantity: qty * n, properties: { _for: item.properties._design || String(item.id), _per: String(n), 'Gäller': root.dataset.productTitle || '', 'Ytor': surfacesWithContent().slice(1).map(surfName).join(', ') } });
    /* mall med ändrad rubrik/egen text → tillägget "Egen text på mall", en per plagg, kopplad via _for */
    var mt = malltextCount();
    if (!mt && item.properties._mt === '1' && item.properties._mtv) mt = 1;
    if (mt && (MALLTEXT_VARIANT || item.properties._mtv)) items.push({ id: Number(MALLTEXT_VARIANT || item.properties._mtv), quantity: qty, properties: { _for: item.properties._design || String(item.id), _typ: 'mt', 'Gäller': root.dataset.productTitle || '', 'Mall': mallNamn() } });
    var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    /* ändrad design från varukorgen: den gamla raden tas bort först (tilläggsraden följer efter via mn-cart-tillagg) */
    var pre = EDIT_LINE ? fetch(rootUrl + 'cart/change.js', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ id: EDIT_LINE, quantity: 0 }) }).catch(function () {}).then(function () { EDIT_LINE = null; }) : Promise.resolve();
    return pre.then(function () { return fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'content-type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }); }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status) { alert(d.description || d.message || 'Kunde inte lägga i varukorgen.'); return; }
      /* Uppladdningskortet på sidan säger nu att designen ligger i varukorgen, och sidans köpknapp blir
         "Lägg i en till" (mn-shop.css). Annars sa kortet "välj storlek och lägg i varukorgen" och kunden
         som gjorde som det stod fick två tröjor. */
      document.querySelectorAll('[data-bt-start]').forEach(function (w) { w.classList.add('bt-start--added'); });
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && d.sections) { drawer.renderContents(d); drawer.classList.remove('is-empty'); /* Dawn rensar bara .drawer__inner */ }
      else window.location.href = '/cart';
      q('[data-mnd-cta-label]').textContent = 'Lägg i varukorgen';
    });
  }
  q('[data-mnd-add-to-cart]').addEventListener('click', function () {
    if (needsSize()) { promptSize(); return; }
    applyDesign(true);
  });
  qa('[data-mnd-apply]').forEach(function (b) { if (!b.hasAttribute('data-mnd-add-to-cart')) b.addEventListener('click', function () { applyDesign(false); }); });

  /* ---------- Panelen som ark på mobil: handtag att trycka/dra, auto-expandera vid text ---------- */

  var panel = q('[data-mnd-panel]');
  var grip = q('[data-mnd-grip]');

  /* Lagerverktygen (spegla/dubblera/…) ligger ovanpå produkten på desktop och liggande mobil, men på
     stående mobil flyttas de ner i kikraden så att ingenting täcker designen. Elementet FLYTTAS – då
     följer klicklyssnarna på knapparna med. */
  var mqPhone = window.matchMedia ? window.matchMedia('(max-width: 899px) and (orientation: portrait)') : null;
  /* arket ligger nertill (handtaget syns och lägena styr höjden) på allt under 900 px UTOM den liggande
     delade vyn, där panelen står till höger i full höjd. Ett smalt liggande fönster (t.ex. 800x600) är
     alltså också ett ark – det bandet tappade annars både höjdreglerna och ett fungerande handtag. */
  var mqSheet = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;
  var mqSplit = window.matchMedia ? window.matchMedia('(max-width: 899px) and (orientation: landscape) and (max-height: 520px)') : null;
  function bottomSheet() { return !!(mqSheet && mqSheet.matches) && !(mqSplit && mqSplit.matches); }
  var seltools = q('[data-mnd-seltools]');
  var toolsHome = seltools ? seltools.parentNode : null;         /* .mnd__stage-tools i [data-mnd-stage-top] */
  var toolsNext = seltools ? seltools.nextElementSibling : null; /* zoomknappen – verktygen hör före den */
  function phonePortrait() { return !!(mqPhone && mqPhone.matches); }
  function placeTools() {
    if (!seltools) return;
    var quick = q('[data-mnd-quick]');
    if (phonePortrait() && quick) {
      if (seltools.parentNode !== quick) quick.appendChild(seltools); /* efter chippen, se renderQuick */
    } else if (toolsHome && seltools.parentNode !== toolsHome) {
      toolsHome.insertBefore(seltools, toolsNext || null);
    }
  }

  /* Arket har tre lägen: kik (standard på stående mobil – bara handtag, kikrad och fot), halvt (skriva och
     pilla med lagren) och helt (listorna, t.ex. när tangentbordet är uppe). mnd--sheet-open på roten döljer
     lägesväljaren och bildtexten så fort arket är uppe – scenen är då för kort för dem. Lägena styr höjden
     på allt som har ett handtag (se bottomSheet); desktop och den liggande delade vyn struntar i dem men
     håller klassen i synk. */
  var SHEET_STEPS = ['peek', 'half', 'full'];   /* i stigande höjd – dragets steg räknar på ordningen */
  var sheet = 'peek';
  var peekH = 0;                                /* senast uppmätta kikhöjd (px) – dragets golv */
  /* Kikhöjden är dragets golv och måste vara den RIKTIGA höjden, inte den arket råkade ha innan
       kikraden fylldes. Mäts bara när arket faktiskt står i kik och inget drag äger höjden. */
  function measurePeek() {
    if (sheetDrag || sheet !== 'peek' || !bottomSheet() || root.hidden) return;
    var ph = panel.offsetHeight;
    if (ph > 40) peekH = ph;
  }
  function sheetClass(state) {
    panel.classList.toggle('is-peek', state === 'peek');
    panel.classList.toggle('is-half', state === 'half');
    panel.classList.toggle('is-full', state === 'full');
  }
  function setSheet(state) {
    if (SHEET_STEPS.indexOf(state) < 0) state = 'peek';
    sheet = state;
    sheetClass(state);
    root.classList.toggle('mnd--sheet-open', state !== 'peek');
    if (grip) grip.setAttribute('aria-expanded', state === 'peek' ? 'false' : 'true');
    renderCtx();
    /* kikhöjden mäts varje gång arket står i kik: den beror på kikradens innehåll (lagerverktygen
       dyker upp när ett lager är markerat) och kan inte räknas fram ur CSS:en, som säger height: auto */
    measurePeek();
    setTimeout(function () { fitStage(); scheduleDraw(); }, 300);
  }
  /* tryck/Enter: kik → halvt → helt → kik. Hela varvet, inte bara kik ⇄ halvt: annars går "helt" bara
     att nå med ett drag på handtaget, och spara-länken (som bara visas i helt läge) blir omöjlig att nå
     för den som styr med tangentbord eller bara trycker. */
  function toggleSheet() { setSheet(SHEET_STEPS[(SHEET_STEPS.indexOf(sheet) + 1) % SHEET_STEPS.length]); }

  /* ---------- Draget: arket följer fingret ----------
     Under draget skrivs höjden som inline-höjd på panelen. Lägesklassen ligger kvar, men is-dragging
     stänger av övergången, och taket (max-height) nollas med en inline-stil – kiklägets tak skulle
     annars kapa ett drag uppåt. Vid släpp räknas farten över de sista ~120 ms: en kastning flyttar ett
     steg åt det hållet, ett lugnt släpp snappar till närmaste läge, och ett tryck (arket rörde sig
     inte) fäller ut/in som förut. Scenen ritas om via requestAnimationFrame och bara när höjden rört
     sig mer än 24 px sedan sist – UV-kompositeringen hinner inte med varje pointermove på en telefon. */
  var TAP_MOVE = 6;                 /* px: mindre rörelse än så är ett tryck, inte ett drag */
  var FLICK_V = 0.5;                /* px/ms – snabbare än så räknas som en kastning */
  var FLICK_MS = 120;               /* farten mäts över de sista så många millisekunderna */
  var DRAW_STEP = 24;               /* px: så mycket måste höjden ändras innan scenen ritas om */
  var PEEK_FALLBACK = 160;          /* 16rem om kikhöjden inte hunnit mätas */
  function nowMs() { return (window.performance && window.performance.now) ? window.performance.now() : Date.now(); }
  /* Arkets drag heter sheetDrag och släppet endSheetDrag. De hette förut drag och endDrag, samma namn som
     scenens drag längre upp i samma funktion: var-deklarationen delades och den senare endDrag ersatte
     scenens. Scenens pointerup kom då aldrig fram, fingret blev kvar i pointers och nästa drag på en
     pekskärm blev en nypning mot en punkt som inte längre fanns. */
  var sheetDrag = null;             /* pågående drag: { id, y0, h0, h, hs, hist … } */
  /* inline-höjden och dragklasserna bort: används när arket byter layout (vändning, stängning) */
  function resetSheetDrag() {
    sheetDrag = null;
    panel.classList.remove('is-dragging', 'is-shut');
    panel.style.height = panel.style.maxHeight = '';
  }
  /* Lägenas höjder mäts i DOM:en, så att CSS:en förblir sanningen om procenten. Kikläget sätts
     aldrig på bara för att mätas: is-peek döljer rullytan med display:none, och då nollställs
     dess rullposition. Det läget kommer i stället från mätningen i setSheet. */
  function sheetHeights() {
    var cur = sheet, out = {}, i, s;
    panel.style.height = '';
    out[cur] = panel.offsetHeight;
    for (i = 0; i < SHEET_STEPS.length; i++) {
      s = SHEET_STEPS[i];
      if (s === cur || s === 'peek') continue;
      sheetClass(s);
      out[s] = panel.offsetHeight;
    }
    sheetClass(cur);
    if (cur === 'peek' && out.peek > 40) peekH = out.peek;
    if (!out.peek) out.peek = peekH || PEEK_FALLBACK;
    /* Utfällt ark har ett eget golv: med flikar och rullyta framme går det inte att krympa under sitt
       min-content (arket hade stannat där och slutat följa fingret). Under den höjden fälls innehållet
       ihop i stället – is-shut – och arket når hela vägen ner till kikhöjden. */
    var wasShut = panel.classList.contains('is-shut');
    panel.classList.remove('is-shut');
    panel.style.height = '0px';
    out.openMin = panel.offsetHeight;
    panel.style.height = '';
    panel.classList.toggle('is-shut', wasShut);
    return out;
  }
  function nearestSheet(h, hs) {
    var best = SHEET_STEPS[0], bd = Infinity, i, d;
    for (i = 0; i < SHEET_STEPS.length; i++) {
      d = Math.abs(hs[SHEET_STEPS[i]] - h);
      if (d < bd) { bd = d; best = SHEET_STEPS[i]; }
    }
    return best;
  }
  /* ett steg i kastningens riktning: närmaste läge ovanför (dir 1) eller under (dir -1) släpphöjden */
  function stepSheetFrom(h, dir, hs) {
    var i;
    if (dir > 0) {
      for (i = 0; i < SHEET_STEPS.length; i++) { if (hs[SHEET_STEPS[i]] > h + 1) return SHEET_STEPS[i]; }
      return SHEET_STEPS[SHEET_STEPS.length - 1];
    }
    for (i = SHEET_STEPS.length - 1; i >= 0; i--) { if (hs[SHEET_STEPS[i]] < h - 1) return SHEET_STEPS[i]; }
    return SHEET_STEPS[0];
  }
  /* px/ms över de sista ~120 ms; positivt = fingret rör sig nedåt (arket krymper) */
  function flickVelocity(hist) {
    var last = hist[hist.length - 1], old = hist[0], i, dt;
    for (i = hist.length - 1; i >= 0; i--) { old = hist[i]; if (last[0] - old[0] >= FLICK_MS) break; }
    dt = last[0] - old[0];
    return dt < 8 ? 0 : (last[1] - old[1]) / dt;
  }
  function dragFrame() {
    if (!sheetDrag) return;
    sheetDrag.raf = 0;
    if (Math.abs(sheetDrag.h - sheetDrag.drawn) < DRAW_STEP) return;
    sheetDrag.drawn = sheetDrag.h;
    fitStage(); scheduleDraw();
  }
  /* Arket växer under fingret när det fälls ut, och telefonens klick efter trycket landar då på det som
     nu ligger där – oftast "Lägg till text", som skapade en tom text. Nästa klick inom en kort stund äts upp. */
  function swallowClick() {
    var nu = nowMs();
    var ata = function (ev) { document.removeEventListener('click', ata, true); if (nowMs() - nu < 600) { ev.preventDefault(); ev.stopPropagation(); } };
    document.addEventListener('click', ata, true);
    setTimeout(function () { document.removeEventListener('click', ata, true); }, 650);
  }
  function endSheetDrag(e, cancelled) {
    if (!sheetDrag) return;
    var d = sheetDrag, t = nowMs(), v, target;
    if (d.raf) cancelAnimationFrame(d.raf);
    try { grip.releasePointerCapture(d.id); } catch (err) {}
    resetSheetDrag();
    if (e && !cancelled && e.clientY != null) d.hist.push([t, e.clientY]);
    /* tryck: samma varv som förut (kik → halvt → helt → kik). Också ett sävligt tryck räknas –
       det som skiljer ett tryck från ett drag är att arket inte rörde sig, inte hur länge fingret
       låg kvar, och närmaste läge vore ändå det man redan står i. */
    if (!cancelled && d.moved < TAP_MOVE) { swallowClick(); toggleSheet(); return; }
    v = cancelled ? 0 : flickVelocity(d.hist);
    if (v < -FLICK_V) target = stepSheetFrom(d.h, 1, d.hs);
    else if (v > FLICK_V) target = stepSheetFrom(d.h, -1, d.hs);
    else target = nearestSheet(d.h, d.hs);
    setSheet(target);
    fitStage(); scheduleDraw();
  }
  if (grip) {
    grip.addEventListener('pointerdown', function (e) {
      /* bara när panelen är ett ark: i den liggande delade vyn och på desktop är handtaget dolt och
         panelen ska aldrig få någon inline-höjd */
      if (sheetDrag || !bottomSheet()) return;
      /* is-dragging först, sedan mätningen: utan den stänger inte övergången av, och offsetHeight
         svarar med höjden övergången råkar stå på (t.ex. 88 % när man just bytt till halvt läge).
         is-shut sätts direkt i kikläget, annars skulle flikarna blinka förbi vid ett tryck. */
      panel.classList.add('is-dragging');
      panel.classList.toggle('is-shut', sheet === 'peek');
      var hs = sheetHeights(), h0 = hs[sheet], t = nowMs();
      if (!h0) { panel.classList.remove('is-dragging', 'is-shut'); return; }
      panel.classList.toggle('is-shut', h0 < hs.openMin);
      /* taket bort först NU: lägenas höjder mättes med det kvar (i ett brett liggande fönster är
         kikläget höjden CSS:en kapar till, inte innehållets egen) – annars hoppar arket vid greppet */
      panel.style.maxHeight = 'none';
      var bodyH = (panel.parentNode ? panel.parentNode.getBoundingClientRect().height : 0) || h0;
      sheetDrag = {
        id: e.pointerId, y0: e.clientY, hs: hs, hist: [[t, e.clientY]],
        h0: h0, h: h0, drawn: h0, moved: 0, raf: 0,
        min: Math.min(hs.peek, h0),                                     /* kikhöjden */
        max: Math.max(h0, hs.full || 0, Math.round(bodyH * 0.88))       /* 88 % av editorns kropp */
      };
      try { grip.setPointerCapture(e.pointerId); } catch (err) {}
    });
    grip.addEventListener('pointermove', function (e) {
      if (!sheetDrag || e.pointerId !== sheetDrag.id) return;
      var dy = e.clientY - sheetDrag.y0, h = sheetDrag.h0 - dy;
      if (h < sheetDrag.min) h = sheetDrag.min; else if (h > sheetDrag.max) h = sheetDrag.max;
      sheetDrag.h = h;
      sheetDrag.moved = Math.max(sheetDrag.moved, Math.abs(dy));
      /* hopfällt utseende under det utfällda arkets golv, annars flikar och rullyta */
      panel.classList.toggle('is-shut', h < sheetDrag.hs.openMin);
      panel.style.height = Math.round(h) + 'px';
      sheetDrag.hist.push([nowMs(), e.clientY]);
      if (sheetDrag.hist.length > 16) sheetDrag.hist.shift();
      if (!sheetDrag.raf) sheetDrag.raf = requestAnimationFrame(dragFrame);
    });
    grip.addEventListener('pointerup', function (e) { endSheetDrag(e, false); });
    grip.addEventListener('pointercancel', function (e) { endSheetDrag(e, true); });
    /* tangentbord: Enter/mellanslag på handtaget fäller ut/in (pekarhändelserna ovan hör bara mus/finger) */
    grip.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault(); toggleSheet();
    });
  }
  /* textfält → helt ark (tangentbordet är uppe och scenen ändå oanvändbar); flik → minst halvt; peka på scenen → kik */
  /* fälten i panelen fäller ut den helt – men inte fältet direkt på plagget (.mnd__inline), då ska plagget synas */
  root.addEventListener('focusin', function (e) { if (e.target && e.target.tagName === 'TEXTAREA' && !e.target.classList.contains('mnd__inline') && stageW < 900) setSheet('full'); });
  qa('[data-mnd-tab]').forEach(function (t) { t.addEventListener('click', function () { if (stageW < 900 && sheet === 'peek') setSheet('half'); }); });
  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('button, .mnd__stage-top, .mnd__modebar')) return;
    if (sheet !== 'peek') { setSheet('peek'); if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); }
  });

  /* ---------- Öppna / stäng ---------- */

  var lastFocus = null;
  var vv = window.visualViewport, fullHojd = 0;   /* synliga ytans höjd utan tangentbord */
  function fitToViewport() {
    if (root.hidden || !vv) return;
    root.style.height = Math.round(vv.height) + 'px';
    root.style.top = Math.round(vv.offsetTop) + 'px';
    /* tangentbordet uppe medan man skriver på plagget (mobil): den synliga ytan är bara en tredjedel av
       skärmen. Då döljs allt utom plagget och textraden, annars blev plagget ett frimärke mellan knapparna. */
    if (!inlineId) fullHojd = Math.max(fullHojd, vv.height); else if (!fullHojd) fullHojd = window.innerHeight;
    var tb = !!(inlineId && bottomSheet() && vv.height < fullHojd * 0.75);
    if (root.classList.contains('mnd--tangentbord') !== tb) { root.classList.toggle('mnd--tangentbord', tb); measurePeek(); }
    fitStage(); scheduleDraw();
  }
  function setInert(on) {
    Array.prototype.forEach.call(document.body.children, function (el) { if (el !== root && 'inert' in el) el.inert = on; });
  }
  /* De färdiga trycken läggs in som låsta bildlager på sina ytor (en gång per öppning om de saknas).
     Läget räknas som i admin-vyn: x/y = mittpunkt i andel av ytan, scale = bredd i andel av ytans bredd. */
  var fardigaLaddas = false;
  function laddaFardiga() {
    if (!FARDIG.length || fardigaLaddas) return;
    var saknas = FARDIG.filter(function (f) { return sides[f.placering] && !sides[f.placering].some(function (l) { return l.fast && l.fardig === f.url + '|' + f.placering; }); });
    if (!saknas.length) return;
    fardigaLaddas = true;
    Promise.all(saknas.map(function (f) {
      return fetch(f.url, { mode: 'cors' }).then(function (r) { return r.blob(); }).then(blobToImage).then(function (r) {
        return makeVersion(r.img, false, false).then(function (paper) { URL.revokeObjectURL(r.url); return { f: f, versions: { paper: paper, clean: null } }; });
      }).catch(function (e) { console.warn('[Minnely-designern] färdigt tryck', e); return null; });
    })).then(function (list) {
      list.filter(Boolean).forEach(function (it) {
        var f = it.f, v = it.versions, id = 'f' + (++uid);
        assets[id] = { versions: v };
        withSide(f.placering, function () {
          var rad = (Number(f.angle) || 0) * Math.PI / 180;
          sides[f.placering].unshift({ id: id, type: 'image', name: f.namn || 'Tryck', fast: true, fardig: f.url + '|' + f.placering, bg: true, flip: false,
            x: R_W * Number(f.x), y: areaH() * Number(f.y), w: R_W * Number(f.scale), ar: v.paper.ar, rot: rad, versions: v });
        });
      });
      layers = sides[placement]; fardigaLaddas = false;
      renderPanels(); renderSides(); draw();
    });
  }
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('mnd-open');
    document.documentElement.classList.add('mnd-open');
    setInert(true);
    var plac = document.querySelector('input[data-bt-placering]');
    tillampaForm();
    if (!UV) setPlacement(plac && plac.value === 'Rygg' && TY && TY.back ? 'back' : 'front', true);
    else { var firstWith = surfacesWithContent()[0]; if (firstWith) setPlacement(firstWith, true); Object.keys(TY.vyer).forEach(function (v) { viewMaps(v); }); }
    layers = sides[placement];
    FONTS.forEach(function (f) { loadFont(f[0]); });
    libAll().then(function (all) { libItems = all.slice(0, LIB_MAX); renderLibrary(); });
    if (BRODYR) {
      qa('[data-mnd-pick]').forEach(function (b) { if (!b.closest('[data-mnd-empty]')) b.hidden = true; });
      var tabBild = q('[data-mnd-tab="bild"]'); if (tabBild) tabBild.hidden = true;
      stage.addEventListener('drop', function (e) { e.stopImmediatePropagation(); }, true);
      showTab('text');
    }
    var pq = pageQtyInput();
    if (pq && Number(pq.value) >= 1) { qty = Math.min(99, Math.round(Number(pq.value))); qtyInput.value = qty; }
    if (EDIT_LINE) q('[data-mnd-cta-label]').textContent = 'Uppdatera varukorgen';
    if (vv) { vv.addEventListener('resize', fitToViewport); vv.addEventListener('scroll', fitToViewport); }
    placeTools();
    setSheet(bottomSheet() ? 'peek' : 'full');
    requestAnimationFrame(function () { fitStage(); renderPanels(); draw(); q('[data-mnd-close]').focus({ preventScroll: true }); });
    /* tom editor: filväljaren direkt – utom när kunden valde att skriva en text (data-bt-text) */
    if (!layers.length && !BRODYR && !textStart && !FARDIG.length) setTimeout(function () { fileInput.click(); }, 250);
    laddaFardiga();
    if (!layers.length && BRODYR && !textStart) setTimeout(function () { if (bottomSheet()) { if (!layers.length) quickAddText(); return; } var b = q('[data-mnd-pane="text"] [data-mnd-add-text]'); if (b) b.click(); }, 250);
  }
  function close() {
    closeMenu(null);
    sheet = 'peek';
    resetSheetDrag();
    if (panel) panel.classList.remove('is-peek', 'is-half', 'is-full');
    root.classList.remove('mnd--sheet-open');
    if (grip) grip.setAttribute('aria-expanded', 'false');
    root.hidden = true;
    root.style.height = root.style.top = '';
    document.body.classList.remove('mnd-open');
    document.documentElement.classList.remove('mnd-open');
    setInert(false);
    if (vv) { vv.removeEventListener('resize', fitToViewport); vv.removeEventListener('scroll', fitToViewport); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  q('[data-mnd-close]').addEventListener('click', requestClose);
  window.addEventListener('resize', function () { if (!root.hidden) { placeTools(); fitStage(); scheduleDraw(); } });
  var onLayoutChange = function () {
    closeMenu(null);
    /* ett pågående drag hör inte hemma i den nya layouten – inline-höjden bort innan lägena sätts om */
    resetSheetDrag();
    placeTools();
    if (!root.hidden) { setSheet(bottomSheet() ? 'peek' : 'full'); fitStage(); scheduleDraw(); }
  };
  [mqPhone, mqSheet, mqSplit].forEach(function (mq) {
    if (!mq) return;
    if (mq.addEventListener) mq.addEventListener('change', onLayoutChange);
    else if (mq.addListener) mq.addListener(onLayoutChange);
  });
  /* fokusfälla: Tab stannar i editorn – och, när inställningsmenyn är öppen, i menyn. Menyn är
     modal (slöjan täcker resten och en klick där stänger), så utan den snävare ramen kan man
     tabba ut till knappar man inte kan se eller peka på – i värsta fall till Stäng designern. */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var scope = fvEl && !fvEl.hidden ? fvEl : (menuFor && menuEl ? menuEl : root);
    var items = qa('button:not([disabled]), input:not([hidden]):not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])', scope).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-bt-upload]');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);
  /* "Eller skriv en text" på produktsidan: designern öppnas direkt med ett nytt textlager i redigering */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-bt-text]');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    textStart = true; open(); textStart = false;
    setTimeout(quickAddText, 300);
  }, true);
  /* Lägg i varukorgen / snabbköp utan design → öppna designern */
  function hasDesign() { var i = document.querySelector('input[data-bt-teckning]'); return !!(i && i.value); }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector || !form.querySelector('input[data-bt-teckning]')) return;
    /* Designad med fler ytor (t.ex. ärmen): sidans egen köpknapp lade bara tröjan i varukorgen och
       tilläggsraden "Extra tryck" (79 kr) föll bort – den läggs bara till härifrån. Därför går köpet
       genom samma väg som designerns knapp, med sidans antal. */
    var per = form.querySelector('input[data-mnd-prop="_per"]'), mtIn = form.querySelector('input[data-mnd-prop="_mt"]');
    if (hasDesign() && ((per && Number(per.value) > 0 && EXTRA_VARIANT) || (mtIn && mtIn.value === '1' && MALLTEXT_VARIANT))) {
      e.preventDefault(); e.stopImmediatePropagation();
      var pq = pageQtyInput(); if (pq && Number(pq.value) >= 1) { qty = Math.min(99, Math.round(Number(pq.value))); qtyInput.value = qty; }
      addToCartNow();
      return;
    }
    if (hasDesign() || FARDIG.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);
  /* "Ändra design" från varukorgen: ?design=<id>&line=<nyckel> → återställ och öppna direkt */
  /* Mallar: knappen på produktsidan ("Välj en julmall") och direktlänken ?mall=<id> från t.ex. kategorin */
  if (mallar().length) {
    /* säsongens grupp i knappen ("Välj en julmall"), annars en neutral text */
    var grupp0 = mallar()[0]._sasong ? mallar()[0].grupp : '';
    document.querySelectorAll('[data-bt-mall]').forEach(function (b) {
      b.hidden = false;
      var lab = b.querySelector('[data-bt-mall-label]'); if (lab) lab.textContent = grupp0 ? 'Välj en ' + grupp0.toLowerCase() + 'mall' : 'Välj en färdig mall';
    });
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-bt-mall]'); if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      textStart = true; open(); textStart = false;
      setTimeout(visaMallar, 250);
    }, true);
    var mallParam = PARAMS.get('mall');
    if (mallParam && !DESIGN_ID) {
      var mStart = mallar().filter(function (x) { return x.id === mallParam; })[0];
      if (mStart) { textStart = true; open(); textStart = false; setTimeout(function () { anvandMall(mStart); }, 300); }
    }
  }
  if (DESIGN_ID) {
    restoreDesign(DESIGN_ID).then(function (ok) {
      if (!ok) { DESIGN_ID = null; EDIT_LINE = null; return; }
      var rm = PARAMS.get('remove'); if (rm && sides[rm]) { sides[rm] = []; }
      /* raden i varukorgen är sanningen: ytor som tagits bort där ska inte komma tillbaka */
      var lineState = EDIT_LINE ? fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var it = (cart.items || []).find(function (x) { return x.key === EDIT_LINE; });
        if (!it) { EDIT_LINE = null; return; }
        if (it.quantity) { qty = Math.min(99, it.quantity); qtyInput.value = qty; }
        var ytor = []; try { ytor = JSON.parse(it.properties._ytor || '[]'); } catch (e) { ytor = []; }
        if (ytor.length) { var keep = {}; ytor.forEach(function (y) { keep[y.id] = 1; }); SURF.forEach(function (sid) { if (!keep[sid]) sides[sid] = []; }); }
      }).catch(function () {}) : Promise.resolve();
      lineState.then(function () {
        if (!sideHasContent(placement)) { var f = surfacesWithContent()[0]; if (f) placement = f; }
        layers = sides[placement];
        if (EDIT_LINE) sizePicked = true;
        savedKey = designKey();
        open();
      });
    });
  }
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest && e.target.closest('.bt-klarna-btn, .shopify-payment-button__button');
    if (!k || hasDesign()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);

  /* Firefox fyller i de dolda fälten igen vid omladdning, och andra webbläsare vid bakåt utan bfcache.
     Resten av designen (_design, förhandsbilden, kortets bild och klarläge) finns då inte, och sidan
     skulle visa "Ladda upp en bild först" på en knapp som ändå lägger i en ofullständig rad. Fälten
     sätts därför tillbaka till sina startvärden: sidan börjar alltid utan design. */
  qa('input[data-bt-teckning], input[data-bt-teckning-rygg], input[data-bt-layout], input[data-bt-placering], input[data-bt-text]', document).forEach(function (i) {
    if (i.value !== i.defaultValue) i.value = i.defaultValue;
  });

  /* ---------- Förhandsvisa: produkten precis som den blir ----------
     I redigeringsvyn syns alltid markeringsramen, handtagen, tryckytans streckade kant och tipsraden.
     Den som vill se resultatet ser dem också, och kan inte skilja dem från själva trycket. Här ritas
     produkten ren, en bild per sida som har innehåll, med samma komposition som galleriet och
     varukorgen använder. Vyn täcker hela designern, så inget bakom den går att råka röra. */
  var fvEl = null, fvFokusFore = null, fvBilder = [], fvIndex = 0, fvGen = 0;
  var FV_STANG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function fvBygg() {
    if (fvEl) return fvEl;
    fvEl = document.createElement('div');
    fvEl.className = 'mnd__fv';
    fvEl.hidden = true;
    fvEl.setAttribute('role', 'dialog');
    fvEl.setAttribute('aria-modal', 'true');
    fvEl.setAttribute('aria-labelledby', 'mnd-fv-rubrik');
    fvEl.innerHTML =
      '<div class="mnd__fv-kort">' +
        '<div class="mnd__fv-topp">' +
          '<h2 class="mnd__fv-rubrik" id="mnd-fv-rubrik" data-mnd-fv-rubrik></h2>' +
          '<button type="button" class="mnd__fv-stang" data-mnd-fv-stang aria-label="' + esc(TXT_FV_TILLBAKA) + '">' + FV_STANG_SVG + '</button>' +
        '</div>' +
        '<div class="mnd__fv-flikar" data-mnd-fv-flikar role="tablist" hidden></div>' +
        '<div class="mnd__fv-scen">' +
          '<img class="mnd__fv-bild" data-mnd-fv-bild alt="" hidden>' +
          '<p class="mnd__fv-status" data-mnd-fv-status role="status" aria-live="polite"></p>' +
        '</div>' +
        '<p class="mnd__fv-info" data-mnd-fv-info></p>' +
        '<div class="mnd__fv-knappar">' +
          '<button type="button" class="mnd__fv-tillbaka" data-mnd-fv-stang>' + esc(TXT_FV_TILLBAKA) + '</button>' +
          '<button type="button" class="mnd__fv-kop" data-mnd-fv-kop></button>' +
        '</div>' +
      '</div>';
    root.appendChild(fvEl);
    fvEl.addEventListener('click', function (e) {
      if (e.target === fvEl || e.target.closest('[data-mnd-fv-stang]')) { fvStang(); return; }
      if (e.target.closest('[data-mnd-fv-kop]')) {
        /* samma köpknapp som i designern, så att storleksvalet och sparandet fungerar exakt likadant */
        fvStang();
        var kop = q('[data-mnd-add-to-cart]');
        if (kop && !kop.disabled) kop.click();
        return;
      }
      var flik = e.target.closest('[data-mnd-fv-flik]');
      if (flik) fvVisaIndex(Number(flik.dataset.mndFvFlik));
    });
    return fvEl;
  }

  function fvStatus(text) {
    var st = fvEl.querySelector('[data-mnd-fv-status]');
    st.textContent = text || '';
    st.hidden = !text;
  }

  /* en ren bild per sida med innehåll: kamerorna för UV-produkter, fram och rygg för de äldre */
  function fvRendera() {
    sides[placement] = layers;
    var jobb = [];
    if (UV) {
      var namnFor = {}, ordning = [];
      surfacesWithContent().forEach(function (sid) {
        var y = TY.ytor[sid], v = (y.vyer || [y.vy])[0];
        if (!namnFor[v]) { namnFor[v] = surfName(sid); ordning.push(v); }
      });
      ordning.forEach(function (view) {
        /* kartan måste vara laddad, annars blir kompositionen tom: kunden kan ha arbetat i den platta vyn */
        var kartor = viewMapsReady[view] ? Promise.resolve(viewMapsReady[view]) : (viewMaps(view), viewMapsReady['_' + view] || Promise.resolve(null));
        jobb.push(Promise.all([loadMock(viewImage(view)), kartor]).then(function (r) {
          return { namn: namnFor[view], url: r[0] ? viewDataUrl(view, r[0], 1400) : null };
        }));
      });
    } else if (TY) {
      ['front', 'back'].forEach(function (pos) {
        if (pos === 'back' && !TY.back) return;
        if (!sideHasContent(pos)) return;
        var a = withSide(pos, area);
        jobb.push(loadMock(a.src).then(function (im) {
          if (!im) return { namn: surfName(pos), url: null };
          var url = withSide(pos, function () {
            var pm = mockImg, pk = mockKey; mockImg = im; mockKey = a.src;
            var u = galleryDataUrl(1400);
            mockImg = pm; mockKey = pk;
            return u;
          });
          return { namn: surfName(pos), url: url };
        }));
      });
    }
    return Promise.all(jobb);
  }

  function fvFlikar() {
    var host = fvEl.querySelector('[data-mnd-fv-flikar]');
    host.hidden = fvBilder.length < 2;
    host.innerHTML = fvBilder.length < 2 ? '' : fvBilder.map(function (b, i) {
      return '<button type="button" role="tab" data-mnd-fv-flik="' + i + '" aria-selected="false">' + esc(b.namn) + '</button>';
    }).join('');
  }

  function fvVisaIndex(i) {
    if (!fvBilder.length) return;
    fvIndex = (i + fvBilder.length) % fvBilder.length;
    var b = fvBilder[fvIndex];
    var img = fvEl.querySelector('[data-mnd-fv-bild]');
    img.src = b.url;
    img.alt = (root.dataset.productTitle || '') + ', ' + b.namn.toLowerCase() + ', med din design';
    img.hidden = false;
    qa('[data-mnd-fv-flik]', fvEl).forEach(function (f) {
      var aktiv = Number(f.dataset.mndFvFlik) === fvIndex;
      f.setAttribute('aria-selected', aktiv ? 'true' : 'false');
      f.classList.toggle('is-on', aktiv);
    });
  }

  function fvOppna() {
    if (!surfacesWithContent().length) return;
    var d = fvBygg();
    var gen = ++fvGen;
    fvFokusFore = document.activeElement;
    fvBilder = []; fvIndex = 0;
    d.querySelector('[data-mnd-fv-rubrik]').textContent = TXT_FV_RUBRIK.replace('[produkt]', (root.dataset.productTitle || '').toLowerCase());
    /* färg, storlek och pris, så att kunden ser allt hon beställer på ett ställe */
    var val = selectedValues().filter(function (v) { return v && v !== TXT_SIZE_PROMPT; });
    var pris = ((q('[data-mnd-price]') || {}).textContent || '').trim();
    d.querySelector('[data-mnd-fv-info]').textContent = val.concat(pris ? [pris] : []).join(' · ');
    /* köpknappen säger samma sak som designerns, till exempel Välj storlek när storleken saknas */
    var etikett = ((q('[data-mnd-cta-label]') || {}).textContent || '').trim();
    d.querySelector('[data-mnd-fv-kop]').textContent = etikett || 'Lägg i varukorgen';
    d.querySelector('[data-mnd-fv-bild]').hidden = true;
    d.querySelector('[data-mnd-fv-flikar]').hidden = true;
    fvStatus(TXT_FV_LADDAR);
    d.hidden = false;
    root.classList.add('mnd--fv-oppen');
    d.querySelector('.mnd__fv-stang').focus({ preventScroll: true });
    fvRendera().then(function (r) {
      if (gen !== fvGen || d.hidden) return;
      fvBilder = (r || []).filter(function (x) { return x && x.url; });
      if (!fvBilder.length) {
        fvStatus(TXT_FV_FEL);
        if (window.console) console.warn('[Minnely-designern] förhandsvisningen kunde inte ritas', r);
        return;
      }
      fvStatus('');
      fvFlikar();
      fvVisaIndex(0);
    }).catch(function (err) {
      if (gen !== fvGen) return;
      fvStatus(TXT_FV_FEL);
      if (window.console) console.warn('[Minnely-designern] förhandsvisningen kunde inte ritas', err);
    });
  }

  function fvStang() {
    if (!fvEl || fvEl.hidden) return;
    fvGen++;
    fvEl.hidden = true;
    root.classList.remove('mnd--fv-oppen');
    var tillbaka = fvFokusFore && document.contains(fvFokusFore) ? fvFokusFore : q('[data-mnd-forhandsvisa]');
    if (tillbaka) tillbaka.focus({ preventScroll: true });
  }

  var fvKnappen = q('[data-mnd-forhandsvisa]');
  if (fvKnappen) fvKnappen.addEventListener('click', fvOppna);

  /* Tangenterna hör till förhandsvisningen medan den är öppen. Esc stänger den och inte hela
     designern, och pilarna bläddrar mellan sidorna i stället för att flytta bilden bakom vyn.
     Lyssnaren fångar i capture-fasen så att den hinner före designerns egen tangenthantering. */
  document.addEventListener('keydown', function (e) {
    if (!fvEl || fvEl.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); fvStang(); return; }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault(); e.stopPropagation();
      if (fvBilder.length > 1) fvVisaIndex(fvIndex + (e.key === 'ArrowRight' ? 1 : -1));
      return;
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Delete' || e.key === 'Backspace' ||
        ((e.metaKey || e.ctrlKey) && String(e.key).toLowerCase() === 'z')) {
      e.preventDefault(); e.stopPropagation();
    }
  }, true);

  window.MinnelyDesigner = { open: open, close: close };
})();
